/// <reference path="../typings/index.d.ts" />
/// <reference path="AutoDme.d.ts" />

namespace App {
  export class AutoDme implements IAutoDme {
    private static dmesDetailFetchDone = false;
    /** Evita vários GET em paralelo ao abrir vários modais antes da 1.ª resposta. */
    private static dmesCatalogDetailRequest: any | null = null;

    private idExtensao: string = null;
    private exibirLog: any = null;
    private categoriaDmes: ICategoriaDme[] = [];
    private dmeIdInicial: number = 1;
    private dmeAtual: number = null;
    public resolvendo: boolean = false;
    // Elementos via jQuery
    private elModoDme: JQuery = $('#modoDme');
    private elSelectCategory: JQuery = $('#modoDme').find('#select-category');
    private elSelectDme: JQuery = $('#modoDme').find('#select-dme');
    private elTitle: JQuery = $('#dme-title');
    private elSubtitle: JQuery = $('#dme-subtitle');
    private elRepeatable: JQuery = $('#dme-repeatable');
    private elRemaining: JQuery = $('#dme-remaining');
    private elCost: JQuery = $('#dme-cost');
    private elImg: JQuery = $('#dme-image');
    private elStatus: JQuery = $('#resolver-status');
    private elBtnResolver: JQuery = $('#btn-resolver');
    private elBtnCancelarSolucao: JQuery = $('#btn-cancelar-solucao');
    private elBtnScanearClube: JQuery = $('.botao-escanear-itens-clube-auto-dme');
    private elTipoSolucao: JQuery = $('#modoDme').find('#tipoSolucao');

    // ------------ Persistência ------------
    private storageNS = 'autoDme:v2';
    private lastCategoryId: string = '';
    private lastDmeId: string = '';
    private lastTipoSolucao: number = 1;
    // NAO inclua aqui campo que virou valor fixo: o restore do localStorage sobrescreveria o
    // input hidden com um valor antigo. Sairam em 15/08/2026: rigorSolucao,
    // tempoMaximoResolucaoMinutos, tentar_ate_limite_antes_de_pular, exigir_todos_desafios_viaveis,
    // executar_somente_quando_dme_anteriores_finalizados e escanear_clube_apos_falhas. As duas
    // configs de scan do clube migraram para o perfil da conta.
    private persistentFieldIds: string[] = [
      'tipoSolucao',
      'forcarNovaSolucao',
      'repetir', 'repetirIntervaloMinutos', 'limite_solucoes_diarias', 'limites_solucoes_por_forragens', 'limite_tentativas_dia', 'minimoRating', 'maximoRating', 'maximo_rating_carta_especial',
      'precoMaximoDesafio', 'precoMaximoJogadorNegociavel', 'precoMaximoJogadorInegociavel',
      'excluirNegociaveis', 'excluirEspeciais',
      'abrirPacksInegociaveisAutomaticamente', 'abrirPacksNegociaveisAutomaticamente', 'enviarAutomaticamente',
      'comprarJogadorAutomaticamente',
      'excludeAtivoNoElenco', 'excludeLeagues', 'excludeNations', 'excludeTeams', 'excludeRarity', 'excludeRating', 'excludePlayers',
      'incluir_exigencias_dme_em_exclusoes_inteligentes',
      'dmeBase',
      'dimensoes_exclusoes_inteligentes',
      'ignorar_exclusoes_para_carta_especial',
      'tentarSolucaoExternaSeNaoEncontrarInterna',
      'usarSomenteJogadoresClube'
    ];

    private static readonly EXCLUDE_MULTISELECT_IDS = ['excludeLeagues', 'excludeNations', 'excludeTeams', 'excludeRarity', 'excludeRating', 'excludePlayers'];

    /** Limites máximos dos sliders (UI + payload) */
    // MAX_TEMPO_RESOLUCAO_MIN removido em 15/08/2026: o tempo virou fixo (TEMPO_RESOLUCAO_FIXO_MIN).
    private static readonly MIN_REPETIR_DME = 1;
    private static readonly MAX_REPETIR_DME = 30;
    private static readonly MAX_INTERVALO_REPETIR_MIN = 5;
    private static readonly MIN_LIMITE_SOLUCOES_DIARIAS = 1;
    private static readonly MAX_LIMITE_SOLUCOES_DIARIAS = 100;
    private static readonly MAX_FORRAGENS_CLUBE_POR_SOLUCAO = 10000;
    private static readonly MAX_LIMITE_FORRAGENS_ABAIXO_DE = 10000;
    private static readonly MIN_LIMITE_TENTATIVAS_DIA = 1;
    private static readonly MAX_LIMITE_TENTATIVAS_DIA = 100;
    private static readonly DEFAULT_LIMITE_TENTATIVAS_DIA = 10;
    /**
     * Valores FIXOS desde 15/08/2026: sairam do formulario do registro. Os limites de scan do
     * clube (diario e intervalo minimo) migraram para o PERFIL da conta e por isso nao tem mais
     * constante aqui — o servidor injeta os dois no payload.
     */
    private static readonly ESCANEAR_CLUBE_APOS_FALHAS_FIXO = 0;
    private static readonly TEMPO_RESOLUCAO_FIXO_MIN = 3;
    private static readonly RIGOR_SOLUCAO_FIXO = 1;
    private static readonly MIN_PRECO_JOGADOR = 150;
    private static readonly MAX_PRECO_JOGADOR = 15000000;
    // Defaults alinhados ao molde do servidor (AutodmeDefaultConfigService::defaultConfigForSbc)
    // em 15/08/2026: registro novo nasce com os tetos no maximo.
    private static readonly DEFAULT_PRECO_JOGADOR_NEGOCIAVEL = 15000000;
    private static readonly DEFAULT_PRECO_JOGADOR_INEGOCIAVEL = 15000000;
    private static readonly MAX_GASTO_DME = 500000;
    private static readonly DEFAULT_GASTO_DME = 500000;
    private static readonly PRECO_JOGADOR_LINKS_EXTERNOS = 500000;
    private static readonly PRECO_JOGADOR_TIERS = [
      { min: 100000, inc: 1000 },
      { min: 50000, inc: 500 },
      { min: 10000, inc: 250 },
      { min: 1000, inc: 100 },
      { min: 150, inc: 50 },
      { min: 0, inc: 150 },
    ];

    private static incrementoPrecoJogador(valor: number): number {
      const tier = AutoDme.PRECO_JOGADOR_TIERS.find(item => valor >= item.min);
      return tier ? tier.inc : 150;
    }

    private static normalizarPrecoJogador(raw: any, fallback: number): number {
      const n = parseInt(String(raw != null && raw !== '' ? raw : fallback), 10);
      if (!Number.isFinite(n) || n < 0) return fallback;
      const clamped = Math.min(AutoDme.MAX_PRECO_JOGADOR, Math.max(AutoDme.MIN_PRECO_JOGADOR, n));
      const incremento = AutoDme.incrementoPrecoJogador(clamped);
      const ajustado = Math.round(clamped / incremento) * incremento;
      return Math.min(
        AutoDme.MAX_PRECO_JOGADOR,
        Math.max(AutoDme.MIN_PRECO_JOGADOR, Number.isFinite(Number(ajustado)) ? Number(ajustado) : clamped)
      );
    }

    private static repeatabilityModeUpper(dme: any): string {
      if (!dme || dme.repeatabilityMode == null) return '';
      return String(dme.repeatabilityMode).trim().toUpperCase();
    }

    private static dmePermiteRepeticaoUi(dme: any): boolean {
      const modo = AutoDme.repeatabilityModeUpper(dme);
      if (modo === 'UNLIMITED' || modo === 'REFRESH' || modo === 'LIMITED' || modo === 'REPEATABLE') return true;
      if (modo === 'NON_REPEATABLE') return false;
      return !!(dme && dme.repeatable);
    }

    private static dmeElegivelParaSelecao(dme: any): boolean {
      return !dme || !dme.timesCompleted || AutoDme.dmePermiteRepeticaoUi(dme);
    }

    private static precoJogadorSliderRange(): any {
      return {
        min: [AutoDme.MIN_PRECO_JOGADOR, AutoDme.incrementoPrecoJogador(AutoDme.MIN_PRECO_JOGADOR)],
        '12%': [1000, AutoDme.incrementoPrecoJogador(1000)],
        '35%': [10000, AutoDme.incrementoPrecoJogador(10000)],
        '58%': [50000, AutoDme.incrementoPrecoJogador(50000)],
        '72%': [100000, AutoDme.incrementoPrecoJogador(100000)],
        max: [AutoDme.MAX_PRECO_JOGADOR],
      };
    }

    private static clampLimiteSolucoesDiarias(raw: any): number {
      const n = parseInt(String(raw != null && raw !== '' ? raw : AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS), 10);
      return Math.min(
        AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS,
        Math.max(AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS, Number.isFinite(n) ? n : AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS)
      );
    }

    private static clampRepetirDme(raw: any, limiteSolucoesDiarias?: number): number {
      const n = parseInt(String(raw != null && raw !== '' ? raw : AutoDme.MIN_REPETIR_DME), 10);
      let repetir = Math.min(
        AutoDme.MAX_REPETIR_DME,
        Math.max(AutoDme.MIN_REPETIR_DME, Number.isFinite(n) ? n : AutoDme.MIN_REPETIR_DME)
      );
      if (limiteSolucoesDiarias != null && Number.isFinite(limiteSolucoesDiarias) && limiteSolucoesDiarias > 0) {
        repetir = Math.min(repetir, limiteSolucoesDiarias);
      }
      return repetir;
    }

    private static normalizarForragensPorSolucao(raw: any): number | null {
      if (raw === undefined || raw === null || String(raw).trim() === '') return null;
      const n = parseInt(String(raw), 10);
      if (!Number.isFinite(n) || n <= 0) return null;
      return Math.min(AutoDme.MAX_FORRAGENS_CLUBE_POR_SOLUCAO, Math.max(1, n));
    }

    private static normalizarLimitesSolucoesPorForragens(raw: any): LimiteSolucoesPorForragens[] {
      let itens: any[] = [];
      if (Array.isArray(raw)) {
        itens = raw;
      } else if (raw && typeof raw === 'object') {
        itens = Object.keys(raw)
          .filter(k => /^\d+$/.test(k))
          .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
          .map(k => raw[k]);
      }

      const out: LimiteSolucoesPorForragens[] = [];
      itens.forEach((item: any) => {
        const solucoesRaw = item && item.solucoes !== undefined ? item.solucoes : (item && item.limite_solucoes_abaixo_forragens);
        const abaixoRaw = item && item.abaixo_de !== undefined ? item.abaixo_de : (item && item.forragens_clube_abaixo_de);
        const solucoes = parseInt(String(solucoesRaw), 10);
        const abaixoDe = parseInt(String(abaixoRaw), 10);
        if (!Number.isFinite(abaixoDe) || abaixoDe <= 0) return;
        out.push({
          solucoes: Math.min(AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS, Math.max(0, Number.isFinite(solucoes) ? solucoes : 1)),
          abaixo_de: Math.min(AutoDme.MAX_LIMITE_FORRAGENS_ABAIXO_DE, Math.max(1, abaixoDe)),
        });
      });

      out.sort((a, b) => a.abaixo_de - b.abaixo_de);
      const dedup: LimiteSolucoesPorForragens[] = [];
      out.forEach(item => {
        const prev = dedup[dedup.length - 1];
        if (prev && prev.abaixo_de === item.abaixo_de) {
          prev.solucoes = item.solucoes;
        } else {
          dedup.push(item);
        }
      });
      return dedup;
    }

    private static normalizarLimitesSolucoesPorForragensComLegado(raw: any): LimiteSolucoesPorForragens[] {
      const atuais = AutoDme.normalizarLimitesSolucoesPorForragens(raw && raw.limites_solucoes_por_forragens);
      if (atuais.length) return atuais;

      const abaixoNovo = AutoDme.normalizarForragensPorSolucao(raw && raw.forragens_clube_abaixo_de);
      if (abaixoNovo != null) {
        const solucoesNovo = parseInt(String(raw && raw.limite_solucoes_abaixo_forragens), 10);
        return [{
          solucoes: Math.min(AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS, Math.max(0, Number.isFinite(solucoesNovo) ? solucoesNovo : 1)),
          abaixo_de: abaixoNovo,
        }];
      }

      const legado = AutoDme.normalizarForragensPorSolucao(raw && raw.forragens_clube_por_solucao);
      return legado != null ? [{ solucoes: 1, abaixo_de: legado }] : [];
    }

    private static lerLimitesForragensDoDom($ctx: JQuery): LimiteSolucoesPorForragens[] {
      const itens: LimiteSolucoesPorForragens[] = [];
      $ctx.find('.js-limite-forragens-row').each((_, el) => {
        const $row = $(el);
        const solucoes = parseInt(String($row.find('[data-limite-forragens-field="solucoes"]').val()), 10);
        const abaixoDe = parseInt(String($row.find('[data-limite-forragens-field="abaixo_de"]').val()), 10);
        if (!Number.isFinite(abaixoDe) || abaixoDe <= 0) return;
        itens.push({
          solucoes: Math.min(AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS, Math.max(0, Number.isFinite(solucoes) ? solucoes : 1)),
          abaixo_de: Math.min(AutoDme.MAX_LIMITE_FORRAGENS_ABAIXO_DE, Math.max(1, abaixoDe)),
        });
      });
      return AutoDme.normalizarLimitesSolucoesPorForragens(itens);
    }

    constructor(idExtensao: string, exibirLog: any) {
      this.idExtensao = idExtensao;
      this.exibirLog = exibirLog;
      console.log('AutoDme iniciado', this.idExtensao);

      if (typeof window !== 'undefined') {
        const w = window as any;
        if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== 'object') {
          w.FSW_DMES_DETAIL_BY_SET_ID = {};
        }
        if (w.FSW_DMES_CATALOGO_DETAIL_URL === undefined || w.FSW_DMES_CATALOGO_DETAIL_URL === null) {
          w.FSW_DMES_CATALOGO_DETAIL_URL = '';
        }
      }

      // carrega categorias da blade (data-attr) ou de window
      const categorias = this.elModoDme.data('categoriasDmes') || (window as any).CATEGORIES;
      this.categoriaDmes = typeof categorias === 'string' ? (JSON.parse(categorias) || []) : (categorias || []);
      this.tryHydrateDmesFromBusinessBootstrap();

      this.bindUI();
      // Preenche selects — se estiver vazio, tentamos recuperar do storage aqui dentro
      this.populateCategorySelect();

      // Restaura padrões globais e liga listeners de persistência
      this.restoreGlobalDefaults();
      this.enablePersistenceListeners();

      this.setupNumericValidation();
      this.bindProAutodmeModals();

      (window as any).autoDme = this;
    }

    /** Sufixo de IDs em formulários PRO (ex.: "-novo", "-5") vindo de data-autodme-id-suf; vazio na barra #modoDme. */
    private getDomIdSuffix($ctx: JQuery): string {
      const $marker = $ctx.find('.conteudo-form-resolver-dme').first();
      if (!$marker.length) return '';
      const raw = $marker.attr('data-autodme-id-suf');
      if (raw === undefined || raw === null) return '';
      return String(raw);
    }

    /** Nome exibível do desafio (modelo bilingue: nameptbr / name_pt / name). */
    private static challengeDisplayName(ch: any, fallbackIndex: number): string {
      const n = AutoDme.challengeRawName(ch);
      return n ? String(n) : ('Desafio ' + fallbackIndex);
    }

    private static challengeRawName(ch: any): string {
      if (!ch) return '';
      const n = ch.name || ch.nameptbr || ch.name_pt || ch.challengeName || ch.title || ch.label;
      return n ? String(n).trim() : '';
    }

    private static challengesHaveDisplayNames(challenges: any[]): boolean {
      return Array.isArray(challenges) && challenges.some((ch: any) => !!AutoDme.challengeRawName(ch));
    }

    private static detailChallengesFromSetId(setId: any): any[] {
      const sid = setId == null ? '' : String(setId);
      if (!sid) return [];
      AutoDme.reapplyDetailInlineFromBootstrapScript();
      const detail = AutoDme.getDmeDetailFromWindowMap(sid);
      return detail && Array.isArray(detail.challenges) ? detail.challenges : [];
    }

    private static challengesForPills(dmeObj: any, setId: any): any[] {
      const fromDme = dmeObj && Array.isArray(dmeObj.challenges) ? dmeObj.challenges : [];
      const fromDetail = AutoDme.detailChallengesFromSetId(setId);
      if (AutoDme.challengesHaveDisplayNames(fromDme)) return fromDme;
      if (AutoDme.challengesHaveDisplayNames(fromDetail)) return fromDetail;
      if (fromDme.length) return fromDme;
      return fromDetail;
    }

    private static createChallengePill(ch: any, index: number, checked: boolean): JQuery {
      const desafioText = 'Desafio ' + index;
      const challengeName = AutoDme.challengeRawName(ch);
      const subtitle = challengeName && challengeName !== desafioText ? challengeName : '';
      const fullTitle = subtitle || desafioText;
      const $label = $('<label/>', {
        class: 'dia-pill autodme-desafio-pill-wrap',
        title: fullTitle
      });
      const $input = $('<input/>', {
        type: 'checkbox',
        name: 'desafios_dme[]',
        value: String(index),
        checked: checked
      });
      const $pill = $('<span/>', { class: 'autodme-desafio-pill' });
      const $copy = $('<em/>', { class: 'autodme-desafio-pill-copy' });
      $copy.append($('<b/>', {
        class: 'autodme-desafio-pill-main',
        text: desafioText
      }));
      if (subtitle) {
        $copy.append($('<small/>', {
          class: 'autodme-desafio-pill-name',
          text: subtitle
        }));
      }
      $pill.append($copy);
      $label.append($input).append($pill);
      return $label;
    }

    private static normalizarSetIdModal(valor: any): string {
      const raw = valor == null ? '' : String(valor).trim();
      if (!raw) return '';
      const n = parseInt(raw, 10);
      return n > 0 ? String(n) : '';
    }

    private static dadosSalvosModalPro($modal: JQuery): any {
      let dadosJson: any = {};
      const raw = String($modal.find('.js-autodme-dados-json').first().text() || '').trim();
      if (raw) {
        try {
          dadosJson = JSON.parse(raw);
        } catch (_e) {
          dadosJson = {};
        }
      }
      const objEditar = $modal.data('autodmeObjEditar');
      const dadosObj = objEditar && objEditar.dados && typeof objEditar.dados === 'object' ? objEditar.dados : {};
      return $.extend(true, {}, dadosJson, dadosObj);
    }

    private static reaplicarDesafiosELinksSalvosModalPro($modal: JQuery, dmeId: any): void {
      if (!App || !App.Util || typeof App.Util.aplicarDadosAutodmeDesafiosELinksNoForm !== 'function') {
        return;
      }
      const dados = AutoDme.dadosSalvosModalPro($modal);
      const idSalvo = AutoDme.normalizarSetIdModal(dados && dados.id_dme);
      const idAtual = AutoDme.normalizarSetIdModal(dmeId);
      if (!idSalvo || !idAtual || idSalvo !== idAtual) {
        return;
      }
      const temDesafios = Object.prototype.hasOwnProperty.call(dados, 'desafios_dme');
      const temLinks = Object.prototype.hasOwnProperty.call(dados, 'links');
      if (!temDesafios && !temLinks) {
        return;
      }
      App.Util.aplicarDadosAutodmeDesafiosELinksNoForm($modal, dados);
    }

    /** Catálogo PRO vindo do Laravel (Business): categorias + mapa de detalhes por setId. */
    private tryHydrateDmesFromBusinessBootstrap(): void {
      console.log('tryHydrateDmesFromBusinessBootstrap');
      if (typeof document === 'undefined') return;
      const w = window as any;
      if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== 'object') {
        w.FSW_DMES_DETAIL_BY_SET_ID = {};
      }
      console.log('w.FSW_DMES_DETAIL_BY_SET_ID', w.FSW_DMES_DETAIL_BY_SET_ID);
      const el = document.getElementById('fsw-dmes-client-bootstrap');
      console.log('[AutoDme backend] fsw-dmes-client-bootstrap el:', el ? 'ENCONTRADO (len=' + (el.textContent || '').length + ')' : 'NÃO ENCONTRADO');
      if (!el || !el.textContent) {
        console.warn(
          '[AutoDme backend] fsw-dmes-client-bootstrap: elemento ausente ou vazio — usando fallback data-dmes-detail-url'
        );
        return;
      }
      try {
        const payload = JSON.parse(el.textContent) as {
          categorias?: ICategoriaDme[];
          detailInline?: Record<string, any> | null;
          detailUrl?: string | null;
        };
        console.log('payload tryHydrateDmesFromBusinessBootstrap', payload);
        const inline = AutoDme.normalizeDetailInlinePayload(payload.detailInline as any);
        const inlineKeys = inline ? Object.keys(inline).length : 0;
        const primeirasChavesDetalhe = inline ? Object.keys(inline).slice(0, 8) : [];
        console.log('[AutoDme backend] bootstrap resumo', {
          categorias: (payload.categorias && payload.categorias.length) ? payload.categorias.length : 0,

          detailInlineChaves: inlineKeys,
          primeirasChavesDetalhe,
          detailUrl: payload.detailUrl || null,
        });
        if (payload.categorias && payload.categorias.length) {
          const hasSets = payload.categorias.some((c) => c && Array.isArray(c.sets) && c.sets.length > 0);
          if (hasSets) {
            this.categoriaDmes = payload.categorias;
          }
        }
        if (inline) {
          w.FSW_DMES_DETAIL_BY_SET_ID = { ...w.FSW_DMES_DETAIL_BY_SET_ID, ...inline };
        }
        if (payload.detailUrl) {
          w.FSW_DMES_CATALOGO_DETAIL_URL = payload.detailUrl;
          AutoDme.dmesDetailFetchDone = false;
        } else {
          w.FSW_DMES_CATALOGO_DETAIL_URL = '';
          AutoDme.dmesDetailFetchDone = true;
        }
      } catch (e) {
        console.warn('fsw-dmes-client-bootstrap', e);
      }
    }

    /**
     * Reaplica detailInline do script JSON no DOM (ex.: AutoDme construído antes do partial Business,
     * ou após navegação). Não altera detailUrl / flag de fetch.
     */
    private static reapplyDetailInlineFromBootstrapScript(): void {
      console.log('reapplyDetailInlineFromBootstrapScript');
      if (typeof document === 'undefined') return;
      const w = window as any;
      if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== 'object') {
        w.FSW_DMES_DETAIL_BY_SET_ID = {};
      }
      const el = document.getElementById('fsw-dmes-client-bootstrap');
      if (!el || !el.textContent) return;
      try {
        const payload = JSON.parse(el.textContent) as { detailInline?: Record<string, any> | null };
        const inline = AutoDme.normalizeDetailInlinePayload(payload.detailInline as any);
        if (inline) {
          w.FSW_DMES_DETAIL_BY_SET_ID = { ...w.FSW_DMES_DETAIL_BY_SET_ID, ...inline };
        }
      } catch (_e) {
        /* ignore */
      }
    }

    /** `detailInline` do Laravel deve ser objeto { "792": {...} }; arrays JSON [] não são mapa por setId. */
    private static normalizeDetailInlinePayload(raw: any): Record<string, any> | null {
      if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
        return null;
      }
      const o = raw as Record<string, any>;
      return Object.keys(o).length ? o : null;
    }

    /** Detalhe do set no mapa global (chaves numéricas vs string no JSON). */
    private static getDmeDetailFromWindowMap(setId: string): any {
      const w = window as any;
      if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== 'object') {
        w.FSW_DMES_DETAIL_BY_SET_ID = {};
      }
      const map = w.FSW_DMES_DETAIL_BY_SET_ID;
      if (!map || typeof map !== 'object') return null;
      const sid = String(setId);
      let d = map[sid];
      if (d) return d;
      const n = parseInt(sid, 10);
      if (Number.isFinite(n) && map[n] != null) return map[n];
      for (const k of Object.keys(map)) {
        if (String(k) === sid) return map[k];
        const nk = parseInt(String(k), 10);
        if (Number.isFinite(nk) && nk === n) return map[k];
      }
      return null;
    }

    /** Mapas id→nome (ligas, clubes, nações) vindos do Laravel — script #fsw-dme-entity-lookups. */
    private static ensureDmeEntityLookupsHydrated(): void {
      if (typeof document === 'undefined') return;
      const w = window as any;
      if (w.__fswDmeEntityLookupsHydrated) return;
      w.__fswDmeEntityLookupsHydrated = true;
      if (!w.FSW_DME_ENTITY_LOOKUPS || typeof w.FSW_DME_ENTITY_LOOKUPS !== 'object') {
        w.FSW_DME_ENTITY_LOOKUPS = {
          leaguesById: {},
          teamsById: {},
          nationsById: {},
        };
      }
      const el = document.getElementById('fsw-dme-entity-lookups');
      if (!el || !el.textContent) return;
      try {
        const data = JSON.parse(el.textContent) as {
          leaguesById?: Record<string, string>;
          teamsById?: Record<string, string>;
          nationsById?: Record<string, string>;
        };
        const cur = w.FSW_DME_ENTITY_LOOKUPS;
        const merge = (a: Record<string, string>, b: any) => {
          if (b && typeof b === 'object' && !Array.isArray(b)) {
            return $.extend({}, a, b as Record<string, string>);
          }
          return a || {};
        };
        w.FSW_DME_ENTITY_LOOKUPS = {
          leaguesById: merge(cur.leaguesById || {}, data.leaguesById),
          teamsById: merge(cur.teamsById || {}, data.teamsById),
          nationsById: merge(cur.nationsById || {}, data.nationsById),
        };
      } catch (_e) {
        /* ignore */
      }
    }

    private static coercePositiveInt(v: any): number | undefined {
      if (v == null || v === '') return undefined;
      const n = typeof v === 'number' ? v : parseInt(String(v), 10);
      return Number.isFinite(n) && n > 0 ? n : undefined;
    }

    /** Lê id EA (clube/liga/país) a partir do item de requisito + tag já inferida. */
    private static extractFifaEntityIdForRequirement(it: any, tag: string | null): number | undefined {
      if (!it || typeof it !== 'object') return undefined;
      var raw = (it.raw && typeof it.raw === 'object') ? it.raw : null;
      var tagFromKey: string | null = null;
      if (raw && raw.key != null) {
        tagFromKey = AutoDme.tagFromEaRequirementRawKey(raw.key);
      }
      var effTag = tag ? tag : tagFromKey;
      var fromRaw: number | undefined = undefined;
      if (raw && raw.value != null && tagFromKey && (!effTag || effTag === tagFromKey)) {
        var rv = raw.value;
        var idPart = (typeof rv === 'object' && rv && (rv as any).id != null) ? (rv as any).id : rv;
        fromRaw = AutoDme.coercePositiveInt(idPart);
      }
      if (effTag === 'team') {
        var firstRaw = typeof fromRaw !== 'undefined' ? fromRaw : undefined;
        var second = (typeof firstRaw !== 'undefined')
          ? firstRaw
          : AutoDme.coercePositiveInt(it.teamId);
        if (typeof second !== 'undefined') return second;
        var third = AutoDme.coercePositiveInt(it.clubId);
        if (typeof third !== 'undefined') return third;
        return undefined;
      }
      if (effTag === 'league') {
        var firstRawLeague = typeof fromRaw !== 'undefined' ? fromRaw : undefined;
        var secondLeague = (typeof firstRawLeague !== 'undefined')
          ? firstRawLeague
          : AutoDme.coercePositiveInt(it.leagueId);
        if (typeof secondLeague !== 'undefined') return secondLeague;
        return undefined;
      }
      if (effTag === 'nation') {
        var firstRawNation = typeof fromRaw !== 'undefined' ? fromRaw : undefined;
        var secondNation = (typeof firstRawNation !== 'undefined')
          ? firstRawNation
          : AutoDme.coercePositiveInt(it.nationId);
        if (typeof secondNation !== 'undefined') return secondNation;
        var thirdNation = AutoDme.coercePositiveInt(it.nation);
        if (typeof thirdNation !== 'undefined') return thirdNation;
        return undefined;
      }
      return undefined;
    }

    private static lookupEntityNameByTag(tag: string | null, id: number | undefined): string | null {
      if (!tag || id == null) return null;
      AutoDme.ensureDmeEntityLookupsHydrated();
      const w = window as any;
      const L = w.FSW_DME_ENTITY_LOOKUPS || {};
      const sid = String(id);
      if (tag === 'league') {
        const m = L.leaguesById || {};
        return (m[sid] || m[id] || null) as string | null;
      }
      if (tag === 'team') {
        const m = L.teamsById || {};
        return (m[sid] || m[id] || null) as string | null;
      }
      if (tag === 'nation') {
        const m = L.nationsById || {};
        return (m[sid] || m[id] || null) as string | null;
      }
      return null;
    }

    /** Texto exibível com liga/clube/país resolvido pelo catálogo do sistema (quando houver id). */
    private static formatRequirementItemDisplay(it: any, tag: string | null, text: string): string {
      var base = String((text || '')).trim();
      if (!base) return base;

      var raw = null;
      if (it && typeof it === "object" && "raw" in it && typeof it.raw === "object") {
        raw = it.raw;
      }

      var tagFromKey = null;
      if (raw && "key" in raw && raw.key != null) {
        tagFromKey = AutoDme.tagFromEaRequirementRawKey(raw.key);
      }

      var effTag = tag;
      if (effTag == null && tagFromKey != null) effTag = tagFromKey;

      var id = AutoDme.extractFifaEntityIdForRequirement(it, tag);
      var name = AutoDme.lookupEntityNameByTag(effTag, id);
      if (!name) return base;

      var nl = name.toLowerCase();
      if (base.toLowerCase().indexOf(nl) !== -1) return base;

      var label = '';
      if (effTag === 'league') {
        label = 'Liga';
      } else if (effTag === 'team') {
        label = 'Clube';
      } else if (effTag === 'nation') {
        label = 'País';
      }

      if (label) {
        return base + ' — ' + label + ': ' + name;
      } else {
        return base + ' — ' + name;
      }
    }

    private static requirementTypeShortLabel(tag: string | null): string {
      if (tag === 'league') return 'Liga';
      if (tag === 'team') return 'Clube';
      if (tag === 'nation') return 'País';
      if (tag === 'rating') return 'OVR';
      return 'Req.';
    }

    private ensureDmesDetailMapLoaded(done: () => void): void {
      console.log('ensureDmesDetailMapLoaded');
      AutoDme.reapplyDetailInlineFromBootstrapScript();
      this.tryHydrateDmesFromBusinessBootstrap();
      const w = window as any;
      let url = typeof w.FSW_DMES_CATALOGO_DETAIL_URL === 'string' ? w.FSW_DMES_CATALOGO_DETAIL_URL.trim() : '';

      // Fallback: quando o #fsw-dmes-client-bootstrap não está no DOM (layout sem bootstrap),
      // tenta ler a URL do data-dmes-detail-url injetado em qualquer .js-select-dme-autodme-pro.
      if (!url && !AutoDme.dmesDetailFetchDone) {
        const $anySelect = $('select.js-select-dme-autodme-pro[data-dmes-detail-url]').first();
        const attrUrl = $anySelect.length ? String($anySelect.attr('data-dmes-detail-url') || '').trim() : '';
        if (attrUrl) {
          url = attrUrl;
          w.FSW_DMES_CATALOGO_DETAIL_URL = url;
          console.log('[AutoDme backend] URL obtida via data-dmes-detail-url:', url);
        }
      }

      const mapKeys = Object.keys(w.FSW_DMES_DETAIL_BY_SET_ID || {}).filter(
        (k) => (w.FSW_DMES_DETAIL_BY_SET_ID as any)[k] != null
      );
      console.log('mapKeys', mapKeys, url, AutoDme.dmesDetailFetchDone);
      if (url && mapKeys.length === 0 && AutoDme.dmesDetailFetchDone) {
        AutoDme.dmesDetailFetchDone = false;
      }
      if (AutoDme.dmesDetailFetchDone || !url) {
        done();
        return;
      }
      if (AutoDme.dmesCatalogDetailRequest) {
        AutoDme.dmesCatalogDetailRequest.always(() => done());
        return;
      }
      AutoDme.dmesCatalogDetailRequest = $.getJSON(url)
        .done((data: any) => {
          console.log('[AutoDme backend] GET dmes-catalogo.json bruto', {
            tipo: typeof data,
            chavesTop: data && typeof data === 'object' && !Array.isArray(data) ? Object.keys(data).slice(0, 12) : null,
            temBySetId: !!(data && data.bySetId),
          });
          let map: any = null;
          if (data && typeof data === 'object' && !Array.isArray(data)) {
            map = data.bySetId != null ? data.bySetId : data;
          }
          if (map && typeof map === 'object' && !Array.isArray(map)) {
            if (!w.FSW_DMES_DETAIL_BY_SET_ID || typeof w.FSW_DMES_DETAIL_BY_SET_ID !== 'object') {
              w.FSW_DMES_DETAIL_BY_SET_ID = {};
            }
            w.FSW_DMES_DETAIL_BY_SET_ID = $.extend({}, w.FSW_DMES_DETAIL_BY_SET_ID, map);
            console.log('[AutoDme backend] GET dmes-catalogo.json mapa fundido', {
              totalChaves: Object.keys(w.FSW_DMES_DETAIL_BY_SET_ID).length,
              primeirasChavesMapa: Object.keys(w.FSW_DMES_DETAIL_BY_SET_ID).slice(0, 8),
            });
          } else {
            console.warn('[AutoDme backend] GET dmes-catalogo.json sem objeto utilizável (bySetId ou raiz)', data);
          }
        })
        .fail((jqXHR: any, textStatus: string, errorThrown: string) => {
          console.warn('[AutoDme backend] GET dmes-catalogo.json falhou', {
            url: w.FSW_DMES_CATALOGO_DETAIL_URL,
            status: jqXHR && jqXHR.status,
            textStatus,
            errorThrown,
          });
        })
        .always(() => {
          AutoDme.dmesDetailFetchDone = true;
          AutoDme.dmesCatalogDetailRequest = null;
          done();
        });
    }

    /** Remove sufixo legado do nome vindo do PHP (`[💵Negociável💵]`). */
    private static stripNegociavelSuffixFromDmeLabel(text: string): string {
      return String(text || '')
        .replace(/\s*\[💵Negociável💵\]\s*$/gi, '')
        .replace(/\s*\[💵\s*Negociável\s*💵\]\s*$/gi, '')
        .trim();
    }

    /** Rótulo curto no badge (alinhado a /sbc-info e legenda Auto DME). */
    private static labelForRepeatabilityMode(mode: string): string {
      const m = String(mode || '').toUpperCase();
      if (m === 'NON_REPEATABLE') return 'NÃO REPETÍVEL';
      return m;
    }

    /** Classes semânticas (.fsw-sbc-badge — ver _sbc-semantic-badges.scss). */
    private static badgeClassForRepeatabilityMode(mode: string): string {
      const m = String(mode || '').toUpperCase();
      if (m === 'NON_REPEATABLE') return 'fsw-sbc-badge fsw-sbc-badge--nao-repetivel';
      if (m === 'UNLIMITED') return 'fsw-sbc-badge fsw-sbc-badge--unlimited';
      if (m === 'REFRESH') return 'fsw-sbc-badge fsw-sbc-badge--refresh';
      return 'fsw-sbc-badge fsw-sbc-badge--nao-repetivel';
    }

    /** Tooltip (title) do modo de repetição do SBC — alinhar com a legenda do formulário. */
    private static titleForRepeatabilityMode(mode: string): string {
      const m = String(mode || '').toUpperCase();
      if (m === 'NON_REPEATABLE') {
        return 'Tipo SBC (EA): NON_REPEATABLE — não repetível. Depois de concluído, este conjunto não volta a ficar disponível no mesmo formato.';
      }
      if (m === 'UNLIMITED') {
        return 'Tipo SBC (EA): UNLIMITED — ilimitado. Pode ser repetido várias vezes, conforme as regras do FUT / Web App.';
      }
      if (m === 'REFRESH') {
        return 'Tipo SBC (EA): REFRESH — com renovação. Pode reabrir ou renovar após um intervalo (ex.: janela diária), conforme a EA.';
      }
      return 'Tipo de repetição do DME (repeatabilityMode) segundo o catálogo.';
    }

    private static readonly TITLE_REPETIVEL =
      'REPETÍVEL — este DME pode ser resolvido mais de uma vez (repetível), conforme o tipo de SBC e o estado na EA.';
    private static readonly TITLE_UNICO =
      'ÚNICO — DME não repetível neste formato; após concluir, não reabre como o mesmo desafio de conjunto.';
    private static readonly TITLE_NEGOCIAVEL =
      'Negociável — existe ao menos uma recompensa negociável (tradable) no grupo ou nos desafios.';
    private static readonly TITLE_NEG_COUNT =
      'Quantidade de recompensas negociáveis contabilizadas no grupo (prémios do set + prémios dos desafios, quando negociáveis).';

    /** Badge repetível vs único (cor distinta do modo e do negociável). */
    private static appendRepeatableBadge($container: JQuery, repRaw: string): void {
      const isRep = repRaw === 'Repeatable' || repRaw === 'true' || repRaw === '1';
      if (isRep) {
        $container.append(
          $('<span/>', {
            class: 'fsw-sbc-badge fsw-sbc-badge--repetivel',
            text: 'REPETÍVEL',
            title: AutoDme.TITLE_REPETIVEL,
          })
        );
        return;
      }
      $container.append(
        $('<span/>', {
          class: 'fsw-sbc-badge fsw-sbc-badge--unico',
          text: 'ÚNICO',
          title: AutoDme.TITLE_UNICO,
        })
      );
    }

    /** Bloco negociável: badge + quantidade (só se count &gt; 0). */
    private static appendNegociavelBadgeIfAny($container: JQuery, tradableCount: number): void {
      const n =
        typeof tradableCount === 'number' && Number.isFinite(tradableCount)
          ? tradableCount
          : parseInt(String(tradableCount || '0'), 10) || 0;
      if (n <= 0) return;
      const $grp = $('<span class="fsw-dme-s2-neg-grp"/>');
      $grp.append(
        $('<span class="fsw-sbc-badge fsw-sbc-badge--negociavel"/>')
          .text('NEGOCIÁVEL')
          .attr('title', AutoDme.TITLE_NEGOCIAVEL)
      );
      $grp.append(
        $('<span class="fsw-sbc-badge fsw-sbc-badge--negociavel"/>')
          .text(String(n) + '×')
          .attr('title', AutoDme.TITLE_NEG_COUNT)
      );
      $container.append($grp);
    }

    /** Tipo de exigência para badge (liga / time / país / rating) — heurística PT/EN. */
    private static inferRequirementTagFromText(text: string): string | null {
      const s = String(text || '').trim();
      if (!s) return null;
      if (/\d/.test(s) && /rating|overall|classifica|classificação|\bovr\b|\bger\b|g\.e\.r\./i.test(s)) {
        return 'rating';
      }
      if (/\bliga\b|\bleague\b|mesma\s+liga|same\s+league|atletas\s+de\s+liga/i.test(s)) return 'league';
      if (/na(ç|c)(a|ã)o|nacionalidade|\bpa(i|í)s\b|\bnation\b|pa(í|i)ses|regi(õ|o)es|atletas\s+de\s+pa(í|i)ses/i.test(s))
        return 'nation';
      if (/\bclube\b|\btime\b|\bclub\b|mesmo\s+clube|same\s+club|atletas\s+de\s+clube/i.test(s)) return 'team';
      return null;
    }

    /** Paridade com `DmeCatalogoNormalizer::mapEaRequirementNumericKeyToTag` (chaves EA em `raw.key`). */
    private static tagFromEaRequirementRawKey(key: any): string | null {
      const n = typeof key === 'number' ? key : parseInt(String(key), 10);
      if (!Number.isFinite(n)) return null;
      const map: Record<number, string> = {
        26: 'rating',
        28: 'rating',
        10: 'nation',
        11: 'league',
        4: 'nation',
        5: 'league',
        6: 'team',
      };
      return map[n] || null;
    }

    private static normalizeChallengeRequirementRows(
      ch: any
    ): Array<{ text: string; tag: string | null; displayText: string }> {
      const items = ch && Array.isArray(ch.requirementItems) ? ch.requirementItems : null;
      if (items && items.length) {
        return items
          .map((it: any) => {
            const text = String((it && it.text) || '').trim();
            if (!text) return null as any;
            let tag: string | null =
              it && it.tag != null && String(it.tag).trim() !== '' ? String(it.tag).trim() : null;
            if (!tag && it && it.raw && it.raw.key != null && it.raw.key !== '') {
              tag = AutoDme.tagFromEaRequirementRawKey(it.raw.key);
            }
            if (!tag) tag = AutoDme.inferRequirementTagFromText(text);
            const displayText = AutoDme.formatRequirementItemDisplay(it, tag, text);
            return { text, tag, displayText };
          })
          .filter((x: any) => x) as Array<{ text: string; tag: string | null; displayText: string }>;
      }
      const reqs = ch && Array.isArray(ch.requirements) ? ch.requirements : [];
      return reqs
        .map((entry: any) => {
          let text = '';
          if (typeof entry === 'string') {
            text = String(entry || '').trim();
          } else if (entry && typeof entry === 'object') {
            text = String(
              entry.text ||
                entry.textPtBr ||
                entry.text_pt ||
                entry.textEn ||
                entry.text_en ||
                entry.description ||
                entry.descriptionPtBr ||
                entry.label ||
                entry.title ||
                ''
            ).trim();
          }
          if (!text) return null as any;
          let tag: string | null = null;
          if (entry && typeof entry === 'object' && entry.raw && entry.raw.key != null && entry.raw.key !== '') {
            tag = AutoDme.tagFromEaRequirementRawKey(entry.raw.key);
          }
          if (!tag) tag = AutoDme.inferRequirementTagFromText(text);
          const displayText =
            entry && typeof entry === 'object'
              ? AutoDme.formatRequirementItemDisplay(entry, tag, text)
              : text;
          return { text, tag, displayText };
        })
        .filter((x: any) => x) as Array<{ text: string; tag: string | null; displayText: string }>;
    }

    private static normalizeChallengeAwardRows(
      ch: any
    ): Array<{ label: string; tag: string; tradable: boolean | null; title: string; imageUrl: string }> {
      const rawAwards: any[] = [];
      const addAwards = (value: any) => {
        if (!value) return;
        if (Array.isArray(value)) {
          value.forEach((it: any) => addAwards(it));
          return;
        }
        if (typeof value === 'object') {
          rawAwards.push(value);
        }
      };

      addAwards(ch && ch.awards);
      addAwards(ch && ch.rewards);
      addAwards(ch && ch.reward);
      addAwards(ch && ch.award);
      if (ch && ch.packMeta) {
        rawAwards.push({ tag: 'Pacote', type: 'pack', packMeta: ch.packMeta });
      }

      return rawAwards
        .map((award: any) => AutoDme.normalizeChallengeAwardRow(award))
        .filter((x: any) => x) as Array<{ label: string; tag: string; tradable: boolean | null; title: string; imageUrl: string }>;
    }

    private static normalizeChallengeAwardRow(award: any): { label: string; tag: string; tradable: boolean | null; title: string; imageUrl: string } | null {
      if (!award || typeof award !== 'object') return null;
      const packMeta = award.packMeta && typeof award.packMeta === 'object' ? award.packMeta : null;
      const type = String(award.type || '').toLowerCase();
      const tagRaw = String(award.tag || '').trim();
      const isPack = tagRaw.toLowerCase() === 'pacote' || type === 'pack' || !!packMeta || !!award.isPack;
      const count = parseInt(String(award.count || '1'), 10) || 1;
      const packId = AutoDme.firstPositiveNumber([award.value, award.rawValue, award.assetId, award.halId, packMeta && packMeta.packId]);
      let label = String(
        (packMeta && packMeta.name) ||
          award.label ||
          award.name ||
          award.title ||
          ''
      ).trim();

      if (!label && isPack) {
        const knownPackName = AutoDme.knownPackNameById(packId);
        label = knownPackName || ('Pack #' + (packId > 0 ? String(packId) : '?'));
      }
      if (!label && (award.isCoin || type === 'coins' || tagRaw.toLowerCase() === 'coins')) {
        const coins = AutoDme.firstPositiveNumber([award.value, award.rawValue]);
        label = (coins > 0 ? String(coins * count) : String(count)) + ' coins';
      }
      if (!label && (award.isXP || type === 'xp' || tagRaw.toLowerCase() === 'xp')) {
        const xp = AutoDme.firstPositiveNumber([award.value, award.rawValue]);
        label = (xp > 0 ? String(xp * count) : String(count)) + ' XP';
      }
      if (!label) {
        label = count + 'x Recompensa';
      } else if (count > 1 && !/^\s*\d+\s*x/i.test(label)) {
        label = count + 'x ' + label;
      }

      let tradable: boolean | null = null;
      if (Object.prototype.hasOwnProperty.call(award, 'tradable')) {
        tradable = !!award.tradable;
      } else if (Object.prototype.hasOwnProperty.call(award, 'isUntradeable')) {
        tradable = !award.isUntradeable;
      }

      const title = String((packMeta && packMeta.description) || award.description || label).trim();
      const imageUrl = String((packMeta && packMeta.imageUrl) || award.imageUrl || '').trim();
      const tag = tagRaw || (isPack ? 'Pack' : (type ? type.toUpperCase() : 'Reward'));
      return { label, tag, tradable, title, imageUrl };
    }

    private static firstPositiveNumber(values: any[]): number {
      for (const v of values) {
        const n = parseInt(String(v || '0'), 10);
        if (Number.isFinite(n) && n > 0) return n;
      }
      return 0;
    }

    private static knownPackNameById(packId: number): string {
      const map: Record<number, string> = {
        1: 'Premium Bronze Pack',
        2: 'Premium Silver Pack',
        3: 'Gold Pack',
        4: 'Gold Players Pack',
        105: 'Premium Bronze Pack',
        205: 'Premium Silver Pack',
        300: 'Jumbo Gold Pack',
        301: 'Premium Gold Pack',
        304: 'Gold Pack',
        305: 'Gold Players Pack',
        308: 'Premium Gold Players Pack',
        314: 'Small Prime Gold Players Pack',
        316: 'Rare Mixed Players Pack',
        403: 'Rare Mixed Players Pack',
        509: 'Two Silver Players Pack',
        510: 'Three Common Gold Players Pack',
        512: 'Two Rare Gold Players Pack',
        519: 'Prime Gold Players Pack',
        531: 'Gold Players Pack',
        1019: '3x 85+ Players Pack',
        20059: 'Daily Rare Gold Pack',
        20060: 'Daily Common Gold Pack',
      };
      return map[packId] || '';
    }

    private static truncateRequirementBadge(s: string, maxLen: number): string {
      const t = String(s || '').trim();
      if (t.length <= maxLen) return t;
      return t.slice(0, Math.max(0, maxLen - 1)) + '…';
    }

    /** Parte após o último ":" (valor humano), senão o texto completo. */
    private static requirementValueSlice(full: string): string {
      const s = String(full || '').trim();
      const idx = s.lastIndexOf(':');
      if (idx !== -1 && idx < s.length - 1) {
        const tail = s.slice(idx + 1).trim();
        if (tail.length > 0 && tail.length < 140) return tail;
      }
      return s;
    }

    private static requirementRatingBadgeLabel(full: string): string {
      const nums = String(full).match(/\d{2,3}/g);
      const n = nums && nums.length ? nums[nums.length - 1] : '';
      if (/máx|máximo|max|maximum/i.test(full)) return 'Rating max. ' + n;
      if (/mín|mínimo|min|minimum/i.test(full)) return 'Rating min. ' + n;
      return n ? 'Rating ' + n : AutoDme.truncateRequirementBadge(full, 36);
    }

    private static requirementBadgeClassForTag(tag: string | null): string {
      if (tag === 'league') return 'badge badge-info font-weight-bold';
      if (tag === 'team') return 'badge badge-primary font-weight-bold';
      if (tag === 'nation') return 'badge badge-warning font-weight-bold';
      if (tag === 'rating') return 'badge badge-secondary font-weight-bold';
      return 'badge badge-light border text-dark font-weight-bold';
    }

    private static requirementBadgeLabel(tag: string | null, full: string): string {
      const tail = AutoDme.requirementValueSlice(full);
      if (tag === 'rating') return AutoDme.requirementRatingBadgeLabel(full);
      const prefix =
        tag === 'league' ? 'Liga' : tag === 'nation' ? 'País' : tag === 'team' ? 'Time' : '';
      if (prefix) {
        const short = AutoDme.truncateRequirementBadge(tail, 36);
        if (short && short !== full.trim()) return prefix + ': ' + short;
        return prefix + (short ? ': ' + short : '');
      }
      return AutoDme.truncateRequirementBadge(full, 44);
    }

    /** Badges de modo / repetível / negociável — mesma linha que o nome (Select2). */
    private static appendDmeSelect2MetaRow($meta: JQuery, mode: string, repRaw: string, trCount: number): void {
      if (mode) {
        $meta.append(
          $('<span/>', {
            class: AutoDme.badgeClassForRepeatabilityMode(mode),
            text: AutoDme.labelForRepeatabilityMode(mode),
            title: AutoDme.titleForRepeatabilityMode(mode),
          })
        );
      }
      AutoDme.appendRepeatableBadge($meta, repRaw);
      AutoDme.appendNegociavelBadgeIfAny($meta, trCount);
    }

    /** Select2: texto + badges em linha (dropdown e caixa fechada). */
    private static formatDmeSelect2State(data: any, compact: boolean): JQuery {
      if (!data || !data.id) {
        return $('<span/>').text(data.text || '');
      }
      const el = data.element as HTMLOptionElement | undefined;
      const $o = el ? $(el) : $();
      if (!$o.length) {
        return $('<span/>').text(data.text || '');
      }
      const mode = String($o.attr('data-repeatability-mode') || '');
      const trCount = parseInt(String($o.attr('data-tradable-count') || '0'), 10) || 0;
      const repRaw = String($o.attr('data-repeatable') || '');
      const cleanName = AutoDme.stripNegociavelSuffixFromDmeLabel(String(data.text || ''));
      const $wrap = $('<div/>').addClass(
        compact ? 'fsw-dme-s2-opt fsw-dme-s2-opt--compact' : 'fsw-dme-s2-opt'
      );
      const $title = $('<span class="fsw-dme-s2-opt__title"/>').text(cleanName);
      const $meta = $('<span class="fsw-dme-s2-opt__meta"/>');
      AutoDme.appendDmeSelect2MetaRow($meta, mode, repRaw, trCount);
      $wrap.append($title, $meta);
      return $wrap;
    }

    /**
     * Linha "quantas vezes a EA permite concluir este DME no ciclo do dia", espelhando o que o
     * /sbc-info mostra em ".sbc-refresh-detail". Fonte: `repeatabilityMode` + `repeats` +
     * `repeatRefreshInterval` do catálogo da EA, lidos do <option> selecionado (com fallback
     * para o detalhe carregado em FSW_DMES_DETAIL_BY_SET_ID).
     */
    private appendLimiteCicloResumo($body: JQuery, $opt: JQuery, detail: any): void {
      const lerNumero = (attr: string, campo: string): number => {
        const doAttr = String($opt.attr(attr) || '');
        const bruto = doAttr !== ''
          ? doAttr
          : (detail && detail[campo] != null ? String(detail[campo]) : '');
        const n = parseInt(bruto, 10);
        return isFinite(n) ? n : 0;
      };
      const modo = String(
        $opt.attr('data-repeatability-mode') || (detail && detail.repeatabilityMode) || ''
      ).toUpperCase();
      const repeats = lerNumero('data-repeats', 'repeats');
      const refreshSec = lerNumero('data-repeat-refresh-interval', 'repeatRefreshInterval');

      const $linha = $('<div class="small text-muted mb-2 fsw-autodme-resumo-ciclo"/>');
      const $rotulo = $('<span/>');
      if (modo === 'UNLIMITED') {
        $rotulo.attr('title', 'A EA não limita conclusões deste DME no ciclo.').text('Soluções permitidas no ciclo: ');
        $rotulo.append($('<strong/>').text('ilimitado'));
      } else if (modo === 'NON_REPEATABLE' || modo === '') {
        $rotulo.attr('title', 'DME único: a EA permite concluir uma só vez.').text('Soluções permitidas no ciclo: ');
        $rotulo.append($('<strong/>').text('1×'));
        $rotulo.append(document.createTextNode(' (único)'));
      } else if (repeats > 0) {
        const prefixo = modo === 'LIMITED' ? 'Limite total: ' : 'Soluções permitidas no ciclo: ';
        $rotulo
          .attr('title', 'Campo `repeats` do catálogo da EA — conclusões permitidas antes do reset do ciclo.')
          .text(prefixo);
        $rotulo.append($('<strong/>').text(String(repeats) + '×'));
      } else {
        $rotulo.attr('title', 'O catálogo da EA não trouxe `repeats` para este DME.').text('Soluções permitidas no ciclo: ');
        $rotulo.append($('<em/>').text('n/d'));
      }
      $linha.append($rotulo);

      if (refreshSec > 0) {
        $linha.append(
          $('<span class="d-block"/>')
            .attr('title', 'repeatRefreshInterval: ' + refreshSec + ' s')
            .text('Janela do ciclo: ' + this.humanizeDurationSeconds(refreshSec))
        );
      }
      $body.append($linha);
    }

    private renderDmeResumoPro($modal: JQuery, setId: string): void {
      const $box = $modal.find('.js-autodme-dme-resumo');
      if (!$box.length) return;
      AutoDme.reapplyDetailInlineFromBootstrapScript();
      this.tryHydrateDmesFromBusinessBootstrap();
      AutoDme.ensureDmeEntityLookupsHydrated();
      const sid = String(setId);
      const $opt = $modal.find('.js-select-dme-autodme-pro option:selected');

      let detail: any = AutoDme.getDmeDetailFromWindowMap(sid);
      let temRequisitosPorDesafio = false;
      if (detail && Array.isArray(detail.challenges) && detail.challenges.length) {
        temRequisitosPorDesafio = (detail.challenges as any[]).some((ch: any) => {
          const rows = AutoDme.normalizeChallengeRequirementRows(ch);
          return rows.length > 0;
        });
      }

      if (!detail || !Array.isArray(detail.challenges) || detail.challenges.length === 0) {
        const setCat = this.findSetInCategoriaDmes(sid);
        const chCat = setCat && Array.isArray(setCat.challenges) ? setCat.challenges : [];
        if (chCat.length) {
          detail = {
            name: (setCat && setCat.name) || '',
            description: (setCat && setCat.description) || '',
            challenges: chCat.map((ch: any, idx: number) => {
              const cidRaw = ch.challengeId != null ? ch.challengeId : ch.id;
              const cid =
                typeof cidRaw === 'number' && cidRaw > 0
                  ? cidRaw
                  : parseInt(String(cidRaw || ''), 10) > 0
                    ? parseInt(String(cidRaw), 10)
                    : idx + 1;
              return {
                challengeId: cid,
                name: ch.name || ch.nameptbr,
                requirements: Array.isArray(ch.requirements) ? ch.requirements : [],
                requirementItems: ch.requirementItems,
                awards: Array.isArray(ch.awards) ? ch.awards : [],
              };
            }),
          };
          temRequisitosPorDesafio = (detail.challenges as any[]).some((ch: any) => {
            const rows = AutoDme.normalizeChallengeRequirementRows(ch);
            return rows.length > 0;
          });
        }
      }

      if (!detail || !Array.isArray(detail.challenges) || detail.challenges.length === 0) {
        let parsed: any[] = [];
        const rawCh = $opt.attr('data-challenges');
        if (rawCh) {
          try {
            const p = JSON.parse(String(rawCh));
            if (Array.isArray(p) && p.length) parsed = p;
          } catch (_e) {
            /* ignore */
          }
        }
        if (parsed.length) {
          detail = {
            name: AutoDme.stripNegociavelSuffixFromDmeLabel(
              String($opt.attr('data-name') || $opt.text() || 'DME #' + sid)
            ),
            description: '',
            challenges: parsed.map((ch: any, idx: number) => ({
              challengeId: ch.challengeId || ch.id || idx + 1,
              name: ch.name,
              requirements: Array.isArray(ch.requirements) ? ch.requirements : [],
              awards: Array.isArray(ch.awards) ? ch.awards : [],
            })),
          };
        }
      }

      if (!detail || !Array.isArray(detail.challenges) || detail.challenges.length === 0) {
        const cnt = parseInt(String($opt.attr('data-challenges-count') || '0'), 10) || 0;
        if (cnt > 0) {
          const title = String($opt.attr('data-name') || $opt.text() || 'DME #' + sid);
          detail = {
            name: AutoDme.stripNegociavelSuffixFromDmeLabel(title),
            description: '',
            challenges: Array.from({ length: cnt }, (_: number, i: number) => ({
              challengeId: i + 1,
              name: null as string | null,
              requirements: [] as string[],
            })),
          };
        }
      }

      if (!detail || !Array.isArray(detail.challenges) || detail.challenges.length === 0) {
        $box.empty().addClass('d-none');
        return;
      }

      const $card = $('<div class="card border shadow-sm mt-2 mb-0 fsw-autodme-dme-resumo-card"/>');
      const $body = $('<div class="card-body"/>');
      const title = detail.name
        ? AutoDme.stripNegociavelSuffixFromDmeLabel(String(detail.name))
        : 'DME #' + sid;
      $body.append($('<div class="font-weight-600 mb-1 text-default fsw-autodme-resumo-title"/>').text(title));
      this.appendLimiteCicloResumo($body, $opt, detail);
      const detailDoMapa = !!AutoDme.getDmeDetailFromWindowMap(sid);
      if (!temRequisitosPorDesafio && !detailDoMapa) {
        $body.append(
          $('<p class="small text-muted mb-2"/>').text(
            'Exigências detalhadas não disponíveis. Recarregue a página para tentar carregar o catálogo completo.'
          )
        );
      }
      if (detail.description) {
        $body.append($('<p class="small text-muted mb-2 fsw-autodme-resumo-desc"/>').text(String(detail.description)));
      }
      const $challengesScroll = $('<div class="fsw-autodme-challenges-scroll"/>').css({
        maxHeight: 'min(44vh, 360px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingRight: '4px',
        marginRight: '-2px',
      });
      const $challengesWrap = $('<div class="fsw-autodme-challenges"/>');
      (detail.challenges as any[]).forEach((ch: any, idx: number) => {
        const nm = AutoDme.challengeDisplayName(ch, idx + 1);
        const $block = $('<div class="fsw-autodme-challenge-col border rounded bg-white"/>');
        $block.append(
          $('<div class="font-weight-600 text-dark fsw-autodme-challenge-name"/>')
            .text(nm)
            .attr('title', nm)
        );
        const awardRows = AutoDme.normalizeChallengeAwardRows(ch);
        if (awardRows.length) {
          const $awards = $('<div class="fsw-autodme-challenge-awards"/>');
          awardRows.slice(0, 3).forEach((award: { label: string; tag: string; tradable: boolean | null; title: string; imageUrl: string }) => {
            const $award = $('<div class="fsw-autodme-award-chip"/>').attr('title', award.title || award.label);
            if (award.imageUrl) {
              $award.append($('<img class="fsw-autodme-award-thumb"/>').attr({ src: award.imageUrl, alt: award.label }));
            } else {
              $award.append($('<i class="fas fa-gift fsw-autodme-award-icon"/>'));
            }
            const $copy = $('<div class="fsw-autodme-award-copy"/>');
            $copy.append($('<span class="fsw-autodme-award-label"/>').text(award.label));
            const $meta = $('<span class="fsw-autodme-award-meta"/>').text(award.tag);
            if (award.tradable === true) {
              $meta.append($('<b class="fsw-autodme-award-neg"/>').text('NEG'));
            } else if (award.tradable === false) {
              $meta.append($('<b class="fsw-autodme-award-ineg"/>').text('INEG'));
            }
            $copy.append($meta);
            $award.append($copy);
            $awards.append($award);
          });
          if (awardRows.length > 3) {
            $awards.append($('<div class="fsw-autodme-award-more"/>').text('+' + (awardRows.length - 3)));
          }
          $block.append($awards);
        }
        const reqRows = AutoDme.normalizeChallengeRequirementRows(ch);
        if (reqRows.length) {
          const $reqList = $('<ul class="list-unstyled mb-0 pl-0"/>');
          reqRows.forEach((row: { text: string; tag: string | null; displayText: string }) => {
            const border =
              row.tag === 'league'
                ? '#17a2b8'
                : row.tag === 'team'
                  ? '#5e72e4'
                  : row.tag === 'nation'
                    ? '#fb6340'
                    : row.tag === 'rating'
                      ? '#8898aa'
                      : '#dee2e6';
            const $li = $('<li class="fsw-autodme-req-line rounded bg-light"/>').css({
              borderLeftColor: border,
            });
            const $row = $('<div class="d-flex align-items-start"/>');
            const $pill = $('<span/>')
              .addClass('mr-2 flex-shrink-0 ' + AutoDme.requirementBadgeClassForTag(row.tag))
              .text(AutoDme.requirementTypeShortLabel(row.tag))
              .addClass('fsw-autodme-req-badge');
            const $txt = $('<div class="text-dark flex-grow-1 fsw-autodme-req-text"/>').text(
              row.displayText
            );
            if (row.displayText !== row.text) {
              $txt.attr('title', row.text);
            }
            $row.append($pill, $txt);
            $li.append($row);
            $reqList.append($li);
          });
          $block.append($reqList);
        } else {
          $block.append(
            $('<p class="small text-muted mb-0 font-italic"/>').text('Sem exigências listadas para este desafio.')
          );
        }
        $challengesWrap.append($block);
      });
      $challengesScroll.append($challengesWrap);
      $body.append($challengesScroll);
      $card.append($body);
      $box.empty().append($card).removeClass('d-none');
    }

    /** Resolve #id ou #id+suffix dentro do contexto (modal PRO ou #modoDme). */
    private $field($ctx: JQuery, baseId: string): JQuery {
      const suf = this.getDomIdSuffix($ctx);
      const full = suf ? baseId + suf : baseId;
      return $ctx.find('#' + full);
    }

    private numIn($ctx: JQuery, baseId: string): number {
      const $el = this.$field($ctx, baseId);
      if (!$el.length) return 0;
      const v = parseInt(String($el.val() || ''), 10);
      return Number.isFinite(v) ? v : 0;
    }

    private contextLimitaRepetirPorLimiteSolucoes($ctx: JQuery): boolean {
      const contexto = String($ctx.find('.configuracoes-auto-dme').first().attr('data-autodme-ui-context') || '');
      return contexto !== 'comum';
    }

    private syncRepetirComLimiteSolucoes($ctx: JQuery, persist: boolean = false): void {
      if (!$ctx || !$ctx.length) return;
      if (!this.contextLimitaRepetirPorLimiteSolucoes($ctx)) return;
      const limite = AutoDme.clampLimiteSolucoesDiarias(this.numIn($ctx, 'limite_solucoes_diarias'));
      const $rep = this.$field($ctx, 'repetir');
      if (!$rep.length) return;
      const atual = parseInt(String($rep.val() || '0'), 10) || 0;
      if (atual <= 0 || atual <= limite) return;
      const novo = AutoDme.clampRepetirDme(atual, limite);
      $rep.val(String(novo));
      this.$field($ctx, 'repetirLabel').text(String(novo));
      const slider = this.$field($ctx, 'sliderRepetir').get(0) as any;
      if (slider && slider.noUiSlider) {
        slider.noUiSlider.set(novo);
      }
      if (persist) {
        this.persistFieldChange('repetir');
      }
    }

    // =======================
    //         AÇÕES
    // =======================
    private validarCompatibilidadeCompraAutomatica(): boolean {
      const $comprarAutomaticamente = this.fieldByIdOrName('comprarJogadorAutomaticamente');
      if ($comprarAutomaticamente.prop('disabled') === true || !this.bool('comprarJogadorAutomaticamente') || !this.bool('excluirNegociaveis')) return true;

      const mensagem = 'Desative a opção "Não usar jogadores negociáveis" para que o sistema possa comprar jogadores negociáveis e usá-los na solução do desafio.';
      this.setStatus(mensagem, false);
      swal('Configurações incompatíveis', mensagem, 'warning');
      return false;
    }

    public resolver(): ResolverPayload | null {
      if (!this.validarCompatibilidadeCompraAutomatica()) return null;

      App.SniperExtensao.exibirLoadingSniperApp('<i class="fas " style="font-size: 34px;" title="Resolvendo aguarde...">🕔</i>', false, "Resolvendo aguarde...");
      const payload = this.buildPayload();
      console.log('Payload para resolver:', payload);
      if (!payload) return null;

      // Salva config no escopo atual (category + dme + tipoSolucao)
      const scope = this.getCurrentScopeKey();
      if (scope) this.saveCurrentConfigToStorage(scope);

      this.setStatus('Configuração gerada.', true);
      this.solucionarDmeNoWebApp(payload);
      return payload;
    }

    // =======================
    //      UI / DOM Binds
    // =======================
    private bindUI(): void {
      //toDo boato scanear escondido por enquanto
      this.elBtnScanearClube.hide();

      if (this.elSelectCategory.length) this.elSelectCategory.on('change', () => this.onCategoryChanged());
      if (this.elSelectDme.length) this.elSelectDme.on('change', () => this.onDmeSelected());
      if (this.elBtnResolver.length) this.elBtnResolver.on('click', () => this.resolver());
      if (this.elBtnCancelarSolucao.length) this.elBtnCancelarSolucao.on('click', () => this.cancelarSolucao());
      if (this.elBtnScanearClube.length) this.elBtnScanearClube.on('click', () => this.scanearClube());
      if (this.elTipoSolucao.length) this.elTipoSolucao.on('change', () => this.applyTipoSolucaoUi());
      if (this.elModoDme.length) {
        this.fieldByIdOrName('comprarJogadorAutomaticamente')
          .add(this.fieldByIdOrName('excluirNegociaveis'))
          .off('change.autoDmeCompraNegociaveis')
          .on('change.autoDmeCompraNegociaveis', () => this.validarCompatibilidadeCompraAutomatica());
        this.$field(this.elModoDme, 'espacoCamposLinksDme').on('change', 'input[id^="linkFutbin"]', () => this.salvarLinksFutbin());
        this.setupLimitesForragensUi(this.elModoDme);
      }

      this.setupNoUiSliders(this.elModoDme);
      this.setupSelect2ExcludeDme(this.elModoDme);
    }

    private setupLimitesForragensUi($ctx: JQuery): void {
      const $list = $ctx.find('.js-limites-forragens-list').first();
      if (!$list.length || $list.data('limites-forragens-bound')) return;
      $list.data('limites-forragens-bound', true);
      if (!$list.find('.js-limite-forragens-row').length) {
        this.renderLimitesForragens($list, []);
      }
      const persist = () => {
        const scope = this.getCurrentScopeKey();
        if (scope && $ctx.is(this.elModoDme)) {
          this.writeScope(scope, { limites_solucoes_por_forragens: AutoDme.lerLimitesForragensDoDom($ctx) });
        }
      };
      $ctx.find('.js-add-limite-forragens').off('click.limitesForragens').on('click.limitesForragens', () => {
        this.addLimiteForragensRow($list, { solucoes: 1, abaixo_de: 1000 });
        persist();
      });
      $list.on('click', '.js-remove-limite-forragens', function () {
        $(this).closest('.js-limite-forragens-row').remove();
        persist();
      });
      $list.on('change', 'input', persist);
    }

    private addLimiteForragensRow($list: JQuery, item: LimiteSolucoesPorForragens): void {
      const solucoes = Math.min(AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS, Math.max(0, Number(item.solucoes) || 0));
      const abaixoDe = Math.min(AutoDme.MAX_LIMITE_FORRAGENS_ABAIXO_DE, Math.max(1, Number(item.abaixo_de) || 1));
      $list.append(
        '<div class="js-limite-forragens-row d-flex align-items-center mb-2" style="gap:8px;">' +
        '<input type="number" class="form-control" data-limite-forragens-field="solucoes" min="0" max="100" step="1" value="' + String(solucoes) + '" placeholder="Solucoes">' +
        '<span class="text-muted font-size-12">abaixo de</span>' +
        '<input type="number" class="form-control" data-limite-forragens-field="abaixo_de" min="1" max="10000" step="1" value="' + String(abaixoDe) + '" placeholder="Forragens">' +
        '<button type="button" class="btn btn-sm btn-outline-danger js-remove-limite-forragens" title="Remover faixa">&times;</button>' +
        '</div>'
      );
    }

    private renderLimitesForragens($list: JQuery, limites: LimiteSolucoesPorForragens[]): void {
      $list.empty();
      AutoDme.normalizarLimitesSolucoesPorForragens(limites).forEach(item => this.addLimiteForragensRow($list, item));
    }

    private setupPrecoJogadorSlider($ctx: JQuery, fieldId: string, sliderId: string, labelId: string, fallback: number, skipPersist: boolean): void {
      const $input = this.$field($ctx, fieldId);
      const $label = this.$field($ctx, labelId);
      const $slider = this.$field($ctx, sliderId).get(0) as HTMLElement;
      if (!$input.length || !$slider || ($slider as any).noUiSlider) return;

      const inicial = AutoDme.normalizarPrecoJogador(this.numIn($ctx, fieldId) || fallback, fallback);
      $input.val(String(inicial));
      $label.text(inicial.toLocaleString('pt-BR'));

      noUiSlider.create($slider, {
        start: inicial,
        connect: [true, false],
        range: AutoDme.precoJogadorSliderRange(),
      });

      ($slider as any).noUiSlider.on('update', (values: string[]) => {
        const v = AutoDme.normalizarPrecoJogador(parseInt(values[0], 10), fallback);
        $input.val(String(v));
        $label.text(v.toLocaleString('pt-BR'));
      });
      ($slider as any).noUiSlider.on('change', (values: string[]) => {
        const v = AutoDme.normalizarPrecoJogador(parseInt(values[0], 10), fallback);
        ($slider as any).noUiSlider.set(v);
        $input.val(String(v));
        $label.text(v.toLocaleString('pt-BR'));
        if (!skipPersist) this.persistFieldChange(fieldId);
      });
    }

    /** noUiSlider + labels no escopo (#modoDme ou modal PRO). */
    private setupNoUiSliders($ctx: JQuery): void {
      if (!$ctx || !$ctx.length) return;
      if (typeof noUiSlider === 'undefined') return;
      const skipPersist = this.getDomIdSuffix($ctx) !== '';
      const minR = this.numIn($ctx, 'minimoRating') || 45;
      const maxR = this.numIn($ctx, 'maximoRating') || 89;
      const gastoDme = this.numIn($ctx, 'precoMaximoDesafio') || AutoDme.DEFAULT_GASTO_DME;

      const $sliderRating = this.$field($ctx, 'sliderRating').get(0) as HTMLElement;
      if ($sliderRating && !($sliderRating as any).noUiSlider) {
        noUiSlider.create($sliderRating, {
          start: [minR, maxR],
          connect: true,
          range: { min: 45, max: 99 },
          step: 1
        });
        ($sliderRating as any).noUiSlider.on('update', (values: string[]) => {
          const vMin = parseInt(values[0], 10);
          const vMax = parseInt(values[1], 10);
          this.$field($ctx, 'minimoRating').val(String(vMin));
          this.$field($ctx, 'maximoRating').val(String(vMax));
          this.$field($ctx, 'ratingMinLabel').text(String(vMin));
          this.$field($ctx, 'ratingMaxLabel').text(String(vMax));
        });
        ($sliderRating as any).noUiSlider.on('change', () => {
          if (!skipPersist) {
            this.persistFieldChange('minimoRating');
            this.persistFieldChange('maximoRating');
          }
        });
      }

      const $sliderGastoDme = this.$field($ctx, 'sliderGastoDme').get(0) as HTMLElement;
      if ($sliderGastoDme && !($sliderGastoDme as any).noUiSlider) {
        noUiSlider.create($sliderGastoDme, {
          start: gastoDme,
          connect: [true, false],
          range: { min: 0, max: AutoDme.MAX_GASTO_DME },
          step: 1000
        });
        ($sliderGastoDme as any).noUiSlider.on('update', (values: string[]) => {
          const v = parseInt(values[0], 10);
          this.$field($ctx, 'precoMaximoDesafio').val(String(v));
          this.$field($ctx, 'gastoDmeLabel').text(v.toLocaleString('pt-BR'));
        });
        ($sliderGastoDme as any).noUiSlider.on('change', () => {
          if (!skipPersist) this.persistFieldChange('precoMaximoDesafio');
        });
      }

      this.setupPrecoJogadorSlider(
        $ctx,
        'precoMaximoJogadorNegociavel',
        'sliderPrecoJogadorNegociavel',
        'precoJogadorNegociavelLabel',
        AutoDme.DEFAULT_PRECO_JOGADOR_NEGOCIAVEL,
        skipPersist
      );
      this.setupPrecoJogadorSlider(
        $ctx,
        'precoMaximoJogadorInegociavel',
        'sliderPrecoJogadorInegociavel',
        'precoJogadorInegociavelLabel',
        AutoDme.DEFAULT_PRECO_JOGADOR_INEGOCIAVEL,
        skipPersist
      );

      const limiteSolucoesInit = AutoDme.clampLimiteSolucoesDiarias(this.numIn($ctx, 'limite_solucoes_diarias'));
      const limiteRepetirInit = this.contextLimitaRepetirPorLimiteSolucoes($ctx) ? limiteSolucoesInit : undefined;
      const repetir = AutoDme.clampRepetirDme(this.numIn($ctx, 'repetir'), limiteRepetirInit);
      this.$field($ctx, 'repetir').val(String(repetir));
      this.$field($ctx, 'repetirLabel').text(String(repetir));
      const intervalo = Math.min(AutoDme.MAX_INTERVALO_REPETIR_MIN, Math.max(0, this.numIn($ctx, 'repetirIntervaloMinutos')));

      // Slider de "Tempo maximo de resolucao" removido em 15/08/2026: o campo virou fixo em
      // 3 min e agora e um input hidden no blade.

      const $sliderRepetir = this.$field($ctx, 'sliderRepetir').get(0) as HTMLElement;
      if ($sliderRepetir && !($sliderRepetir as any).noUiSlider) {
        noUiSlider.create($sliderRepetir, {
          start: repetir,
          connect: [true, false],
          range: { min: AutoDme.MIN_REPETIR_DME, max: AutoDme.MAX_REPETIR_DME },
          step: 1
        });
        ($sliderRepetir as any).noUiSlider.on('update', (values: string[]) => {
          const v = parseInt(values[0], 10);
          this.$field($ctx, 'repetir').val(String(v));
          this.$field($ctx, 'repetirLabel').text(String(v));
        });
        ($sliderRepetir as any).noUiSlider.on('change', () => {
          if (!skipPersist) this.persistFieldChange('repetir');
        });
      }

      const $sliderIntervalo = this.$field($ctx, 'sliderIntervalo').get(0) as HTMLElement;
      if ($sliderIntervalo && !($sliderIntervalo as any).noUiSlider) {
        noUiSlider.create($sliderIntervalo, {
          start: intervalo,
          connect: [true, false],
          range: { min: 0, max: AutoDme.MAX_INTERVALO_REPETIR_MIN },
          step: 1
        });
        ($sliderIntervalo as any).noUiSlider.on('update', (values: string[]) => {
          const v = parseInt(values[0], 10);
          this.$field($ctx, 'repetirIntervaloMinutos').val(String(v));
          this.$field($ctx, 'intervaloLabel').text(String(v));
        });
        ($sliderIntervalo as any).noUiSlider.on('change', () => {
          if (!skipPersist) this.persistFieldChange('repetirIntervaloMinutos');
        });
      }

      const $sliderLimiteSol = this.$field($ctx, 'sliderLimiteSolucoesDiarias').get(0) as HTMLElement;
      if ($sliderLimiteSol && !($sliderLimiteSol as any).noUiSlider) {
        const limiteInit = limiteSolucoesInit;
        noUiSlider.create($sliderLimiteSol, {
          start: limiteInit,
          connect: [true, false],
          range: {
            min: AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS,
            max: AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS
          },
          step: 1
        });
        ($sliderLimiteSol as any).noUiSlider.on('update', (values: string[]) => {
          const v = parseInt(values[0], 10);
          this.$field($ctx, 'limite_solucoes_diarias').val(String(v));
          this.$field($ctx, 'limiteSolucoesDiariasLabel').text(String(v));
          this.syncRepetirComLimiteSolucoes($ctx);
        });
        ($sliderLimiteSol as any).noUiSlider.on('change', () => {
          if (!skipPersist) {
            this.syncRepetirComLimiteSolucoes($ctx, true);
            this.persistFieldChange('limite_solucoes_diarias');
          }
        });
      }

      const $sliderLimiteTent = this.$field($ctx, 'sliderLimiteTentativasDia').get(0) as HTMLElement;
      if ($sliderLimiteTent && !($sliderLimiteTent as any).noUiSlider) {
        let limiteTentInit = this.numIn($ctx, 'limite_tentativas_dia') || AutoDme.DEFAULT_LIMITE_TENTATIVAS_DIA;
        limiteTentInit = Math.min(
          AutoDme.MAX_LIMITE_TENTATIVAS_DIA,
          Math.max(AutoDme.MIN_LIMITE_TENTATIVAS_DIA, limiteTentInit)
        );
        noUiSlider.create($sliderLimiteTent, {
          start: limiteTentInit,
          connect: [true, false],
          range: {
            min: AutoDme.MIN_LIMITE_TENTATIVAS_DIA,
            max: AutoDme.MAX_LIMITE_TENTATIVAS_DIA
          },
          step: 1
        });
        ($sliderLimiteTent as any).noUiSlider.on('update', (values: string[]) => {
          const v = parseInt(values[0], 10);
          this.$field($ctx, 'limite_tentativas_dia').val(String(v));
          this.$field($ctx, 'limiteTentativasDiaLabel').text(String(v));
        });
        ($sliderLimiteTent as any).noUiSlider.on('change', () => {
          if (!skipPersist) this.persistFieldChange('limite_tentativas_dia');
        });
      }

      // Sliders de scan do clube removidos em 15/08/2026: "Scanear Clube Apos N Falhas"
      // virou fixo em 0 e o limite diario / intervalo minimo migraram para o PERFIL da conta.
    }

    private setupSelect2ExcludeDme($ctx: JQuery): void {
      if (!$ctx || !$ctx.length) return;
      if (typeof (window as any).$.fn.select2 !== 'function') return;
      // O Select2 precisa do modal como parent para calcular a posicao correta dentro do scroll.
      let $dropdownParent: JQuery = $ctx.closest('.modal').first();
      if (!$dropdownParent.length) $dropdownParent = $ctx.closest('.modal-content').first();
      if (!$dropdownParent.length) $dropdownParent = $ctx;
      const readSelectedValues = ($el: JQuery): string[] => {
        const raw = $el.val();
        if (Array.isArray(raw)) return raw.map((x: any) => String(x)).filter((x: string) => x !== '');
        if (raw !== undefined && raw !== null && String(raw) !== '') return [String(raw)];
        const selected: string[] = [];
        $el.find('option:selected').each((_, opt) => {
          const v = String($(opt).val() || '');
          if (v) selected.push(v);
        });
        return selected;
      };
      const readSelectedLabels = ($el: JQuery): Record<string, string> => {
        const labels: Record<string, string> = {};
        $el.find('option:selected').each((_, opt) => {
          const $opt = $(opt);
          const v = String($opt.val() || '');
          if (v) labels[v] = String($opt.text() || ('#' + v));
        });
        return labels;
      };
      const ensureOptionsForValues = ($el: JQuery, values: string[], labels: Record<string, string>): void => {
        values.forEach((value) => {
          if (!value || $el.find('option[value="' + value + '"]').length) return;
          $el.append(new Option(labels[value] || ('#' + value), value, false, true));
        });
      };
      const fixDropdownPosition = ($el: JQuery): void => {
        window.setTimeout(() => {
          const $container = $el.next('.select2-container');
          const containerEl = $container.get(0);
          if (!containerEl) return;
          const rect = containerEl.getBoundingClientRect();
          if (!rect || rect.width <= 0) return;
          const $openDropdownContainer = $('.select2-container--open').filter((_, node) => {
            return $(node).find('.select2-dropdown').length > 0;
          }).last();
          if (!$openDropdownContainer.length) return;
          $openDropdownContainer.css({
            position: 'fixed',
            top: Math.round(rect.bottom) + 'px',
            left: Math.round(rect.left) + 'px',
            width: Math.round(rect.width) + 'px',
            zIndex: 1065
          });
          $openDropdownContainer.find('.select2-dropdown').css({ width: '100%' });
        }, 0);
      };
      const multiSelectIds = ['excludeLeagues', 'excludeNations', 'excludeTeams', 'excludeRarity', 'excludeRating'];
      multiSelectIds.forEach(id => {
        const $el = this.$field($ctx, id);
        if (!$el.length) {
          console.warn('[AutoDme] exclude multiselect não encontrado:', id);
          return;
        }
        const selectedValues = readSelectedValues($el);
        const selectedLabels = readSelectedLabels($el);
        if ($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');
        ensureOptionsForValues($el, selectedValues, selectedLabels);
        const placeholder = id === 'excludeRarity' ? 'Selecione raridades' : id === 'excludeRating' ? 'Selecione ratings' : 'Selecione...';
        const opts: any = { multiple: true, placeholder, width: '100%' };
        if ($dropdownParent.length) opts.dropdownParent = $dropdownParent;
        $el.select2(opts);
        $el.off('select2:open.autoDmeExclude').on('select2:open.autoDmeExclude', () => fixDropdownPosition($el));
        if (selectedValues.length) {
          $el.val(selectedValues).trigger('change').trigger('change.select2');
        }
      });
      const $players = this.$field($ctx, 'excludePlayers');
      if ($players.length) {
        const selectedValues = readSelectedValues($players);
        const selectedLabels = readSelectedLabels($players);
        if ($players.hasClass('select2-hidden-accessible')) $players.select2('destroy');
        ensureOptionsForValues($players, selectedValues, selectedLabels);
        const playerOpts: any = {
          multiple: true,
          placeholder: 'Buscar jogador por nome...',
          width: '100%',
          ajax: {
            url: '/players.json',
            dataType: 'json',
            delay: 200,
            data: (params: any) => ({ q: params.term || '' }),
            processResults: (data: any, params: any) => {
              const list = (data.Players || []).map((p: any) => ({
                id: p.id,
                text: (p.c || ((p.f || '') + ' ' + (p.l || '')).trim()).trim() || String(p.id)
              }));
              const term = (params.term || '').toLowerCase();
              const filtered = term ? list.filter((x: any) => x.text.toLowerCase().indexOf(term) !== -1) : list;
              return { results: filtered.slice(0, 80) };
            }
          },
          minimumInputLength: 0
        };
        if ($dropdownParent.length) playerOpts.dropdownParent = $dropdownParent;
        $players.select2(playerOpts);
        $players.off('select2:open.autoDmeExclude').on('select2:open.autoDmeExclude', () => fixDropdownPosition($players));
        if (selectedValues.length) {
          if (App && App.Util && typeof App.Util.hidratarSelectExcludePlayersComNomes === 'function') {
            App.Util.hidratarSelectExcludePlayersComNomes($players, selectedValues);
          }
          $players.val(selectedValues).trigger('change').trigger('change.select2');
        }
      }
    }

    /** Inicializa sliders/select2/toggles e monta UI do DME selecionado no modal PRO. */
    /**
     * "Não usar jogadores especiais" e "OVR máx. p/ carta especial" sao MUTUAMENTE EXCLUSIVOS:
     * um tira as especiais do pool, o outro amplia o teto de overall so para elas — pedidos
     * opostos. Ligar um zera e desabilita o outro.
     *
     * O checkbox desabilitado continua sendo lido corretamente no submit porque
     * `Util.normalizarPayloadSalvarAutodme` le `.prop('checked')` explicitamente; o campo
     * numerico desabilitado nao e enviado e cai no default 0 do servidor, que e justamente o
     * valor que a trava impoe.
     */
    private aplicarTravaEspeciaisVsOvr($modal: JQuery, origem: 'especiais' | 'ovr' | 'inicial'): void {
      const $especiais = $modal.find('.js-autodme-excluir-especiais');
      const $ovr = $modal.find('.js-autodme-ovr-especial');
      if (!$especiais.length || !$ovr.length) return;

      const especiaisLigado = $especiais.prop('checked') === true;
      const ovrValor = parseInt(String($ovr.val() || ''), 10);
      const ovrAtivo = isFinite(ovrValor) && ovrValor > 0;

      if (origem === 'especiais' && especiaisLigado) {
        $ovr.val('0');
      } else if (origem === 'ovr' && ovrAtivo) {
        $especiais.prop('checked', false);
      }

      const especiaisFinal = $especiais.prop('checked') === true;
      const ovrFinalValor = parseInt(String($ovr.val() || ''), 10);
      const ovrFinalAtivo = isFinite(ovrFinalValor) && ovrFinalValor > 0;

      $ovr.prop('disabled', especiaisFinal);
      $especiais.prop('disabled', ovrFinalAtivo);
    }

    private bindTravaEspeciaisVsOvr($modal: JQuery): void {
      $modal
        .off('change.autoDmeEspeciaisOvr', '.js-autodme-excluir-especiais')
        .on('change.autoDmeEspeciaisOvr', '.js-autodme-excluir-especiais', () => {
          this.aplicarTravaEspeciaisVsOvr($modal, 'especiais');
        });
      $modal
        .off('input.autoDmeEspeciaisOvr change.autoDmeEspeciaisOvrNum', '.js-autodme-ovr-especial')
        .on('input.autoDmeEspeciaisOvr change.autoDmeEspeciaisOvrNum', '.js-autodme-ovr-especial', () => {
          this.aplicarTravaEspeciaisVsOvr($modal, 'ovr');
        });
      this.aplicarTravaEspeciaisVsOvr($modal, 'inicial');
    }

    private initProModal($modal: JQuery): void {
      if (!$modal || !$modal.length) return;
      if (!$modal.find('.conteudo-form-resolver-dme').length) return;
      if ($modal.data('autoDmeProInited')) {
        window.setTimeout(() => $modal.trigger('autodme:pro-modal-ready'), 0);
        return;
      }

      const $dmeSel = $modal.find('.js-select-dme-autodme-pro');
      this.ensureDmesDetailMapLoaded(() => {
        if ($modal.data('autoDmeProInited')) return;
        $modal.data('autoDmeProInited', 1);
        this.setupNoUiSliders($modal);
        this.setupSelect2ExcludeDme($modal);
        this.setupLimitesForragensUi($modal);
        this.initProDmeSelect2($modal, $dmeSel);

        const applyDom = () => { AutoDme.applyTipoSolucaoUiProModal($modal); };
        $modal.find('select[name="tipoSolucao"]').off('change.autoDmePro').on('change.autoDmePro', applyDom);
        $dmeSel.off('change.autoDmePro').on('change.autoDmePro', () => {
          // Troca explícita do usuário: re-deriva os limites do ciclo pela EA.
          this.onDmeSelectedPro($modal, true);
        });
        this.bindTravaEspeciaisVsOvr($modal);

        applyDom();
        const v = String($dmeSel.val() || '');
        if (v) this.onDmeSelectedPro($modal);
        $modal.trigger('autodme:pro-modal-ready');
        window.setTimeout(() => $modal.trigger('autodme:pro-modal-ready'), 0);
      });
    }

    private initProDmeSelect2($modal: JQuery, $dmeSel: JQuery): void {
      if (!$dmeSel.length) return;
      if ($dmeSel.data('fswSelect2Dme')) return;
      const w: any = window as any;
      if (typeof w.jQuery === 'undefined' || typeof ($dmeSel as any).select2 !== 'function') return;
      if ($dmeSel.hasClass('select2-hidden-accessible')) {
        try { ($dmeSel as any).select2('destroy'); } catch (_e) { /* ignore */ }
      }
      const self = this;
      ($dmeSel as any).select2({
        width: '100%',
        dropdownParent: $modal,
        containerCssClass: 'fsw-select2-dme-autodme-wrap',
        dropdownCssClass: 'fsw-select2-dme-autodme-dropdown',
        escapeMarkup: (m: string) => m,
        templateResult: (data: any) => AutoDme.formatDmeSelect2State(data, false),
        templateSelection: (data: any) => AutoDme.formatDmeSelect2State(data, true),
      });
      $dmeSel.data('fswSelect2Dme', 1);
      $dmeSel.off('select2:open.autoDmeProDropH').on('select2:open.autoDmeProDropH', () => {
        window.setTimeout(() => {
          const $dlg = $modal.find('.modal-dialog').first();
          const dlgH = $dlg.outerHeight() || 0;
          let cap =
            dlgH > 160
              ? Math.floor(dlgH - 110)
              : Math.floor(Math.min(window.innerHeight * 0.68, 560));
          cap = Math.max(300, Math.min(cap, window.innerHeight - 96));
          const $ro = $modal.find(
            '.select2-dropdown.fsw-select2-dme-autodme-dropdown .select2-results__options'
          );
          if ($ro.length) {
            $ro.css('max-height', cap + 'px');
          }
        }, 0);
      });
      $dmeSel.off('select2:select.autoDmePro').on('select2:select.autoDmePro', () => {
        // Troca explícita do usuário: re-deriva os limites do ciclo pela EA.
        self.onDmeSelectedPro($modal, true);
      });
    }

    /** Inicializa sliders/select2 e visibilidade por tipo de solução ao abrir modal PRO (cadastrar / resolver). */
    private bindProAutodmeModals(): void {
      console.log('bindProAutodmeModals');
      const self = this;
      $(document).on('shown.bs.modal', '.modal', function () {
        console.log('shown.bs.modal');
        const $m = $(this);
        if (!$m.find('.conteudo-form-resolver-dme').length) {
          return;
        }
        const alreadyInited = !!$m.data('autoDmeProInited');
        self.initProModal($m);
        if (alreadyInited) {
          const $dmeSel = $m.find('.js-select-dme-autodme-pro');
          console.log('dmeSel', $dmeSel);
          const vid = String($dmeSel.val() || '');
          if (vid) {
            self.ensureDmesDetailMapLoaded(() => {
              self.onDmeSelectedPro($m);
            });
          }
        }
      });

      // Robustez: alguns fluxos podem abrir o modal antes do JS terminar.
      $('.modal.show, .modal[aria-hidden="false"]').each((_: number, el: Element) => {
        const $el = $(el);
        if ($el.find('.conteudo-form-resolver-dme').length) {
          self.initProModal($el);
        }
      });
    }

    /** Visibilidade de campos por tipo (1/2/3) só no DOM — sem persistência (formulários PRO). */
    public static applyTipoSolucaoUiProModal($modal: JQuery): void {
      const $cfg = $modal.find('.config-dme-root').first();
      if (!$cfg.length) return;
      const tipoSolucao = parseInt(String($modal.find('select[name="tipoSolucao"]').val()), 10) || 1;
      const linksFutbin = tipoSolucao === 3;

      if (tipoSolucao === 2) {
        $cfg.removeClass('tipo-interna-hide-solucao-externa');
        $modal.find('.config-visible-interna-only').css('display', '');
      } else {
        $cfg.addClass('tipo-interna-hide-solucao-externa');
        $modal.find('[id^="usarSomenteJogadoresClube"]').prop('checked', false);
      }

      if (tipoSolucao === 2) {
        $cfg.removeClass('auto-dme-tipo-nao-interna');
      } else {
        $cfg.addClass('auto-dme-tipo-nao-interna');
        $modal.find('[id^="excludeAtivoNoElenco"]').prop('checked', false);
        $modal.find('[id^="excluirEspeciais"]').prop('checked', false);
        $modal.find('[id^="excluirNegociaveis"]').prop('checked', false);
        $modal.find('[id^="minimoRating"]').val('45');
        $modal.find('[id^="maximoRating"]').val('99');
      }

      if (linksFutbin) {
        $cfg.addClass('tipo-links-futbin');
        $modal.find('[id^="menuLinksFutbin"]').show();
        $modal.find('.config-visible-interna-rapida:not(.config-visible-links-futbin)').hide();
        $modal.find('.config-visible-links-futbin').show();
        $modal.find('[id^="usarDuplicatas"]').prop('checked', true);
        $modal.find('[id^="excluirEspeciais"]').prop('checked', false);
        $modal.find('[id^="excluirNegociaveis"]').prop('checked', false);
      } else {
        $cfg.removeClass('tipo-links-futbin');
        $modal.find('.config-visible-interna-rapida').show();
        $modal.find('.config-visible-links-futbin').show();
        $modal.find('[id^="tab-simples"]').parent().show();
        $modal.find('[id^="tab-avancado"]').parent().show();
        $modal.find('[id^="menuLinksFutbin"]').hide();
      }

      $modal.find('[id^="wrapTempoMaximoSolucao"]').toggle(tipoSolucao === 2);

      const hasPills = $modal.find('[id^="form-desafios-dme"] input[name="desafios_dme[]"]').length > 0;
      const $rowDes = $modal.find('[id^="row-desafios-dme"]');
      if (tipoSolucao === 3) {
        $rowDes.hide();
      } else if (hasPills) {
        $rowDes.show();
      } else {
        $rowDes.hide();
      }
    }

    /** Sincroniza slider de limite diário (PRO com sufixo ou #modoDme sem sufixo, se existir). */
    private syncLimiteSolucoesSlider($ctx: JQuery): void {
      if (!$ctx || !$ctx.length) return;
      const suf = this.getDomIdSuffix($ctx);
      const sliderId = 'sliderLimiteSolucoesDiarias' + (suf ? suf : '');
      const el = document.getElementById(sliderId) as any;
      if (!el || !el.noUiSlider) return;
      const lim = AutoDme.clampLimiteSolucoesDiarias(this.numIn($ctx, 'limite_solucoes_diarias'));
      this.patchSingleSliderRange(
        sliderId,
        AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS,
        AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS,
        lim
      );
      this.$field($ctx, 'limiteSolucoesDiariasLabel').text(String(lim));
      this.syncRepetirComLimiteSolucoes($ctx);
    }

    /** Sincroniza slider de limite de falhas/ciclo EA por DME (default 10). */
    private syncLimiteTentativasDiaSlider($ctx: JQuery): void {
      if (!$ctx || !$ctx.length) return;
      const suf = this.getDomIdSuffix($ctx);
      const sliderId = 'sliderLimiteTentativasDia' + (suf ? suf : '');
      const el = document.getElementById(sliderId) as any;
      if (!el || !el.noUiSlider) return;
      let lim = this.numIn($ctx, 'limite_tentativas_dia') || AutoDme.DEFAULT_LIMITE_TENTATIVAS_DIA;
      lim = Math.min(
        AutoDme.MAX_LIMITE_TENTATIVAS_DIA,
        Math.max(AutoDme.MIN_LIMITE_TENTATIVAS_DIA, lim)
      );
      this.patchSingleSliderRange(
        sliderId,
        AutoDme.MIN_LIMITE_TENTATIVAS_DIA,
        AutoDme.MAX_LIMITE_TENTATIVAS_DIA,
        lim
      );
      this.$field($ctx, 'limiteTentativasDiaLabel').text(String(lim));
    }
    // syncEscanearClubeAposFalhasSlider / syncIntervaloMinutosScanClubeAutoDmeSlider /
    // syncLimiteScansClubeDiaAutoDmeSlider removidos em 15/08/2026 junto com os sliders.

    /** Ajusta range de slider de um único valor (após migração de limites no localStorage). */
    private patchSingleSliderRange(elementId: string, min: number, max: number, value: number): void {
      const el = document.getElementById(elementId) as any;
      if (!el || !el.noUiSlider) return;
      const clamped = Math.min(max, Math.max(min, value));
      try {
        el.noUiSlider.updateOptions({ range: { min, max } }, false);
      } catch { /* noUiSlider antigo: range já correto na criação */ }
      el.noUiSlider.set(clamped);
    }

    private syncSlidersFromInputs(): void {
      const minR = this.num('minimoRating') || 45;
      const maxR = this.num('maximoRating') || 89;
      const gastoDme = this.num('precoMaximoDesafio') || AutoDme.DEFAULT_GASTO_DME;
      const precoJogadorNegociavel = AutoDme.normalizarPrecoJogador(this.num('precoMaximoJogadorNegociavel') || AutoDme.DEFAULT_PRECO_JOGADOR_NEGOCIAVEL, AutoDme.DEFAULT_PRECO_JOGADOR_NEGOCIAVEL);
      const precoJogadorInegociavel = AutoDme.normalizarPrecoJogador(this.num('precoMaximoJogadorInegociavel') || AutoDme.DEFAULT_PRECO_JOGADOR_INEGOCIAVEL, AutoDme.DEFAULT_PRECO_JOGADOR_INEGOCIAVEL);
      const limiteSolucoes = AutoDme.clampLimiteSolucoesDiarias(this.num('limite_solucoes_diarias'));
      const repetir = AutoDme.clampRepetirDme(this.num('repetir'));
      let intervalo = this.num('repetirIntervaloMinutos');
      intervalo = Math.min(AutoDme.MAX_INTERVALO_REPETIR_MIN, Math.max(0, intervalo));
      $('#precoMaximoJogadorNegociavel').val(String(precoJogadorNegociavel));
      $('#precoMaximoJogadorInegociavel').val(String(precoJogadorInegociavel));
      $('#repetir').val(String(repetir));
      $('#limite_solucoes_diarias').val(String(limiteSolucoes));
      $('#repetirIntervaloMinutos').val(String(intervalo));
      const sliderRating = document.getElementById('sliderRating') as any;
      const sliderGastoDme = document.getElementById('sliderGastoDme') as any;
      const sliderPrecoJogadorNegociavel = document.getElementById('sliderPrecoJogadorNegociavel') as any;
      const sliderPrecoJogadorInegociavel = document.getElementById('sliderPrecoJogadorInegociavel') as any;
      const sliderRepetir = document.getElementById('sliderRepetir') as any;
      const sliderIntervalo = document.getElementById('sliderIntervalo') as any;
      const sliderLimiteSolucoes = document.getElementById('sliderLimiteSolucoesDiarias') as any;
      if (sliderRating && sliderRating.noUiSlider) sliderRating.noUiSlider.set([minR, maxR]);
      if (sliderGastoDme && sliderGastoDme.noUiSlider) sliderGastoDme.noUiSlider.set(gastoDme);
      if (sliderPrecoJogadorNegociavel && sliderPrecoJogadorNegociavel.noUiSlider) sliderPrecoJogadorNegociavel.noUiSlider.set(precoJogadorNegociavel);
      if (sliderPrecoJogadorInegociavel && sliderPrecoJogadorInegociavel.noUiSlider) sliderPrecoJogadorInegociavel.noUiSlider.set(precoJogadorInegociavel);
      if (sliderRepetir && sliderRepetir.noUiSlider) {
        this.patchSingleSliderRange('sliderRepetir', AutoDme.MIN_REPETIR_DME, AutoDme.MAX_REPETIR_DME, repetir);
      }
      if (sliderIntervalo && sliderIntervalo.noUiSlider) {
        this.patchSingleSliderRange('sliderIntervalo', 0, AutoDme.MAX_INTERVALO_REPETIR_MIN, intervalo);
      }
      if (sliderLimiteSolucoes && sliderLimiteSolucoes.noUiSlider) {
        this.patchSingleSliderRange('sliderLimiteSolucoesDiarias', AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS, AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS, limiteSolucoes);
      }
      $('#ratingMinLabel').text(String(minR));
      $('#ratingMaxLabel').text(String(maxR));
      $('#gastoDmeLabel').text(gastoDme.toLocaleString('pt-BR'));
      $('#precoJogadorNegociavelLabel').text(precoJogadorNegociavel.toLocaleString('pt-BR'));
      $('#precoJogadorInegociavelLabel').text(precoJogadorInegociavel.toLocaleString('pt-BR'));
      $('#repetirLabel').text(String(repetir));
      $('#limiteSolucoesDiariasLabel').text(String(limiteSolucoes));
      $('#intervaloLabel').text(String(intervalo));
    }

    // ---------- salva/recupera último categories (DMEs) ----------
    private readLastDmes(): ICategoriaDme[] {
      try {
        const raw = localStorage.getItem(`${this.storageNS}:lastDmes`);
        const obj = raw ? JSON.parse(raw) : null;
        // compat: pode ter sido salvo { categories: [...] } ou diretamente [...]
        if (obj && Array.isArray(obj)) return obj as ICategoriaDme[];
        if (obj && Array.isArray(obj.categories)) return obj.categories as ICategoriaDme[];
        return [];
      } catch { return []; }
    }

    private writeLastDmes(cats: ICategoriaDme[] | { categories: ICategoriaDme[] }): void {
      try {
        const toSave = Array.isArray(cats) ? cats : (cats && cats.categories ? cats.categories : []);
        localStorage.setItem(`${this.storageNS}:lastDmes`, JSON.stringify(toSave));
      } catch { /* ignore */ }
    }

    // ---------- restauração de última seleção (categoria/dme) ----------
    private getLastSelection(): { categoryId?: string; setId?: string } {
      try {
        const raw = localStorage.getItem(`${this.storageNS}:lastSelection`);
        return raw ? JSON.parse(raw) : {};
      } catch { return {}; }
    }

    private setLastSelection(sel: { categoryId?: string; setId?: string }) {
      const prev = this.getLastSelection();
      localStorage.setItem(
        `${this.storageNS}:lastSelection`,
        JSON.stringify({ ...prev, ...sel })
      );
    }

    // ---------- selects ----------
    private populateCategorySelect(): void {
      if (!this.elSelectCategory.length) return;

      // Se não há dados carregados, tenta usar o último salvo
      if (!this.categoriaDmes || this.categoriaDmes.length === 0) {
        const cached = this.readLastDmes();
        if (cached && cached.length > 0) {
          console.log('Restaurando categorias/DMEs do storage (lastDmes).');
          this.categoriaDmes = cached;
        }
      }

      // limpa mantendo placeholder
      this.elSelectCategory.find('option:not(:first)').remove();

      // Verifica se existe o DME inicial disponível em alguma categoria
      const categoriaDoInicial = (this.categoriaDmes || []).find(cat =>
        Array.isArray(cat.sets) &&
        cat.sets.some(s => String(s.setId) === String(this.dmeIdInicial) && !s.timesCompleted)
      );

      const categoriasParaMostrar = categoriaDoInicial ? [categoriaDoInicial] : (this.categoriaDmes || []);

      // popula apenas as categorias permitidas
      categoriasParaMostrar.forEach((cat: ICategoriaDme) => {
        const rawName = cat.name != null ? String(cat.name) : '';
        const label = rawName.toUpperCase();
        const $opt = $('<option/>', {
          value: String(cat.categoryId),
          text: label,
        }).attr('data-name', rawName);
        this.elSelectCategory.append($opt);
      });

      // tenta restaurar seleção anterior (categoria + dme)
      const { categoryId, setId } = this.getLastSelection();

      if (categoryId && this.elSelectCategory.find(`option[value="${categoryId}"]`).length) {
        // seta categoria sem disparar change automaticamente
        this.elSelectCategory.val(categoryId);

        const catIdNum = parseInt(String(categoryId), 10);
        this.populateDmeSelect(Number.isFinite(catIdNum) ? catIdNum : null);

        // tenta restaurar DME
        if (setId && this.elSelectDme.find(`option[value="${setId}"]`).length) {
          this.elSelectDme.val(setId);
          // atualiza header e restaura config por DME
          this.onDmeSelected();
        } else {
          this.clearHeader();
        }
      } else {
        // sem restauração válida
        this.clearHeader();
        this.elSelectDme.prop('disabled', true).val('');
      }
    }

    private onCategoryChanged(): void {
      // Salva config do conjunto anterior antes de trocar
      const prevScope = this.scopeKeyForSelection(
        this.lastCategoryId,
        this.lastDmeId,
        this.lastTipoSolucao
      );
      if (this.lastDmeId) this.saveCurrentConfigToStorage(prevScope);

      const catId = this.getSelectedCategoryId();
      console.log('Categoria selecionada:', catId, this.categoriaDmes);

      this.lastCategoryId = catId != null ? String(catId) : '';
      this.lastDmeId = '';

      this.setLastSelection({ categoryId: this.lastCategoryId, setId: '' });

      this.clearHeader();
      this.populateDmeSelect(catId);
    }

    private populateDmeSelect(categoryId: number | null): void {
      if (!this.elSelectDme.length) return;

      this.elSelectDme.prop('disabled', true);
      this.elSelectDme.find('option:not(:first)').remove();
      if (categoryId == null) return;

      const cat = this.categoriaDmes.find((c: any) => Number(c.categoryId) === Number(categoryId));
      if (!cat || !Array.isArray(cat.sets)) return;

      // Base: só DMEs não concluídos
      const setsElegiveis = cat.sets.filter((s: any) => AutoDme.dmeElegivelParaSelecao(s));

      // Regra 2: se o DME inicial está na lista, SOMENTE ele pode ser selecionado
      const temDmeInicial = setsElegiveis.some((s: any) => String(s.setId) === String(this.dmeIdInicial));
      const listaFinal = temDmeInicial
        ? setsElegiveis.filter((s: any) => String(s.setId) === String(this.dmeIdInicial))
        : setsElegiveis;

      listaFinal.forEach((set: any) => {
        const $opt = $('<option/>', {
          value: String(set.setId),
          text: set.name
        })
          .attr('data-name', set.name)
          .attr('data-image', this.buildSetImageUrl(set.setId))
          .attr('data-repeatable', AutoDme.dmePermiteRepeticaoUi(set) ? 'Repeatable' : 'Non-Repeatable')
          .attr('data-repeatability-mode', set.repeatabilityMode != null ? String(set.repeatabilityMode) : '')
          .attr('data-tradable-count', set.tradableRewardsCount != null ? String(set.tradableRewardsCount) : '0')
          .attr('data-challenges-count', String(this.effectiveChallengesCount(set) || 0))
          .attr('data-challenges', JSON.stringify(set.challenges || []))
          .attr('data-remaining', this.humanizeRemaining(set.endTime))
          .attr('data-cost', '—');
        this.elSelectDme.append($opt);
      });

      this.elSelectDme.prop('disabled', false);

      // Se o inicial existe, já força seleção nele e atualiza UI/config.
      if (temDmeInicial) {
        this.elSelectDme.val(String(this.dmeIdInicial));
        // salva seleção e atualiza header/config do DME selecionado
        this.setLastSelection({ setId: String(this.dmeIdInicial) });
        this.onDmeSelected();
      }
    }

    private appendDmeOptionsToSelect($sel: JQuery, listaFinal: any[]): void {
      if (!$sel.length) return;
      const rawValue = $sel.val();
      const selectedValue = Array.isArray(rawValue)
        ? (rawValue.length ? String(rawValue[0]) : '')
        : (rawValue != null ? String(rawValue) : '');
      $sel.prop('disabled', true);
      $sel.find('option:not(:first)').remove();
      listaFinal.forEach((set: any) => {
        const $opt = $('<option/>', {
          value: String(set.setId),
          text: set.name
        })
          .attr('data-name', set.name)
          .attr('data-image', this.buildSetImageUrl(set.setId))
          .attr('data-repeatable', AutoDme.dmePermiteRepeticaoUi(set) ? 'Repeatable' : 'Non-Repeatable')
          .attr('data-repeatability-mode', set.repeatabilityMode != null ? String(set.repeatabilityMode) : '')
          .attr('data-tradable-count', set.tradableRewardsCount != null ? String(set.tradableRewardsCount) : '0')
          .attr('data-challenges-count', String(this.effectiveChallengesCount(set) || 0))
          .attr('data-challenges', JSON.stringify(set.challenges || []))
          .attr('data-remaining', this.humanizeRemaining(set.endTime))
          .attr('data-cost', '—');
        if (set.autodmeDefaultConfig && typeof set.autodmeDefaultConfig === 'object') {
          $opt.attr('data-autodme-default-config', JSON.stringify(set.autodmeDefaultConfig));
          $opt.attr('data-tem-autodme-default-admin', set._temAutodmeDefaultConfigAdmin ? '1' : '0');
        }
        $sel.append($opt);
      });
      if (selectedValue) {
        const existe = $sel.find('option').filter((_: number, option: Element) => String($(option).val()) === selectedValue).length > 0;
        $sel.val(existe ? selectedValue : '');
      }
      $sel.prop('disabled', false);
      if (selectedValue) {
        $sel.trigger('change.select2');
      }
    }

    /** Reaplica UI do DME em modais PRO após atualização de categorias (monta challenges/links). */
    private refreshProModalsOnDmesUpdate(): void {
      const $sels = $('.js-select-dme-autodme-pro');
      const visited: Element[] = [];
      $sels.each((_: number, el: Element) => {
        const $modal = $(el).closest('.modal');
        if (!$modal.length) return;
        const modalEl = $modal.get(0) as Element;
        if (visited.indexOf(modalEl) !== -1) return;
        visited.push(modalEl);

        const val = String($modal.find('.js-select-dme-autodme-pro').val() || '');
        if (!val) return;

        this.initProModal($modal);
        this.onDmeSelectedPro($modal);
      });
    }

    /**
     * Modo PRO (sem categoria): popula o select-dme com uma lista única (flatten de sets).
     * Mantém a regra de “forçar DME inicial” quando ele existir na lista.
     * Também atualiza todos os `.js-select-dme-autodme-pro` nos modais (IDs com sufixo).
     */
    private populateDmeSelectAsListUnique(): void {
      const allSets: any[] = [];
      (this.categoriaDmes || []).forEach((cat: any) => {
        if (!cat || !Array.isArray(cat.sets)) return;
        cat.sets.forEach((s: any) => allSets.push(s));
      });

      const setsElegiveis = allSets.filter((s: any) => AutoDme.dmeElegivelParaSelecao(s));
      const temDmeInicial = setsElegiveis.some((s: any) => String(s.setId) === String(this.dmeIdInicial));
      const listaFinal = temDmeInicial
        ? setsElegiveis.filter((s: any) => String(s.setId) === String(this.dmeIdInicial))
        : setsElegiveis;

      $('.js-select-dme-autodme-pro').each((_: number, el: Element) => {
        this.appendDmeOptionsToSelect($(el), listaFinal);
      });

      if (!this.elSelectDme.length) return;

      this.appendDmeOptionsToSelect(this.elSelectDme, listaFinal);

      if (temDmeInicial) {
        this.elSelectDme.val(String(this.dmeIdInicial));
        this.setLastSelection({ setId: String(this.dmeIdInicial) });
        this.onDmeSelected();
        return;
      }

      const { setId } = this.getLastSelection();
      if (setId && this.elSelectDme.find(`option[value="${setId}"]`).length) {
        this.elSelectDme.val(setId);
        this.setLastSelection({ setId: String(setId) });
        this.onDmeSelected();
      }
    }

    private getSelectedCategoryId(): number | null {
      const v = this.elSelectCategory.val();
      if (v == null || v === '') return null;
      const n = parseInt(String(v), 10);
      return Number.isFinite(n) ? n : null;
    }

    private buildSetImageUrl(setId: string | null): string {
      if (!setId) return '';
      return `https://cdn.futnext.com/sbc/set/${setId}.png`;
    }

    /** Duração em segundos (ex. repeatRefreshInterval) em texto curto para o painel de info. */
    private humanizeDurationSeconds(sec: number): string {
      if (!sec || sec <= 0) return '—';
      const d = Math.floor(sec / 86400);
      const h = Math.floor((sec % 86400) / 3600);
      const m = Math.floor((sec % 3600) / 60);
      if (d > 0) return d === 1 ? '1 dia' : `${d} dias`;
      if (h > 0) return `${h} h`;
      if (m > 0) return `${m} min`;
      return `${sec} s`;
    }

    private humanizeRemaining(endTime: number | null): string {
      if (!endTime || endTime <= 0) return '—';
      // Timestamp Unix (s ou ms) vs segundos restantes (legado)
      let secsRemaining = endTime;
      if (endTime > 1e12) {
        secsRemaining = Math.max(0, Math.floor(endTime / 1000 - Date.now() / 1000));
      } else if (endTime > 1e9) {
        secsRemaining = Math.max(0, Math.floor(endTime - Date.now() / 1000));
      }
      const mins = Math.floor(secsRemaining / 60);
      const days = Math.floor(mins / (60 * 24));
      const remMins = mins % (60 * 24);
      const hours = Math.floor(remMins / 60);
      const minutes = remMins % 60;
      const parts: string[] = [];
      if (days) parts.push(`${days}d`);
      if (hours) parts.push(`${hours}h`);
      if (minutes) parts.push(`${minutes}m`);
      return parts.length ? parts.join(' ') : `${mins}m`;
    }

    private salvarLinksFutbin(): void {
      const links = App.Util.obterLinksFutbin();
      localStorage.setItem('linksFutbin', JSON.stringify(links));
      const tipo = parseInt(String(this.elTipoSolucao.val()), 10) || 1;
      if (tipo === 3) {
        const scope = this.getCurrentScopeKey();
        if (scope) {
          this.writeScope(scope, {
            excludedChallengeIndices: this.excludedChallengeIndicesFromLinksFutbin(links),
          });
        }
      }
    }

    /**
     * Índices 1..n como em desafios_dme[]: desafio sem URL (false / vazio) = excluído.
     */
    private excludedChallengeIndicesFromLinksFutbin(linksArr: (string | false)[]): number[] {
      const excluded: number[] = [];
      linksArr.forEach((cell, i) => {
        if (cell === false || typeof cell !== 'string' || !String(cell).trim()) {
          excluded.push(i + 1);
        }
      });
      return excluded.sort((a, b) => a - b);
    }

    /** Oculta pills de desafio no tipo 3 (links definem o que entra na resolução). */
    private syncRowDesafiosVisibility(): void {
      const tipo = parseInt(String(this.elTipoSolucao.val()), 10) || 1;
      const hasPills = $('#form-desafios-dme input[name="desafios_dme[]"]').length > 0;
      if (tipo === 3) {
        $('#row-desafios-dme').hide();
      } else if (hasPills) {
        $('#row-desafios-dme').show();
      } else {
        $('#row-desafios-dme').hide();
      }
    }

    /** Objeto do set atualmente selecionado no select (ou null). */
    private getSelectedDmeObject(): IConjuntoDme | null {
      return this.getSelectedDmeObjectFromSelect(this.elSelectDme);
    }

    /** Contagem de desafios: campo numérico ou tamanho do array `challenges`. */
    private effectiveChallengesCount(dme: any): number {
      if (!dme) return 0;
      const raw = dme.challengesCount;
      const n =
        typeof raw === 'number' && Number.isFinite(raw)
          ? raw
          : parseInt(String(raw != null && raw !== '' ? raw : '0'), 10);
      if (Number.isFinite(n) && n > 0) return n;
      const ch = dme.challenges;
      if (Array.isArray(ch) && ch.length > 0) return ch.length;
      return 0;
    }

    /** Localiza o set no catálogo PRO injetado em `categoriaDmes` (bootstrap / extensão). */
    private findSetInCategoriaDmes(setId: string): any {
      let out: any = null;
      (this.categoriaDmes || []).forEach((cat: ICategoriaDme) => {
        if (!cat || !Array.isArray(cat.sets)) return;
        cat.sets.forEach((set: any) => {
          if (out) return;
          if (String(set.setId) === String(setId)) {
            out = set;
          }
        });
      });
      return out;
    }

    private readChallengesMetaFromOption($opt: JQuery): { count: number; challenges: any[] } {
      const challengesCountRaw = $opt.attr('data-challenges-count');
      const parsedCount = parseInt(String(challengesCountRaw || '0'), 10);
      const challengesCount = Number.isFinite(parsedCount) ? parsedCount : 0;
      const challengesJson = $opt.attr('data-challenges');
      let challenges: any[] = [];
      if (challengesJson) {
        try {
          const parsed = JSON.parse(String(challengesJson));
          if (Array.isArray(parsed)) challenges = parsed;
        } catch { /* ignore */ }
      }
      const countFromArray = challenges.length;
      const count = challengesCount > 0 ? challengesCount : countFromArray;
      return { count, challenges };
    }

    private getSelectedDmeObjectFromSelect($select: JQuery): IConjuntoDme | null {
      const currentVal = String($select.val() || '');
      if (!currentVal) return null;
      let found: IConjuntoDme = null;
      (this.categoriaDmes || []).forEach((cat: ICategoriaDme) => {
        if (!cat || !Array.isArray(cat.sets)) return;
        cat.sets.forEach((set: IConjuntoDme) => {
          if (found) return;
          if (String(set.setId) === String(currentVal)) found = set;
        });
      });

      const $opt = $select.find('option:selected').first();
      const optMeta = this.readChallengesMetaFromOption($opt);

      if (found) {
        const merged: any = { ...found };
        const arrRaw = merged.challenges;
        const arr = Array.isArray(arrRaw) ? arrRaw : [];
        const detailChallenges = AutoDme.detailChallengesFromSetId(currentVal);
        const rawCc = merged.challengesCount;
        const countField =
          typeof rawCc === 'number' && Number.isFinite(rawCc) && rawCc > 0
            ? rawCc
            : parseInt(String(rawCc != null && rawCc !== '' ? rawCc : '0'), 10) || 0;
        const targetCount = Math.max(countField, optMeta.count, arr.length, optMeta.challenges.length, detailChallenges.length);

        let challengesOut: any[] = [];
        if (AutoDme.challengesHaveDisplayNames(arr)) {
          challengesOut = arr.slice();
        } else if (AutoDme.challengesHaveDisplayNames(detailChallenges)) {
          challengesOut = detailChallenges.slice();
        } else if (optMeta.challenges.length) {
          challengesOut = optMeta.challenges.slice();
        } else if (arr.length) {
          challengesOut = arr.slice();
        } else if (detailChallenges.length) {
          challengesOut = detailChallenges.slice();
        } else if (targetCount > 0) {
          challengesOut = Array.from({ length: targetCount }, (_: number, i: number) => ({
            challengeId: i + 1,
            name: null as string | null,
          }));
        }

        merged.challenges = challengesOut;
        merged.challengesCount = Math.max(targetCount, challengesOut.length);
        return merged as IConjuntoDme;
      }

      // Fallback PRO: categorias vazias ou set fora da lista — usa data-* da <option>.
      const challengesCount = optMeta.count;
      const challenges = optMeta.challenges;
      const detailChallenges = AutoDme.detailChallengesFromSetId(currentVal);

      if (challengesCount > 0 || (challenges && challenges.length > 0) || detailChallenges.length > 0) {
        const repeatableRaw = $opt.attr('data-repeatable');
        const repeatabilityMode = String($opt.attr('data-repeatability-mode') || '');
        const repeatable = repeatableRaw === 'Repeatable' || repeatableRaw === 'true';
        const nameRaw = String($opt.attr('data-name') || $opt.text() || '').trim();
        const nCh = Math.max(challengesCount, challenges.length, detailChallenges.length);
        let chList: any[] = [];
        if (AutoDme.challengesHaveDisplayNames(challenges)) {
          chList = challenges.slice();
        } else if (AutoDme.challengesHaveDisplayNames(detailChallenges)) {
          chList = detailChallenges.slice();
        } else if (challenges && challenges.length) {
          chList = challenges.slice();
        } else if (detailChallenges.length) {
          chList = detailChallenges.slice();
        }
        if (nCh > 0 && chList.length === 0) {
          chList = Array.from({ length: nCh }, (_: number, i: number) => ({
            challengeId: i + 1,
            name: null as string | null,
          }));
        }
        const minimal: any = {
          setId: parseInt(String(currentVal), 10),
          name: nameRaw || null,
          repeatable: AutoDme.dmePermiteRepeticaoUi({ repeatable, repeatabilityMode }),
          repeatabilityMode,
          challengesCount: nCh,
          challenges: chList,
          endTime: null
        };
        return minimal as IConjuntoDme;
      }

      return null;
    }

    /** Painel `.espaco-info-dme` — uma linha curta (rótulo: valor). */
    private renderDmeInfoDetalhes(dme: IConjuntoDme | null): void {
      const $box = $('#dme-info-detalhes');
      if (!$box.length) return;
      if (!dme) {
        $box.empty().addClass('d-none');
        return;
      }
      const segs: string[] = [];
      const chTotal = this.effectiveChallengesCount(dme);
      const chDone = dme.challengesCompletedCount != null ? dme.challengesCompletedCount : 0;
      if (chTotal > 0) {
        segs.push(chDone >= chTotal ? 'Concluído ✅' : 'Desaf. ' + chDone + '/' + chTotal);
      }
      const timesTot = dme.timesCompleted != null ? dme.timesCompleted : 0;
      segs.push('Total ' + timesTot + '×');
      if (AutoDme.dmePermiteRepeticaoUi(dme)) {
        const ti = dme.timesCompletedInInterval;
        const rp = dme.repeats;
        if (ti != null && rp != null) {
          segs.push('Hoje ' + ti + '/' + rp);
        } else if (ti != null) {
          segs.push('Hoje ' + ti);
        } else if (rp != null) {
          segs.push('Máx. ' + rp);
        }
        if (dme.repeatRefreshInterval && dme.repeatRefreshInterval > 0) {
          segs.push('↻ ' + this.humanizeDurationSeconds(dme.repeatRefreshInterval));
        }
      }
      if (dme.lastCompletedTime && dme.lastCompletedTime > 0) {
        const raw = dme.lastCompletedTime;
        const ms = raw > 1e12 ? raw : raw * 1000;
        const dt = new Date(ms);
        if (!isNaN(dt.getTime())) {
          segs.push(
            'Últ. ' +
            dt.toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            })
          );
        }
      }
      $box
        .text(segs.join(' · '))
        .removeClass('d-none');
    }

    /**
     * Campos repetir / intervalo só fazem sentido para DME repetível.
     * Quando oculto, zera valores e persiste no escopo atual.
     */
    private applyRepetirConfigVisibility(repeatable: boolean): void {
      const $w = $('#wrapRepetirDmeConfig');
      if (!$w.length) return;
      if (repeatable) {
        $w.removeClass('d-none');
        const rAtual = this.num('repetir');
        if (rAtual < AutoDme.MIN_REPETIR_DME) {
          $('#repetir').val(String(AutoDme.MIN_REPETIR_DME));
          $('#repetirLabel').text(String(AutoDme.MIN_REPETIR_DME));
          this.syncSlidersFromInputs();
          const sc = this.getCurrentScopeKey();
          if (sc) {
            this.writeScope(sc, { repetir: AutoDme.MIN_REPETIR_DME });
          }
        }
      } else {
        $w.addClass('d-none');
        $('#repetir').val('0');
        $('#repetirIntervaloMinutos').val('0');
        $('#repetirLabel').text('0');
        $('#intervaloLabel').text('0');
        this.syncSlidersFromInputs();
        const scope = this.getCurrentScopeKey();
        if (scope) {
          this.writeScope(scope, { repetir: 0, repetirIntervaloMinutos: 0 });
        }
      }
      this.syncLimitesConfigVisibility();
    }

    private syncLimitesConfigVisibility(): void {
      const $tituloLimites = $('#wrapLimitesDmeConfig');
      if (!$tituloLimites.length) return;
      // "repetir" mudou para a aba Opcoes principais (secao "Limite deste DME"), entao nao conta mais aqui.
      const tempoVisivel = $('#modoDme').find('[id^="wrapTempoMaximoSolucao"]').filter(function () {
        return $(this).is(':visible');
      }).length > 0;
      if (tempoVisivel) {
        $tituloLimites.removeClass('d-none');
      } else {
        $tituloLimites.addClass('d-none');
      }
    }

    private limparLinksFutbin(): void {
      // Limpa os campos de input
      const container = document.getElementById('espacoCamposLinksDme');
      if (container) {
        const inputs: any = container.querySelectorAll('input[id^="linkFutbin"]');
        inputs.forEach((input: any) => {
          (input as HTMLInputElement).value = '';
        });
      }
      // Limpa o localStorage
      localStorage.removeItem('linksFutbin');
    }

    private onDmeSelected(): void {
      const $opt = this.elSelectDme.find('option:selected');
      const dmeId = this.elSelectDme.val();

      if (!$opt.length || !dmeId) {
        this.clearHeader();
        this.lastDmeId = '';
        this.setLastSelection({ setId: '' });
        return;
      }

      const catId = this.getSelectedCategoryId();
      const tipo = parseInt(String(this.elTipoSolucao.val()), 10) || 1;

      // Salva config do conjunto anterior antes de trocar
      if (this.lastDmeId) {
        const prevScope = this.scopeKeyForSelection(
          this.lastCategoryId,
          this.lastDmeId,
          this.lastTipoSolucao
        );
        this.saveCurrentConfigToStorage(prevScope);
      }

      if (this.dmeAtual && this.dmeAtual != dmeId) {
        this.limparLinksFutbin();
      }

      this.dmeAtual = dmeId;
      this.lastCategoryId = catId != null ? String(catId) : '';
      this.lastDmeId = String(dmeId);
      this.lastTipoSolucao = tipo;

      // Hard-guard adicional: se o inicial está na lista, força seleção nele
      const existeInicialNoSelect = this.elSelectDme.find(`option[value="${this.dmeIdInicial}"]`).length > 0;
      if (existeInicialNoSelect && String(dmeId) !== String(this.dmeIdInicial)) {
        this.elSelectDme.val(String(this.dmeIdInicial));
      }

      const currentVal = String(this.elSelectDme.val() || '');
      this.setLastSelection({ setId: currentVal });

      const dmeObj = this.getSelectedDmeObject();

      console.log('DME selecionado (objeto completo):', dmeObj);

      // limpe a div#espacoCamposLinksDme e crie campos de links para o Futbin de acordo com dmeObj.challengesCount
      // se dmeObj.challengesCount for 0 ou nulo, não cria nada, se existir cria a quantidade de campos input de acordo dmeObj.challengesCount
      const $linksContainer = $('#espacoCamposLinksDme');
      $linksContainer.empty();

      const savedLinks = this.getSavedLinksFutbin();

      const challenges: Array<{ id?: number; challengeId?: number; name?: string }> =
        AutoDme.challengesForPills(dmeObj, dmeId);
      const nChallenges = this.effectiveChallengesCount(dmeObj);
      if (dmeObj && nChallenges > 0) {
        for (let i = 0; i < nChallenges; i++) {
          const ch = challenges[i];
          const labelText = AutoDme.challengeDisplayName(ch, i + 1);
          const $group = $('<div/>', { class: 'form-group mb-2' });
          const $label = $('<label/>', { for: `linkFutbin${i}`, class: "form-control-label font-weight-600", text: labelText });
          const saved = savedLinks[i];
          const $input = $('<input/>', {
            type: 'text',
            class: 'form-control',
            id: `linkFutbin${i}`,
            name: `link_desafio_futbin_${i}`,
            placeholder: `https://www.futbin.com/squad/...`,
            value: typeof saved === 'string' && saved ? saved : ''
          });
          $group.append($label).append($input);
          $linksContainer.append($group);
        }
      }

      // Pills de desafios (desmarcar = excluir da resolução)
      const $desafiosContainer = $('#form-desafios-dme');
      $desafiosContainer.empty();
      const $rowDesafios = $('#row-desafios-dme');
      if (dmeObj && nChallenges > 0) {
        $rowDesafios.show();
        const scope = this.scopeKeyForSelection(this.lastCategoryId, this.lastDmeId, this.lastTipoSolucao);
        const savedData = this.readScope(scope);
        const savedExcluded: number[] = Array.isArray(savedData.excludedChallengeIndices) ? savedData.excludedChallengeIndices : [];
        const challengesForPills = AutoDme.challengesForPills(dmeObj, dmeId);
        for (let n = 1; n <= nChallenges; n++) {
          const ch = challengesForPills[n - 1] || null;
          const checked = savedExcluded.indexOf(n) === -1;
          $desafiosContainer.append(AutoDme.createChallengePill(ch, n, checked));
        }
      } else {
        $rowDesafios.hide();
      }

      if (!dmeObj) {
        this.clearHeader();
        return;
      }

      // Atualiza header com dados do objeto
      this.setText(this.elTitle, dmeObj.name);
      this.setText(this.elSubtitle, '');
      this.setText(this.elRepeatable, AutoDme.dmePermiteRepeticaoUi(dmeObj) ? 'Repetível' : 'Único');
      this.setText(this.elRemaining, this.humanizeRemaining(dmeObj.endTime));
      this.setText(this.elCost, '—');
      this.renderDmeInfoDetalhes(dmeObj);

      // usa setImageId para montar a URL correta
      if (this.elImg.length) {
        const imgUrl = this.buildSetImageUrl(dmeObj.setId != null ? String(dmeObj.setId) : null);
        if (imgUrl) this.elImg.attr('src', imgUrl).removeClass('d-none');
        else this.elImg.addClass('d-none').removeAttr('src');
      }

      const selectedId = String(dmeObj.setId);
      const ehDmeInicial = String(selectedId) === String(this.dmeIdInicial);
      const scope = this.scopeKeyForSelection(this.lastCategoryId, this.lastDmeId, this.lastTipoSolucao);
      if (ehDmeInicial) {
        this.applySavedConfigForScope(scope);
        // Não bloqueia mais campos quando o DME inicial (setId=1) está selecionado.
        this.applyInitialDmeUi(false);
      } else {
        this.applySavedConfigForScope(scope);
        this.applyInitialDmeUi(false);
      }
      this.applyTipoSolucaoUi();
      this.applyRepetirConfigVisibility(AutoDme.dmePermiteRepeticaoUi(dmeObj));
      this.syncRowDesafiosVisibility();
    }

    /** Fluxo de seleção de DME dentro de modal PRO (IDs com sufixo; sem depender do #modoDme). */
    /**
     * @param derivarLimitesDaEa `true` apenas quando o USUÁRIO troca o DME no select. Nos demais
     * caminhos (abertura/rehidratação do modal) os valores salvos do registro têm que prevalecer.
     */
    private onDmeSelectedPro($modal: JQuery, derivarLimitesDaEa: boolean = false): void {
      const $sel = $modal.find('.js-select-dme-autodme-pro');
      const suf = this.getDomIdSuffix($modal);
      const idSuf = suf ? suf : '';
      const $opt = $sel.find('option:selected');
      const dmeId = $sel.val();

      if (!$opt.length || !dmeId) {
        $modal.find('[id^="row-desafios-dme"]').hide();
        $modal.find('.js-autodme-dme-resumo').empty().addClass('d-none');
        $modal.trigger('autodme:pro-dme-rendered');
        return;
      }

      const dmeObj = this.getSelectedDmeObjectFromSelect($sel);
      console.log('dmeObj', dmeObj);
      const $linksContainer = $modal.find('[id^="espacoCamposLinksDme"]');
      $linksContainer.empty();

      const savedLinks = this.getSavedLinksFutbin();
      const challenges: Array<{ id?: number; challengeId?: number; name?: string }> = AutoDme.challengesForPills(dmeObj, dmeId);
      const nChallenges = this.effectiveChallengesCount(dmeObj);
      if (dmeObj && nChallenges > 0) {
        for (let i = 0; i < nChallenges; i++) {
          const ch = challenges[i];
          const labelText = AutoDme.challengeDisplayName(ch, i + 1);
          const inputId = 'linkFutbin' + i + idSuf;
          const $group = $('<div/>', { class: 'form-group mb-2' });
          const $label = $('<label/>', { for: inputId, class: 'form-control-label font-weight-600', text: labelText });
          const saved = savedLinks[i];
          const $input = $('<input/>', {
            type: 'text',
            class: 'form-control',
            id: inputId,
            name: 'link_desafio_futbin_' + i,
            placeholder: 'https://www.futbin.com/squad/...',
            value: typeof saved === 'string' && saved ? saved : ''
          });
          $group.append($label).append($input);
          $linksContainer.append($group);
        }
      }

      const $desafiosContainer = $modal.find('[id^="form-desafios-dme"]');
      $desafiosContainer.empty();
      const $rowDesafios = $modal.find('[id^="row-desafios-dme"]');
      if (dmeObj && nChallenges > 0) {
        $rowDesafios.show();
        for (let n = 1; n <= nChallenges; n++) {
          const ch = challenges[n - 1] || null;
          $desafiosContainer.append(AutoDme.createChallengePill(ch, n, true));
        }
      } else {
        $rowDesafios.hide();
      }
      AutoDme.reaplicarDesafiosELinksSalvosModalPro($modal, dmeId);

      if (!dmeObj) {
        $modal.trigger('autodme:pro-dme-rendered');
        return;
      }

      if (this.elTitle.length) {
        this.setText(this.elTitle, dmeObj.name);
        this.setText(this.elSubtitle, '');
        this.setText(this.elRepeatable, AutoDme.dmePermiteRepeticaoUi(dmeObj) ? 'Repetível' : 'Único');
        this.setText(this.elRemaining, this.humanizeRemaining(dmeObj.endTime));
        this.setText(this.elCost, '—');
        this.renderDmeInfoDetalhes(dmeObj);
        if (this.elImg.length) {
          const imgUrl = this.buildSetImageUrl(dmeObj.setId != null ? String(dmeObj.setId) : null);
          if (imgUrl) this.elImg.attr('src', imgUrl).removeClass('d-none');
          else this.elImg.addClass('d-none').removeAttr('src');
        }
      }

      if (derivarLimitesDaEa) {
        this.aplicarLimitesCicloEaPro($modal, $opt, AutoDme.getDmeDetailFromWindowMap(String(dmeId)));
      }
      this.applyRepetirConfigVisibilityPro($modal, AutoDme.dmePermiteRepeticaoUi(dmeObj));
      AutoDme.applyTipoSolucaoUiProModal($modal);
      this.syncLimiteSolucoesSlider($modal);
      this.syncLimiteTentativasDiaSlider($modal);
      // Recalcula a trava especiais x OVR: os valores podem ter mudado pelo config padrao do DME.
      this.aplicarTravaEspeciaisVsOvr($modal, 'inicial');
      $modal.trigger('autodme:pro-dme-rendered');
      this.ensureDmesDetailMapLoaded(() => {
        this.renderDmeResumoPro($modal, String(dmeId));
      });
    }

    /**
     * Deriva "Soluções máximas deste DME Hoje" e "Solucionar o DME quantas vezes em sequência?"
     * do que a EA permite no ciclo. Espelha `AutodmeDefaultConfigService::repeticoesPermitidasNoCiclo()`
     * — único → 1; `UNLIMITED` → máximo do campo; `REFRESH`/`LIMITED` → `min(repeats, teto)`.
     *
     * Fonte: `data-repeats` / `data-repeatability-mode` do <option> (com fallback para o detalhe
     * em FSW_DMES_DETAIL_BY_SET_ID). Antes de 15/08/2026 esses campos ficavam presos em 1 porque
     * `repeats` nem chegava ao catálogo do Web.
     *
     * SÓ deve rodar quando o usuário TROCA o DME no select: ao reabrir o modal de um registro já
     * salvo, os valores escolhidos por ele têm que prevalecer.
     */
    private aplicarLimitesCicloEaPro($modal: JQuery, $opt: JQuery, detail: any): void {
      const modo = String(
        $opt.attr('data-repeatability-mode') || (detail && detail.repeatabilityMode) || ''
      ).toUpperCase();
      const repeatsAttr = String($opt.attr('data-repeats') || '');
      const repeatsBruto = repeatsAttr !== ''
        ? repeatsAttr
        : (detail && detail.repeats != null ? String(detail.repeats) : '');
      const repeats = parseInt(repeatsBruto, 10);

      let limite = 1;
      let repetir = 1;
      if (modo === 'UNLIMITED') {
        limite = AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS;
        repetir = AutoDme.MAX_REPETIR_DME;
      } else if (modo !== 'NON_REPEATABLE' && isFinite(repeats) && repeats > 0) {
        limite = Math.min(repeats, AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS);
        repetir = Math.min(repeats, AutoDme.MAX_REPETIR_DME);
      }

      const suf = this.getDomIdSuffix($modal);
      this.$field($modal, 'limite_solucoes_diarias').val(String(limite));
      this.$field($modal, 'limiteSolucoesDiariasLabel').text(String(limite));
      this.patchSingleSliderRange(
        'sliderLimiteSolucoesDiarias' + (suf ? suf : ''),
        AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS,
        AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS,
        limite
      );
      this.$field($modal, 'repetir').val(String(repetir));
      this.$field($modal, 'repetirLabel').text(String(repetir));
      this.patchSingleSliderRange(
        'sliderRepetir' + (suf ? suf : ''),
        AutoDme.MIN_REPETIR_DME,
        AutoDme.MAX_REPETIR_DME,
        repetir
      );
    }

    private applyRepetirConfigVisibilityPro($modal: JQuery, repeatable: boolean): void {
      const $w = this.$field($modal, 'wrapRepetirDmeConfig');
      if (!$w.length) return;
      if (repeatable) {
        $w.removeClass('d-none');
        const rAtual = this.numIn($modal, 'repetir');
        if (rAtual < AutoDme.MIN_REPETIR_DME) {
          this.$field($modal, 'repetir').val(String(AutoDme.MIN_REPETIR_DME));
          this.$field($modal, 'repetirLabel').text(String(AutoDme.MIN_REPETIR_DME));
        }
      } else {
        $w.addClass('d-none');
        this.$field($modal, 'repetir').val('0');
        this.$field($modal, 'repetirIntervaloMinutos').val('0');
        this.$field($modal, 'repetirLabel').text('0');
        this.$field($modal, 'intervaloLabel').text('0');
      }
    }

    private getSavedLinksFutbin(): (string | false)[] {
      try {
        const raw = localStorage.getItem('linksFutbin');
        if (!raw) return [];
        const p = JSON.parse(raw);
        if (Array.isArray(p)) {
          return p.map((x: any) =>
            typeof x === 'string' && x.trim() ? x.trim() : false
          );
        }
      } catch { /* legado objeto ignorado */ }
      return [];
    }

    private applyInitialDmeUi(isInitial: boolean): void {
      const $configWrapper = $('#config-dme');
      const $all = $configWrapper.find('input, select, textarea');
      const $keep = $('#excluirNegociaveis, #abrirPacksInegociaveisAutomaticamente');

      if (isInitial) {
        $all.not($keep).prop('disabled', true)
          .closest('.form-group, .d-flex, .col').css('opacity', 0.3);
        $keep.prop('disabled', false)
          .closest('.form-group, .d-flex, .col').css('opacity', 1);

      } else {
        $all.prop('disabled', false)
          .closest('.form-group, .d-flex, .col').css('opacity', 1);
      }
    }



    private buildPayload(): ResolverPayload | null {
      const $opt = this.elSelectDme.find('option:selected');
      const val = this.elSelectDme.val();
      if (!$opt.length || val == null || val === '') {
        this.setStatus('Selecione um DME antes de resolver.', false);
        return null;
      }

      const tipoSolucaoPre = parseInt(String($('#tipoSolucao').val()), 10) || 1;
      const linksFutbinArr = App.Util.obterLinksFutbin();
      const links: DmeLinks | null =
        tipoSolucaoPre === 3 && linksFutbinArr.length > 0 ? linksFutbinArr : null;

      let excludedChallengeIndices: number[] = [];
      if (tipoSolucaoPre === 3) {
        excludedChallengeIndices = this.excludedChallengeIndicesFromLinksFutbin(linksFutbinArr);
      } else {
        $('#form-desafios-dme input[name="desafios_dme[]"]:not(:checked)').each(function () {
          const v = parseInt(String($(this).val()), 10);
          if (Number.isFinite(v)) excludedChallengeIndices.push(v);
        });
        excludedChallengeIndices.sort((a, b) => a - b);
      }

      const dme: DmePayload = {
        setId: this.parseIntSafe(String(val)),
        name: $opt.attr('data-name') || null,
        links,
        excludedChallengeIndices: excludedChallengeIndices.length > 0 ? excludedChallengeIndices : undefined,
      };

      // tipoSolucao: 1=externa, 2=interna, 3=links
      const tipoSolucao = tipoSolucaoPre;
      const linksFutbin = tipoSolucao === 3;
      const solucaoInterna = tipoSolucao === 2;

      const dmeMeta = this.getSelectedDmeObject();
      const dmeRepeatable = AutoDme.dmePermiteRepeticaoUi(dmeMeta);

      const limiteSolucoesDiariasBase = AutoDme.clampLimiteSolucoesDiarias(this.num('limite_solucoes_diarias'));
      const limitesForragens = AutoDme.lerLimitesForragensDoDom(this.elModoDme);
      const repetirVal = dmeRepeatable
        ? AutoDme.clampRepetirDme(this.num('repetir'))
        : 0;
      const limiteSolucoesDiarias = Math.max(limiteSolucoesDiariasBase, repetirVal || limiteSolucoesDiariasBase);
      const limiteTentativasDia = Math.min(
        AutoDme.MAX_LIMITE_TENTATIVAS_DIA,
        Math.max(AutoDme.MIN_LIMITE_TENTATIVAS_DIA, this.num('limite_tentativas_dia') || AutoDme.DEFAULT_LIMITE_TENTATIVAS_DIA)
      );
      // Valores fixos desde 15/08/2026 (sairam do formulario). O limite diario e o intervalo
      // minimo de scan do clube nao vao mais daqui: sao configuracao do PERFIL da conta e o
      // servidor os injeta no payload (WebApp.anexarContextoTravaScanClubeAutoDme).
      const escanearClubeAposFalhas = AutoDme.ESCANEAR_CLUBE_APOS_FALHAS_FIXO;
      const tempoResVal = AutoDme.TEMPO_RESOLUCAO_FIXO_MIN;
      const rigorSolucao = AutoDme.RIGOR_SOLUCAO_FIXO;
      const aplicaFiltrosManuais = tipoSolucao !== 3;
      const usarSomenteJogadoresClube = aplicaFiltrosManuais ? this.bool('usarSomenteJogadoresClube') : false;
      const usarConceitos = !usarSomenteJogadoresClube;
      const precoMaximoJogadorNegociavel = AutoDme.normalizarPrecoJogador(
        this.fieldByIdOrName('precoMaximoJogadorNegociavel').val(),
        AutoDme.DEFAULT_PRECO_JOGADOR_NEGOCIAVEL
      );
      const precoMaximoJogadorInegociavel = AutoDme.normalizarPrecoJogador(
        this.fieldByIdOrName('precoMaximoJogadorInegociavel').val(),
        AutoDme.DEFAULT_PRECO_JOGADOR_INEGOCIAVEL
      );
      const precoMaximoJogadorNegociavelEfetivo = linksFutbin
        ? Math.max(precoMaximoJogadorNegociavel, AutoDme.PRECO_JOGADOR_LINKS_EXTERNOS)
        : precoMaximoJogadorNegociavel;

      const cfg: ConfiguracaoPayload = {
        repetir: repetirVal,
        repetirIntervaloMinutos: 0,
        limite_solucoes_diarias: limiteSolucoesDiarias,
        limites_solucoes_por_forragens: limitesForragens.length ? limitesForragens : undefined,
        limite_tentativas_dia: limiteTentativasDia,
        tentar_ate_limite_antes_de_pular: false,
        executar_somente_quando_dme_anteriores_finalizados: false,
        escanear_clube_apos_falhas: escanearClubeAposFalhas,
        tipoSolucao,
        rigorSolucao,
        quantidadeSolucoesColetadas: 2,

        excluirNegociaveis: aplicaFiltrosManuais ? this.bool('excluirNegociaveis') : false,
        excluirEspeciais: aplicaFiltrosManuais ? this.bool('excluirEspeciais') : false,

        usarConceitos,

        minimoRating: solucaoInterna ? this.num('minimoRating') : 45,
        maximoRating: solucaoInterna ? this.num('maximoRating') : 99,
        // OVR máx. p/ carta ESPECIAL: amplia o teto só p/ especiais (0 = desligado).
        maximoRatingCartaEspecial: this.num('maximo_rating_carta_especial') || 0,
        tempoMaximoResolucaoMinutos: solucaoInterna ? tempoResVal : 3,

        usarDuplicatas: true,
        abrirPacksInegociaveisAutomaticamente: this.bool('abrirPacksInegociaveisAutomaticamente'),
        abrirPacksNegociaveisAutomaticamente: this.bool('abrirPacksNegociaveisAutomaticamente'),
        enviarAutomaticamente: this.bool('enviarAutomaticamente'),

        precoMaximoDesafio: this.num('precoMaximoDesafio'),
        precoMaximoJogadorNegociavel: precoMaximoJogadorNegociavelEfetivo,
        precoMaximoJogadorInegociavel,

        comprarJogadorSomenteNaCertezaDeSolucao: true,
        comprarJogadorAutomaticamente: this.bool('comprarJogadorAutomaticamente'),
        permitir_execucao_descanso_sniper: this.bool('permitirExecucaoDescansoSniper') || this.boolByName('permitir_execucao_descanso_sniper'),
        exigir_todos_desafios_viaveis: this.bool('exigirTodosDesafiosViaveis') || this.boolByName('exigir_todos_desafios_viaveis'),
        atualizar_setid_por_nome_dme: this.bool('atualizarSetIdPorNomeDme') || this.boolByName('atualizar_setid_por_nome_dme'),
        incluir_exigencias_dme_em_exclusoes_inteligentes: this.bool('incluir_exigencias_dme_em_exclusoes_inteligentes') || this.boolByName('incluir_exigencias_dme_em_exclusoes_inteligentes'),
        dmeBase: solucaoInterna ? this.bool('dmeBase') : false,
        retentativasAntesDeFecharWebApp: 2,
        forcarSolucaoACadaRetentativa: false,
        aumentarRatingAposCadaTentativa: 0,
        aumentarPrecoJogadorAposCadaTentativa: 0,

        enviarImediatamenteSeEstiverPronto: this.bool('enviarAutomaticamente'),
        forcarNovaSolucao: true,

        excludeAtivoNoElenco: aplicaFiltrosManuais ? this.bool('excludeAtivoNoElenco') : false,
        excludeLeagues: aplicaFiltrosManuais ? this.arr('excludeLeagues') : [],
        excludeNations: aplicaFiltrosManuais ? this.arr('excludeNations') : [],
        excludeTeams: aplicaFiltrosManuais ? this.arr('excludeTeams') : [],
        excludeRarity: aplicaFiltrosManuais ? this.arr('excludeRarity') : [],
        excludeRating: aplicaFiltrosManuais ? this.arr('excludeRating') : [],
        excludePlayers: aplicaFiltrosManuais ? this.arr('excludePlayers') : [],
        dimensoes_exclusoes_inteligentes: aplicaFiltrosManuais ? this.dimensoesExclusoesInteligentes(this.elModoDme) : [],
        ignorar_exclusoes_para_carta_especial: aplicaFiltrosManuais ? AutoDme.lerIgnorarExclusoesCartaEspecial(this.elModoDme) : [],
        tentarSolucaoExternaSeNaoEncontrarInterna: solucaoInterna
          ? this.bool('tentarSolucaoExternaSeNaoEncontrarInterna')
          : false,
        selecionarItensPlayerPick: false,
        // Na versao comum aplica em rapida/inteligente; Links Futbin mantem filtros manuais desligados.
        usarSomenteJogadoresClube
      };

      return { dme, configuracao: cfg };
    }

    private clearHeader(): void {
      this.setText(this.elTitle, '');
      this.setText(this.elSubtitle, '');
      this.setText(this.elRepeatable, '—');
      this.setText(this.elRemaining, '—');
      this.setText(this.elCost, '—');
      this.renderDmeInfoDetalhes(null);
      this.applyRepetirConfigVisibility(false);
      if (this.elImg.length) {
        this.elImg.addClass('d-none').removeAttr('src');
      }
    }

    private setText($el: JQuery, text: string): void {
      if ($el && $el.length) $el.text(text);
    }

    private setStatus(msg: string, ok: boolean): void {
      if (!this.elStatus.length) return;
      this.elStatus
        .text(msg)
        .removeClass('text-red-600 text-green-600')
        .addClass(ok ? 'text-green-600' : 'text-red-600');
    }

    private fieldByIdOrName(id: string): JQuery {
      const $el = $('#' + id);
      if ($el.length) return $el;
      return this.elModoDme.find('[name="' + id + '"]').first();
    }

    private num(id: string): number {
      const $el = this.fieldByIdOrName(id);
      if (!$el.length) return 0;
      const value = $el.val();
      const v = parseInt(value !== undefined && value !== null ? String(value) : '', 10);
      return Number.isFinite(v) ? v : 0;
    }

    private bool(id: string): boolean {
      const $el = this.fieldByIdOrName(id);
      return !!($el.length && ($el.prop('checked') === true));
    }

    private boolByName(name: string): boolean {
      const $el = this.elModoDme.find('[name="' + name + '"]').first();
      return !!($el.length && ($el.prop('checked') === true));
    }

    private dimensoesExclusoesInteligentes($scope: JQuery): string[] {
      return AutoDme.lerDimensoesExclusoesInteligentes($scope);
    }

    private static lerDimensoesExclusoesInteligentes($scope: JQuery): string[] {
      const validas = ['league', 'nation', 'team', 'rating'];
      return $scope.find('input[name="dimensoes_exclusoes_inteligentes[]"]:checked')
        .map((_, el) => String($(el).val() || ''))
        .get()
        .filter((v: string) => validas.indexOf(v) !== -1);
    }

    private static normalizarIgnorarExclusoesCartaEspecial(raw: any): string[] {
      const validas = ['league', 'nation', 'team', 'rarity', 'rating'];
      const valores = Array.isArray(raw)
        ? raw
        : (raw !== undefined && raw !== null && String(raw).trim() !== '' ? String(raw).split(',') : []);
      const out: string[] = [];
      valores
        .map((v: any) => String(v || '').trim())
        .filter((v: string) => validas.indexOf(v) !== -1)
        .forEach((v: string) => {
          if (out.indexOf(v) === -1) out.push(v);
        });
      return out;
    }

    private static lerIgnorarExclusoesCartaEspecial($scope: JQuery): string[] {
      return AutoDme.normalizarIgnorarExclusoesCartaEspecial(
        $scope.find('input[name="ignorar_exclusoes_para_carta_especial[]"]:checked')
          .map((_, el) => String($(el).val() || ''))
          .get()
      );
    }

    /** Retorna array de números para select multiple (ex.: excludeLeagues, excludePlayers). */
    private arr(id: string): number[] {
      const $el = $('#' + id);
      if (!$el.length) return [];
      const v = $el.val();
      if (Array.isArray(v)) return v.map((x: any) => Number(x)).filter((n: number) => Number.isFinite(n));
      if (v !== undefined && v !== null && v !== '') return [Number(v)];
      return [];
    }

    private parseIntSafe(v: string): number {
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : 0;
    }

    private async postConfig(url: string, payload: ResolverPayload): Promise<Response> {
      const tokenConteudo = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement);
      const token = tokenConteudo ? tokenConteudo.content : '';
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': token
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin',
      });
    }

    private marcarConceitoExtinto(dados: any): void {
      const jogador = dados && dados.jogador ? dados.jogador : null;
      const resourceId = Number(jogador && (jogador.resourceId || jogador.definitionId || jogador.id));
      if (!Number.isFinite(resourceId) || resourceId <= 0) return;

      const tokenConteudo = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement;
      const token = tokenConteudo ? tokenConteudo.content : '';
      fetch('/autodme/conceitos/extinto', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': token
        },
        body: JSON.stringify({
          resourceId,
          plataforma: dados && dados.plataforma === 'pc' ? 'pc' : 'console'
        }),
        credentials: 'same-origin',
      }).then(resposta => {
        if (!resposta.ok) console.warn('Não foi possível marcar o jogador de conceito como extinto.', resourceId);
      }).catch(erro => console.warn('Não foi possível marcar o jogador de conceito como extinto.', resourceId, erro));
    }

    /**
     * Builder para o botão "Resolver" do PRO.
     * Monta o ResolverPayload a partir do DOM do modal (sem depender de categoria/sets internos).
     *
     * Importante: repetições são calculadas pela visibilidade do wrapper no DOM (`#wrapRepetirDmeConfig`),
     * e não pelo meta `repeatable` do DME.
     */
    public static montarPayloadResolverPro(elModal: JQuery): ResolverPayload | null {
      const dmeSelect = elModal.find('.js-select-dme-autodme-pro').first();
      const dmeIdRaw = dmeSelect.val();
      const dmeId = parseInt(String(dmeIdRaw || ''), 10);
      if (!Number.isFinite(dmeId) || String(dmeIdRaw || '') === '') return null;

      const dmeOpt = dmeSelect.find('option:selected');
      const dmeName = String(dmeOpt.attr('data-name') || dmeOpt.text() || '')
        .trim()
        .replace(/<[^>]*>/g, '');

      const tipoSolucao = parseInt(String(elModal.find('select[name="tipoSolucao"]').val()), 10) || 1;
      const rigorSolucao = AutoDme.RIGOR_SOLUCAO_FIXO;
      const solucaoInterna = tipoSolucao === 2;
      const linksFutbin = tipoSolucao === 3;

      const abrirPacksInegociaveisAutomaticamente = elModal.find('input[name="abrirPacksInegociaveisAutomaticamente"]').is(':checked');
      const abrirPacksNegociaveisAutomaticamente = elModal.find('input[name="abrirPacksNegociaveisAutomaticamente"]').is(':checked');
      const enviarAutomaticamente = true;
      const comprarJogadorAutomaticamente = true;
      const forcarNovaSolucao = true;
      const comprarJogadorSomenteNaCertezaDeSolucao = true;

      const excluirNegociaveis = elModal.find('input[type="checkbox"][name="excluirNegociaveis"]').is(':checked');
      const excluirEspeciais = elModal.find('input[name="excluirEspeciais"]').is(':checked');
      const excludeAtivoNoElenco = elModal.find('input[type="checkbox"][name="excludeAtivoNoElenco"]').is(':checked');
      const usarSomenteJogadoresClube = elModal.find('input[name="usarSomenteJogadoresClube"]').is(':checked');
      const usarConceitos = !(tipoSolucao === 2 && usarSomenteJogadoresClube);
      const tentarSolucaoExternaSeNaoEncontrarInterna = elModal.find('input[name="tentarSolucaoExternaSeNaoEncontrarInterna"]').is(':checked');

      const precoMaximoDesafio = parseInt(String(elModal.find('input[name="precoMaximoDesafio"]').val()), 10) || AutoDme.DEFAULT_GASTO_DME;
      const precoMaximoJogadorNegociavel = AutoDme.normalizarPrecoJogador(
        elModal.find('input[name="precoMaximoJogadorNegociavel"]').val(),
        AutoDme.DEFAULT_PRECO_JOGADOR_NEGOCIAVEL
      );
      const precoMaximoJogadorInegociavel = AutoDme.normalizarPrecoJogador(
        elModal.find('input[name="precoMaximoJogadorInegociavel"]').val(),
        AutoDme.DEFAULT_PRECO_JOGADOR_INEGOCIAVEL
      );

      const minimoRatingInput = parseInt(String(elModal.find('input[name="minimoRating"]').val()), 10) || 45;
      const maximoRatingInput = parseInt(String(elModal.find('input[name="maximoRating"]').val()), 10) || 99;
      const maximoRatingCartaEspecialInput = parseInt(String(elModal.find('input[name="maximo_rating_carta_especial"]').val()), 10) || 0;

      const tempoMaximoResolucaoMinutos = AutoDme.TEMPO_RESOLUCAO_FIXO_MIN;

      const repetirEnabled = !elModal.find('[id^="wrapRepetirDmeConfig"]').hasClass('d-none');
      let repetirVal = 0;
      const limiteRaw = parseInt(String(elModal.find('input[name="limite_solucoes_diarias"]').val()), 10) || AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS;
      const limiteSolucoesDiarias = AutoDme.clampLimiteSolucoesDiarias(limiteRaw);
      const limitesForragens = AutoDme.lerLimitesForragensDoDom(elModal);
      if (repetirEnabled) {
        const repetirRaw = parseInt(String(elModal.find('input[name="repetir"]').val()), 10) || 0;
        repetirVal = AutoDme.clampRepetirDme(repetirRaw, limiteSolucoesDiarias);

      }
      const limiteTentRaw = parseInt(String(elModal.find('input[name="limite_tentativas_dia"]').val()), 10) || AutoDme.DEFAULT_LIMITE_TENTATIVAS_DIA;
      const limiteTentativasDia = Math.min(
        AutoDme.MAX_LIMITE_TENTATIVAS_DIA,
        Math.max(AutoDme.MIN_LIMITE_TENTATIVAS_DIA, limiteTentRaw)
      );
      // Fixo em 0 (15/08/2026). Os limites de scan do clube sairam daqui: viraram configuracao
      // do PERFIL e o servidor os injeta no payload.
      const escanearClubeAposFalhas = AutoDme.ESCANEAR_CLUBE_APOS_FALHAS_FIXO;

      const readMultiSelectNums = (name: string): number[] => {
        const v = elModal.find('select[name="' + name + '"]').val();
        if (Array.isArray(v)) return v.map((x: any) => Number(x)).filter((n: number) => Number.isFinite(n));
        if (v !== undefined && v !== null && v !== '') {
          const n = Number(v);
          return Number.isFinite(n) ? [n] : [];
        }
        return [];
      };

      let linksArr: (string | false)[] = [];
      if (linksFutbin) {
        const container = elModal.find('[id^="espacoCamposLinksDme"]');
        const nodes = container.find('input[id^="linkFutbin"]');
        const pairs: { i: number; v: string }[] = [];
        nodes.each((_, el) => {
          const $el = $(el);
          const idStr = String($el.attr('id') || '');
          const m = /^linkFutbin(\d+)/.exec(idStr);
          if (!m) return;
          const i = parseInt(m[1], 10);
          pairs.push({ i, v: String($el.val() || '').trim() });
        });
        pairs.sort((a, b) => a.i - b.i);
        linksArr = pairs.map(p => p.v ? p.v : false);
      }

      let excludedChallengeIndices: number[] = [];
      if (linksFutbin) {
        excludedChallengeIndices = [];
        linksArr.forEach((cell, i) => {
          if (cell === false || typeof cell !== 'string' || !String(cell).trim()) excludedChallengeIndices.push(i + 1);
        });
        excludedChallengeIndices.sort((a, b) => a - b);
      } else {
        excludedChallengeIndices = [];
        elModal.find('[id^="form-desafios-dme"] input[name="desafios_dme[]"]:not(:checked)').each((_, el) => {
          const v = parseInt(String($(el).val()), 10);
          if (Number.isFinite(v)) excludedChallengeIndices.push(v);
        });
        excludedChallengeIndices.sort((a, b) => a - b);
      }

      const links: DmeLinks | null = linksFutbin && linksArr.length ? linksArr : null;

      const precoMaximoJogadorNegociavelEfetivo = linksFutbin
        ? Math.max(precoMaximoJogadorNegociavel, AutoDme.PRECO_JOGADOR_LINKS_EXTERNOS)
        : precoMaximoJogadorNegociavel;

      const dme: DmePayload = {
        setId: dmeId,
        name: dmeName || null,
        links,
        excludedChallengeIndices: excludedChallengeIndices.length > 0 ? excludedChallengeIndices : undefined
      };

      const cfg: ConfiguracaoPayload = {
        repetir: repetirVal,
        repetirIntervaloMinutos: 0,
        limite_solucoes_diarias: limiteSolucoesDiarias,
        limites_solucoes_por_forragens: limitesForragens.length ? limitesForragens : undefined,
        limite_tentativas_dia: limiteTentativasDia,
        tentar_ate_limite_antes_de_pular: !!elModal.find('input[name="tentar_ate_limite_antes_de_pular"]').prop('checked'),
        executar_somente_quando_dme_anteriores_finalizados: !!elModal.find('input[name="executar_somente_quando_dme_anteriores_finalizados"]').prop('checked'),
        escanear_clube_apos_falhas: escanearClubeAposFalhas,
        tipoSolucao,
        rigorSolucao,
        quantidadeSolucoesColetadas: 2,

        excluirNegociaveis: solucaoInterna ? excluirNegociaveis : false,
        excluirEspeciais: solucaoInterna ? excluirEspeciais : false,
        usarConceitos,

        minimoRating: solucaoInterna ? minimoRatingInput : 45,
        maximoRating: solucaoInterna ? maximoRatingInput : 99,
        // OVR máx. p/ carta ESPECIAL: amplia o teto só p/ especiais (0 = desligado).
        maximoRatingCartaEspecial: maximoRatingCartaEspecialInput,
        tempoMaximoResolucaoMinutos: solucaoInterna ? tempoMaximoResolucaoMinutos : 3,

        usarDuplicatas: true,
        abrirPacksInegociaveisAutomaticamente: abrirPacksInegociaveisAutomaticamente,
        abrirPacksNegociaveisAutomaticamente: abrirPacksNegociaveisAutomaticamente,
        enviarAutomaticamente: enviarAutomaticamente,

        precoMaximoDesafio: precoMaximoDesafio,
        precoMaximoJogadorNegociavel: precoMaximoJogadorNegociavelEfetivo,
        precoMaximoJogadorInegociavel,

        comprarJogadorSomenteNaCertezaDeSolucao: comprarJogadorSomenteNaCertezaDeSolucao,
        comprarJogadorAutomaticamente: comprarJogadorAutomaticamente,
        permitir_execucao_descanso_sniper: !!elModal.find('input[name="permitir_execucao_descanso_sniper"]').prop('checked'),
        exigir_todos_desafios_viaveis: !!elModal.find('input[name="exigir_todos_desafios_viaveis"]').prop('checked'),
        atualizar_setid_por_nome_dme: !!elModal.find('input[name="atualizar_setid_por_nome_dme"]').prop('checked'),
        incluir_exigencias_dme_em_exclusoes_inteligentes: !!elModal.find('input[name="incluir_exigencias_dme_em_exclusoes_inteligentes"]').prop('checked'),
        dmeBase: solucaoInterna ? !!elModal.find('input[name="dmeBase"]').prop('checked') : false,
        retentativasAntesDeFecharWebApp: 2,
        forcarSolucaoACadaRetentativa: false,
        aumentarRatingAposCadaTentativa: 0,
        aumentarPrecoJogadorAposCadaTentativa: 0,

        enviarImediatamenteSeEstiverPronto: enviarAutomaticamente,
        forcarNovaSolucao: forcarNovaSolucao,

        excludeAtivoNoElenco: solucaoInterna ? excludeAtivoNoElenco : false,
        excludeLeagues: linksFutbin ? [] : readMultiSelectNums('excludeLeagues'),
        excludeNations: linksFutbin ? [] : readMultiSelectNums('excludeNations'),
        excludeTeams: linksFutbin ? [] : readMultiSelectNums('excludeTeams'),
        excludeRarity: linksFutbin ? [] : readMultiSelectNums('excludeRarity'),
        excludeRating: linksFutbin ? [] : readMultiSelectNums('excludeRating'),
        excludePlayers: linksFutbin ? [] : readMultiSelectNums('excludePlayers'),
        dimensoes_exclusoes_inteligentes: linksFutbin ? [] : AutoDme.lerDimensoesExclusoesInteligentes(elModal),
        ignorar_exclusoes_para_carta_especial: linksFutbin ? [] : AutoDme.lerIgnorarExclusoesCartaEspecial(elModal),
        exclusoes_inteligentes_origens: linksFutbin ? [] : (Array.isArray(elModal.data('exclusoesInteligentesOrigens')) ? elModal.data('exclusoesInteligentesOrigens') : []),
        tentarSolucaoExternaSeNaoEncontrarInterna: solucaoInterna ? tentarSolucaoExternaSeNaoEncontrarInterna : false,
        usarSomenteJogadoresClube: tipoSolucao === 2 ? usarSomenteJogadoresClube : false
      };

      return { dme, configuracao: cfg };
    }

    /**
     * Payload para resolver o DME Inicial (Foundations) a partir do mesmo modal do PRO:
     * reaproveita preços, repetição, packs etc. de {@link montarPayloadResolverPro},
     * força opções padrão para o passo inicial e aponta o `dme` para o set configurado em `configAutoDme.dmeInicialId`.
     * @param basePayload Se vier de {@link montarPayloadResolverPro}, evita ler o DOM duas vezes.
     */
    public static montarPayloadDmeInicialResolverPro(elModal: JQuery, basePayload?: ResolverPayload | null): ResolverPayload | null {
      const base = basePayload !== undefined ? basePayload : AutoDme.montarPayloadResolverPro(elModal);
      if (!base) return null;

      const dmeInicialId =
        App.Util.config && App.Util.config.configAutoDme && Number.isFinite(App.Util.config.configAutoDme.dmeInicialId)
          ? App.Util.config.configAutoDme.dmeInicialId
          : 1;

      const excluirNegociaveis = false;
      const minimoRatingInput = parseInt(String(elModal.find('input[name="minimoRating"]').val()), 10) || 45;
      const maximoRatingInput = parseInt(String(elModal.find('input[name="maximoRating"]').val()), 10) || 99;
      const tempoMaximoResolucaoMinutos = AutoDme.TEMPO_RESOLUCAO_FIXO_MIN;
      const excludeAtivoNoElenco = false;

      const readMultiSelectNums = (name: string): number[] => {
        const v = elModal.find('select[name="' + name + '"]').val();
        if (Array.isArray(v)) return v.map((x: any) => Number(x)).filter((n: number) => Number.isFinite(n));
        if (v !== undefined && v !== null && v !== '') {
          const n = Number(v);
          return Number.isFinite(n) ? [n] : [];
        }
        return [];
      };

      const configuracao: ConfiguracaoPayload = {
        ...base.configuracao,
        tipoSolucao: 2,
        forcarNovaSolucao: true,
        excluirEspeciais: true,
        excluirNegociaveis,
        minimoRating: minimoRatingInput,
        maximoRating: maximoRatingInput,
        tempoMaximoResolucaoMinutos,
        excludeAtivoNoElenco,
        excludeLeagues: readMultiSelectNums('excludeLeagues'),
        excludeNations: readMultiSelectNums('excludeNations'),
        excludeTeams: readMultiSelectNums('excludeTeams'),
        excludeRarity: readMultiSelectNums('excludeRarity'),
        excludeRating: readMultiSelectNums('excludeRating'),
        excludePlayers: readMultiSelectNums('excludePlayers'),
        usarSomenteJogadoresClube: true,
        usarConceitos: false,
        tentarSolucaoExternaSeNaoEncontrarInterna: false,
      };

      return {
        dme: { setId: dmeInicialId, name: 'DME Inicial', links: null },
        configuracao,
      };
    }

    // =======================
    //   Persistência Helpers
    // =======================
    /** Chave de escopo por conjunto: category + dme + tipoSolucao */
    private scopeKeyForSelection(categoryId: string, dmeId: string, tipoSolucao: number): string {
      const cat = categoryId || '_';
      const dme = dmeId || '_';
      const tipo = String(tipoSolucao || 1);
      return `cat_${cat}_dme_${dme}_tipo_${tipo}`;
    }

    private getCurrentScopeKey(): string | null {
      const catId = this.getSelectedCategoryId();
      const dmeId = String(this.elSelectDme.val() || '');
      const tipo = parseInt(String(this.elTipoSolucao.val()), 10) || 1;
      if (!dmeId) return null;
      return this.scopeKeyForSelection(
        catId != null ? String(catId) : '',
        dmeId,
        tipo
      );
    }

    private readScope(scope: 'global' | string): Record<string, any> {
      const key = `${this.storageNS}:${scope}`;
      try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    }

    private writeScope(scope: 'global' | string, patch: Record<string, any>): void {
      const key = `${this.storageNS}:${scope}`;
      const prev = this.readScope(scope);
      const next = { ...prev, ...patch };
      if (next.limite_solucoes_diarias != null && next.limite_solucoes_diarias !== undefined) {
        next.limite_solucoes_diarias = AutoDme.clampLimiteSolucoesDiarias(next.limite_solucoes_diarias);
      }
      next.limites_solucoes_por_forragens = AutoDme.normalizarLimitesSolucoesPorForragensComLegado(next);
      delete next.usar_limite_solucoes_por_forragens;
      delete next.forragens_clube_por_solucao;
      delete next.limite_solucoes_abaixo_forragens;
      delete next.forragens_clube_abaixo_de;
      localStorage.setItem(key, JSON.stringify(next));
    }

    private applySavedConfigForScope(scope: 'global' | string): void {
      let data = this.readScope(scope);
      // Migração: scope novo vazio -> tenta carregar do formato antigo dme:X
      if (Object.keys(data).length === 0 && scope.startsWith('cat_') && scope.includes('_dme_')) {
        const m = scope.match(/cat_[^_]*_dme_([^_]+)_tipo_/);
        const dmeId = m ? m[1] : '';
        if (dmeId && dmeId !== '_') {
          const legacy = this.readScope(`dme:${dmeId}`);
          if (Object.keys(legacy).length > 0) data = legacy;
        }
      }
      // Migração: tipoSolucao string -> número (1=externa, 2=interna, 3=links)
      if (typeof data.tipoSolucao === 'string') {
        const m: Record<string, number> = { rapida: 1, interna: 2, links_futbin: 3 };
        data.tipoSolucao = m[data.tipoSolucao] != null ? m[data.tipoSolucao] : 1;
      }
      if (data.enviarAutomaticamente === undefined && (data.autoSubmit !== undefined || data.enviarImediatamenteSeEstiverPronto !== undefined)) {
        data.enviarAutomaticamente = data.autoSubmit !== undefined ? data.autoSubmit : data.enviarImediatamenteSeEstiverPronto;
      }
      if (data.usarSomenteJogadoresClube === undefined && data.usarConceitos === false) {
        data.usarSomenteJogadoresClube = true;
      }
      // Migracao pontual (uma vez por navegador): na versao comum "Somente jogadores do clube"
      // nascia LIGADO e desligava o uso de cartas de conceito, entao o modo inteligente nunca
      // completava um desafio com carta que o usuario nao tem. Solta o valor salvo para que o
      // novo default do blade valha. Gated pelo marcador #autodme-contexto-comum: o localStorage
      // e do dominio inteiro e nao pode ser mexido a partir da tela da PRO.
      if ($('#autodme-contexto-comum').length > 0) {
        var chaveMigrConceito = this.storageNS + ':migr_conceito_comum';
        var jaMigrouConceito = false;
        try { jaMigrouConceito = localStorage.getItem(chaveMigrConceito) === '1'; } catch (_e) { jaMigrouConceito = true; }
        if (!jaMigrouConceito) {
          if (data.usarSomenteJogadoresClube !== undefined) {
            delete data.usarSomenteJogadoresClube;
            delete data.usarConceitos;
            this.writeScope(scope, { usarSomenteJogadoresClube: undefined, usarConceitos: undefined });
          }
          try { localStorage.setItem(chaveMigrConceito, '1'); } catch (_e) { }
        }
      }
      if (data.dmeBase === undefined && data.dme_base !== undefined) {
        data.dmeBase = data.dme_base;
      }
      if (data.repetir != null && data.repetir !== undefined) {
        const rp = Number(data.repetir);
        if (Number.isFinite(rp)) {
          data.repetir = Math.min(
            AutoDme.MAX_REPETIR_DME,
            Math.max(AutoDme.MIN_REPETIR_DME, rp < AutoDme.MIN_REPETIR_DME ? AutoDme.MIN_REPETIR_DME : rp)
          );
        }
      }
      if (data.repetirIntervaloMinutos != null && data.repetirIntervaloMinutos !== undefined) {
        const iv = Number(data.repetirIntervaloMinutos);
        if (Number.isFinite(iv)) {
          data.repetirIntervaloMinutos = Math.min(AutoDme.MAX_INTERVALO_REPETIR_MIN, Math.max(0, iv));
        }
      }
      if (data.limite_solucoes_diarias != null && data.limite_solucoes_diarias !== undefined) {
        const lim = Number(data.limite_solucoes_diarias);
        if (Number.isFinite(lim)) {
          data.limite_solucoes_diarias = Math.min(
            AutoDme.MAX_LIMITE_SOLUCOES_DIARIAS,
            Math.max(AutoDme.MIN_LIMITE_SOLUCOES_DIARIAS, lim)
          );
        }
      }
      data.limites_solucoes_por_forragens = AutoDme.normalizarLimitesSolucoesPorForragensComLegado(data);
      delete data.usar_limite_solucoes_por_forragens;
      delete data.forragens_clube_por_solucao;
      delete data.limite_solucoes_abaixo_forragens;
      delete data.forragens_clube_abaixo_de;
      if (data.limite_tentativas_dia != null && data.limite_tentativas_dia !== undefined) {
        const limT = Number(data.limite_tentativas_dia);
        if (Number.isFinite(limT)) {
          data.limite_tentativas_dia = Math.min(
            AutoDme.MAX_LIMITE_TENTATIVAS_DIA,
            Math.max(AutoDme.MIN_LIMITE_TENTATIVAS_DIA, limT)
          );
        }
      }
      // Configs de scan do clube e demais campos que viraram fixos nao sao mais restaurados
      // daqui: sairam de persistentFieldIds em 15/08/2026. Chaves antigas no localStorage
      // ficam inertes.
      this.persistentFieldIds.forEach(id => {
        if (id === 'tipoSolucao') return; // tipoSolucao faz parte do conjunto mas não é sobrescrito ao carregar
        if (id === 'dimensoes_exclusoes_inteligentes') {
          const dims = Array.isArray(data[id]) ? data[id].map((x: any) => String(x)) : [];
          this.elModoDme.find('input[name="dimensoes_exclusoes_inteligentes[]"]').each((_, el) => {
            const $el = $(el);
            $el.prop('checked', dims.indexOf(String($el.val() || '')) !== -1);
          });
          return;
        }
        if (id === 'ignorar_exclusoes_para_carta_especial') {
          const dims = AutoDme.normalizarIgnorarExclusoesCartaEspecial(data[id]);
          this.elModoDme.find('input[name="ignorar_exclusoes_para_carta_especial[]"]').each((_, el) => {
            const $el = $(el);
            $el.prop('checked', dims.indexOf(String($el.val() || '')) !== -1);
          });
          return;
        }
        if (id === 'limites_solucoes_por_forragens') {
          const $list = $('#limites_solucoes_por_forragens');
          if ($list.length) this.renderLimitesForragens($list, data.limites_solucoes_por_forragens || []);
          return;
        }
        const $el = this.fieldByIdOrName(id);
        if (!$el.length) return;
        const val = data[id];

        if (AutoDme.EXCLUDE_MULTISELECT_IDS.indexOf(id) !== -1) {
          const arrVal = (() => {
            if (Array.isArray(val)) {
              return val
                .map((x: any) => parseInt(String(x), 10))
                .filter((n: number) => Number.isFinite(n))
                .map((n: number) => String(n));
            }
            if (typeof val === 'string') {
              const t = val.trim();
              if (!t) return [];
              return t
                .split(',')
                .map((x: string) => parseInt(x.trim(), 10))
                .filter((n: number) => Number.isFinite(n))
                .map((n: number) => String(n));
            }
            const n = parseInt(String(val), 10);
            return Number.isFinite(n) ? [String(n)] : [];
          })();
          if (id === 'excludePlayers' && arrVal.length) {
            // Select2 AJAX precisa de option no DOM com label antes do .val(...)
            App.Util.hidratarSelectExcludePlayersComNomes($el, arrVal);
          }
          $el.val(arrVal);
          $el.trigger('change').trigger('change.select2');
          return;
        }

        if (val === undefined) return;

        const tag = ($el.prop('tagName') || '').toString().toLowerCase();
        const type = ($el.attr('type') || '').toLowerCase();

        if (type === 'checkbox') {
          $el.prop('checked', !!val);
        } else if (tag === 'select' || type === 'number' || type === 'text' || type === 'hidden') {
          $el.val(Array.isArray(val) ? val : val);
          if (tag === 'select' && $el.attr('multiple') && Array.isArray(val)) $el.trigger('change');
        }
      });
      const excludedArr = data.excludedChallengeIndices;
      if (Array.isArray(excludedArr)) {
        $('#form-desafios-dme input[name="desafios_dme[]"]').each(function () {
          const idx = parseInt(String($(this).val()), 10);
          $(this).prop('checked', excludedArr.indexOf(idx) === -1);
        });
      }
      this.syncSlidersFromInputs();
    }

    private restoreGlobalDefaults(): void {
      const scope = this.getCurrentScopeKey();
      if (scope) {
        this.applySavedConfigForScope(scope);
      } else {
        this.applySavedConfigForScope('global');
      }
      this.applyTipoSolucaoUi();
    }

    private applyTipoSolucaoUi(): void {
      const tipoSolucao = parseInt(String($('#tipoSolucao').val()), 10) || 1;
      const linksFutbin = tipoSolucao === 3;

      const catId = this.getSelectedCategoryId();
      const dmeId = String(this.elSelectDme.val() || '');

      if (dmeId) {
        // Salva config do conjunto anterior (category, dme, oldTipo) antes de trocar
        if (this.lastTipoSolucao !== tipoSolucao) {
          const prevScope = this.scopeKeyForSelection(
            this.lastCategoryId,
            this.lastDmeId,
            this.lastTipoSolucao
          );
          this.saveCurrentConfigToStorage(prevScope, { tipoSolucao: this.lastTipoSolucao });
        }

        this.lastTipoSolucao = tipoSolucao;
        this.lastCategoryId = catId != null ? String(catId) : '';
        this.lastDmeId = dmeId;

        // Carrega config do novo conjunto (category, dme, tipoSolucao)
        const scope = this.scopeKeyForSelection(this.lastCategoryId, this.lastDmeId, this.lastTipoSolucao);
        this.applySavedConfigForScope(scope);
      }

      // Opcoes internas do solver continuam restritas ao tipo inteligente.
      if (tipoSolucao === 2) {
        $('#config-dme').removeClass('tipo-interna-hide-solucao-externa');
        $('.config-visible-interna-only').css('display', '');
      } else {
        $('#config-dme').addClass('tipo-interna-hide-solucao-externa');
      }

      const somenteInterna = tipoSolucao === 2;
      if (somenteInterna) {
        $('#config-dme').removeClass('auto-dme-tipo-nao-interna');
      } else {
        $('#config-dme').addClass('auto-dme-tipo-nao-interna');
        $('#minimoRating').val('45');
        $('#maximoRating').val('99');
        this.syncSlidersFromInputs();
      }

      // Links Futbin: mostrar menu de links e apenas configs permitidas (abas permanecem visíveis, só os campos são ocultados)
      if (linksFutbin) {
        $('#config-dme').addClass('tipo-links-futbin');
        $('#menuLinksFutbin').show();
        $('.config-visible-interna-rapida:not(.config-visible-links-futbin)').hide();
        $('.config-visible-links-futbin').show();
        // Links externos mantem filtros manuais desligados para nao bloquear a solucao importada.
        $('#usarDuplicatas').prop('checked', true);
        $('#usarSomenteJogadoresClube').prop('checked', false);
        $('#excludeAtivoNoElenco').prop('checked', false);
        $('#excluirEspeciais').prop('checked', false);
        $('#excluirNegociaveis').prop('checked', false);
      } else {
        $('#config-dme').removeClass('tipo-links-futbin');
        $('.config-visible-interna-rapida').show();
        $('.config-visible-links-futbin').show();
        $('#tab-simples').parent().show();
        $('#tab-avancado').parent().show();
        $('#menuLinksFutbin').hide();
        this.limparLinksFutbin();
      }

      $('#modoDme').find('[id^="wrapTempoMaximoSolucao"]').toggle(tipoSolucao === 2);
      this.syncLimitesConfigVisibility();

      this.syncRowDesafiosVisibility();
    }

    private persistFieldChange(fieldId: string): void {
      const $el = $('#' + fieldId);
      if (!$el.length) return;

      let value: any;
      const tag = ($el.prop('tagName') || '').toString().toLowerCase();
      const type = ($el.attr('type') || '').toLowerCase();

      if (type === 'checkbox') {
        value = $el.prop('checked') === true;
      } else {
        value = $el.val();
      }

      const scope = this.getCurrentScopeKey();
      if (scope) this.writeScope(scope, { [fieldId]: value });
    }

    private enablePersistenceListeners(): void {
      this.persistentFieldIds.forEach(id => {
        const $el = this.fieldByIdOrName(id);
        if (!$el.length) return;
        $el.on('change', () => this.persistFieldChange(id));
        // // Se quiser salvar enquanto digita:
        // $el.on('input',  () => this.persistFieldChange(id));
      });
      this.elModoDme.find('input[name="dimensoes_exclusoes_inteligentes[]"]').on('change', () => {
        const scope = this.getCurrentScopeKey();
        if (scope) this.writeScope(scope, { dimensoes_exclusoes_inteligentes: AutoDme.lerDimensoesExclusoesInteligentes(this.elModoDme) });
      });
      this.elModoDme.find('input[name="ignorar_exclusoes_para_carta_especial[]"]').on('change', () => {
        const scope = this.getCurrentScopeKey();
        if (scope) this.writeScope(scope, { ignorar_exclusoes_para_carta_especial: AutoDme.lerIgnorarExclusoesCartaEspecial(this.elModoDme) });
      });
    }

    private saveCurrentConfigToStorage(scope: 'global' | string, overrides?: Record<string, any>): void {
      const patch: Record<string, any> = {};
      this.persistentFieldIds.forEach(id => {
        if (id === 'dimensoes_exclusoes_inteligentes') {
          patch[id] = AutoDme.lerDimensoesExclusoesInteligentes(this.elModoDme);
          return;
        }
        if (id === 'ignorar_exclusoes_para_carta_especial') {
          patch[id] = AutoDme.lerIgnorarExclusoesCartaEspecial(this.elModoDme);
          return;
        }
        if (id === 'limites_solucoes_por_forragens') {
          patch[id] = AutoDme.lerLimitesForragensDoDom(this.elModoDme);
          return;
        }
        const $el = this.fieldByIdOrName(id);
        if (!$el.length) return;
        const type = ($el.attr('type') || '').toLowerCase();
        if (AutoDme.EXCLUDE_MULTISELECT_IDS.indexOf(id) !== -1) {
          const v = $el.val();
          patch[id] = Array.isArray(v) ? v : [];
          return;
        }
        patch[id] = type === 'checkbox' ? ($el.prop('checked') === true) : $el.val();
      });
      const tipoSolucaoSave = parseInt(String($('#tipoSolucao').val()), 10) || 1;
      const $desafiosContainer = $('#form-desafios-dme');
      if (tipoSolucaoSave === 3) {
        const linksArr = App.Util.obterLinksFutbin();
        patch.excludedChallengeIndices = this.excludedChallengeIndicesFromLinksFutbin(linksArr);
      } else if ($desafiosContainer.length && $desafiosContainer.find('input[name="desafios_dme[]"]').length) {
        const excluded: number[] = [];
        $desafiosContainer.find('input[name="desafios_dme[]"]:not(:checked)').each(function () {
          const v = parseInt(String($(this).val()), 10);
          if (Number.isFinite(v)) excluded.push(v);
        });
        patch.excludedChallengeIndices = excluded.sort((a, b) => a - b);
      }
      if (overrides) Object.assign(patch, overrides);
      this.writeScope(scope, patch);
    }

    private resetarCategoriasDmes(): void {
      this.setLastSelection({ categoryId: '', setId: '' });
      this.elSelectCategory.val('');
      this.elSelectDme.prop('disabled', true).val('');
      this.clearHeader();
    }

    private solucionarDmeNoWebApp(payload?: ResolverPayload): void {
      try {
        console.log('Enviando mensagem para extensão do Chrome para resolver o DME...', payload, this.idExtensao);
        this.resolvendo = true;
        chrome.runtime.sendMessage(this.idExtensao, { evento: "rsolvdme", request: payload }, (_resultado: any) => { });
      } catch (e) {
        console.error('Falha ao enviar mensagem à extensão:', e);
        this.finalizaProcesso();
      }
    }

    /** Aplica um objeto de config aos inputs do formulário */
    private applyConfigToForm(config: Record<string, any>): void {
      Object.keys(config).forEach((fieldId) => {
        const $el = $('#' + fieldId);
        if (!$el.length) return;

        const type = ($el.attr('type') || '').toLowerCase();
        if (type === 'checkbox') {
          $el.prop('checked', !!config[fieldId]);
        } else {
          $el.val(config[fieldId]);
        }
        $el.trigger('change');
      });
      if (config.minimoRating !== undefined || config.maximoRating !== undefined ||
        config.precoMaximoDesafio !== undefined ||
        config.precoMaximoJogadorNegociavel !== undefined ||
        config.precoMaximoJogadorInegociavel !== undefined ||
        config.tempoMaximoResolucaoMinutos !== undefined ||
        config.repetir !== undefined || config.repetirIntervaloMinutos !== undefined) {
        this.syncSlidersFromInputs();
      }
    }

    private formatCoins(n?: number | null): string {
      if (n == null || isNaN(n as number)) return '—';
      return n.toLocaleString('pt-BR');
    }

    /** Normaliza string → número inteiro, respeitando min/max */
    private clampToRange(raw: string, minAttr?: string | number | null, maxAttr?: string | number | null, allowNegative = false): string {
      // remove tudo que não é dígito (e opcionalmente o sinal "-")
      const cleaned = (raw || '').replace(allowNegative ? /[^0-9-]/g : /[^0-9]/g, '');

      if (cleaned === '' || cleaned === '-') return ''; // deixa vazio se o usuário ainda está digitando

      let n = parseInt(cleaned, 10);
      if (!Number.isFinite(n)) return '';

      const min = (minAttr !== undefined && minAttr !== null && minAttr !== '') ? Number(minAttr) : undefined;
      const max = (maxAttr !== undefined && maxAttr !== null && maxAttr !== '') ? Number(maxAttr) : undefined;

      if (typeof min === 'number' && Number.isFinite(min) && n < min) n = min;
      if (typeof max === 'number' && Number.isFinite(max) && n > max) n = max;

      return String(n);
    }

    /** Bloqueia teclas inválidas e garante min/max em tempo real para inputs number */
    private setupNumericValidation(): void {
      const $scope = $('#config-dme'); // limite à área das configs; troque se quiser abranger a página toda

      // 1) Bloqueio de teclas inválidas (keydown)
      $scope.on('keydown', 'input[type="number"]', (ev: any) => {
        const e = ev as any as KeyboardEvent;
        const key = e.key;

        // atalhos e teclas de navegação
        const ctrlCmd = e.ctrlKey || e.metaKey;
        const allowedNav: any = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (allowedNav.includes(key) || (ctrlCmd && (['a', 'c', 'v', 'x', 'z', 'A', 'C', 'V', 'X', 'Z'] as any).includes(key))) return;

        const target = ev.currentTarget as HTMLInputElement;
        const minAttr = target.getAttribute('min');
        const allowNegative = !!(minAttr && Number(minAttr) < 0);

        // Só dígitos; SEM ".", "e", "E", "+"; "-" apenas se min < 0 e no início
        if (key >= '0' && key <= '9') return;
        if (key === '-' && allowNegative) {
          // permitir "-" apenas na posição 0 e se ainda não existe
          const hasMinus = target.value.includes('-');
          const caretAtStart = (target.selectionStart != null ? target.selectionStart : 0) === 0;
          if (!hasMinus && caretAtStart) return;
        }

        // bloqueia qualquer outra tecla
        e.preventDefault();
      });

      // 2) Sanitização em paste (colar)
      $scope.on('paste', 'input[type="number"]', (ev: any) => {
        const e = ev.originalEvent as ClipboardEvent;
        const t = ev.currentTarget as HTMLInputElement;
        if (!e || !e.clipboardData) return;
        const pasted = e.clipboardData.getData('text') || '';

        const allowNegative = !!(t.getAttribute('min') && Number(t.getAttribute('min')) < 0);
        const minAttr = t.getAttribute('min');
        const maxAttr = t.getAttribute('max');

        const next = this.clampToRange(pasted, minAttr, maxAttr, allowNegative);
        e.preventDefault();
        t.value = next;
        // dispara change para sua persistência
        $(t).trigger('change');
      });

      // 3) Sanitização contínua (input) e clamp em min/max
      $scope.on('input', 'input[type="number"]', (ev: any) => {
        const t = ev.currentTarget as HTMLInputElement;
        const allowNegative = !!(t.getAttribute('min') && Number(t.getAttribute('min')) < 0);
        const minAttr = t.getAttribute('min');
        const maxAttr = t.getAttribute('max');

        const next = this.clampToRange(t.value, minAttr, maxAttr, allowNegative);
        if (t.value !== next) {
          t.value = next;
          $(t).trigger('change');
        }
      });

      // 4) Ajuste final ao sair do campo (blur) — evita ficar vazio quando min > 0
      $scope.on('blur', 'input[type="number"]', (ev: any) => {
        const t = ev.currentTarget as HTMLInputElement;
        const minAttr = t.getAttribute('min');
        if ((t.value === '' || t.value === '-') && minAttr !== null && minAttr !== '') {
          t.value = String(Number(minAttr));
          $(t).trigger('change');
        }
      });

      // 5) (Opcional) Impede rolagem do mouse alterar números sem querer
      $scope.on('wheel', 'input[type="number"]', (ev) => {
        (ev.currentTarget as HTMLInputElement).blur();
      });
    }


    /**
     * Monta um resumo descritivo para log.
     */
    /**
     * Diz EXATAMENTE o que faltou, em linguagem do usuario, a partir dos campos estruturados que a
     * extensao manda no diagnostico (key/target/available). Ex.: "O desafio pede 11 cartas dessa
     * qualidade e voce tem 3."
     */
    /**
     * Nomeia as CONFIGURACOES que de fato barraram cartas, com quantas cada uma bloqueou.
     * A extensao ja calculava isso (exclusionAudit.rejectedByReason) e mandava no diagnostico,
     * mas a tela ignorava e imprimia uma lista fixa de sugestoes — que podia nem ter relacao
     * com o que realmente limitou. Sem dado, devolve vazio e o texto generico continua valendo.
     */
    private configuracoesLimitantesAutoDme(fonte: any, diag: any): string {
      const lista = (fonte && $.isArray(fonte.configuracoesLimitantes))
        ? fonte.configuracoesLimitantes
        : ((diag && $.isArray(diag.configuracoesLimitantes)) ? diag.configuracoesLimitantes : []);
      if (!lista.length) return '';
      const partes: string[] = [];
      for (let i = 0; i < lista.length; i++) {
        const c = lista[i];
        if (!c || !c.configuracao) continue;
        const qtd = Number(c.cartasBloqueadas) || 0;
        partes.push('<b>•</b> “' + c.configuracao + '”' + (qtd > 0 ? ' — bloqueou ' + qtd.toLocaleString('pt-BR') + ' carta(s)' : ''));
      }
      if (!partes.length) return '';
      // Fecha o laço: se o sistema chegou a tentar completar com carta do mercado, diz isso —
      // senão o usuário fica sem saber se a opção de conceito sequer entrou em ação.
      const tentouConceito = (fonte && fonte.conceitoTentado === true) || (diag && diag.conceitoTentado === true);
      if (tentouConceito) {
        partes.push('<small>' + this.detalheTentativaConceitoAutoDme(fonte, diag) + '</small>');
      }
      return partes.join('<br/>');
    }

    /**
     * Diz o que a 2a passada (clube + cartas do mercado) tentou e por que caiu.
     * Antes a tela só dizia "também não fechou": o usuário não sabia se o sistema chegou a
     * carregar cartas de conceito, quantas, nem qual foi o motivo técnico — que existia apenas
     * no console da página da EA e portanto nunca chegava a quem opera.
     */
    private detalheTentativaConceitoAutoDme(fonte: any, diag: any): string {
      const ler = function (campo: string): any {
        if (fonte && fonte[campo] !== undefined && fonte[campo] !== null) return fonte[campo];
        if (diag && diag[campo] !== undefined && diag[campo] !== null) return diag[campo];
        return null;
      };
      const conceitos = Number(ler('cartasDeConceitoNoPool')) || 0;
      const total = Number(ler('cartasNaUltimaTentativa')) || 0;
      const motivos: any = {
        pool_objectively_insufficient: 'nem com elas o desafio fecha (falta carta que atenda a uma exigência)',
        not_enough_players: 'nem com elas há jogadores suficientes para todos os slots',
        deadline: 'o tempo limite de montagem estourou antes de achar solução',
        no_valid_solution: 'nenhuma combinação válida foi encontrada',
        advanced_no_valid_solution: 'nenhuma combinação válida foi encontrada',
        advanced_pool_too_small: 'sobraram cartas de menos depois dos filtros obrigatórios',
        advanced_not_applicable: 'este tipo de desafio não é suportado pelo montador avançado',
        advanced_disabled: 'o montador avançado está desativado',
        chemistry_unsupported: 'a exigência de química deste desafio não é suportada',
        unsupported: 'este desafio tem uma exigência que o montador não sabe tratar'
      };
      const bruto = String(ler('motivoTecnicoSolver') || '').toLowerCase();
      let texto = 'Também tentei completar com cartas que você não tem';
      if (conceitos > 0) {
        texto += ' (' + conceitos.toLocaleString('pt-BR') + ' carta(s) do mercado';
        if (total > 0) texto += ', ' + total.toLocaleString('pt-BR') + ' no total';
        texto += ')';
      }
      texto += ' e ainda assim não fechou';
      if (bruto && motivos[bruto]) {
        texto += ': ' + motivos[bruto];
      } else if (bruto) {
        texto += ' (motivo técnico: ' + bruto + ')';
      }
      texto += '.';
      const requisito = String(ler('requisitoQueFaltou') || '').trim();
      if (requisito) texto += ' Requisito que faltou: ' + requisito;
      return texto;
    }

    private detalheFaltaAutoDme(diag: any): string {
      if (!diag) return '';
      const alvo = Number(diag.target);
      const disponivel = Number(diag.available);
      const razao = String(diag.objectiveReason || '').toLowerCase();
      const chave = String(diag.key || '').toUpperCase();
      const rotulos: any = {
        PLAYER_QUALITY: 'cartas dessa qualidade (bronze/prata/ouro)',
        PLAYER_LEVEL: 'cartas dessa qualidade (bronze/prata/ouro)',
        LEAGUE_ID: 'jogadores da liga exigida',
        NATION_ID: 'jogadores do país exigido',
        CLUB_ID: 'jogadores do clube exigido',
        PLAYER_RARITY: 'cartas da raridade exigida',
        PLAYER_RARITY_GROUP: 'cartas da raridade exigida',
        PLAYER_MIN_OVR: 'cartas com o overall exigido',
        PLAYER_MAX_OVR: 'cartas com o overall exigido',
        PLAYER_EXACT_OVR: 'cartas com o overall exigido'
      };
      if (razao === 'team_rating_impossible') {
        return isFinite(alvo) && alvo > 0
          ? `Suas cartas não alcançam a média de time exigida (${alvo}).`
          : 'Suas cartas não alcançam a média de time exigida.';
      }
      if (razao === 'not_enough_players') {
        const m = String(diag.diagnosticMessage || '').match(/possui\s+(\d+)\s+jogadores[^0-9]*?(\d+)\s+slots/i);
        if (m) return `Você tem ${m[1]} carta(s) que servem e o desafio precisa de ${m[2]}.`;
        return '';
      }
      if (isFinite(alvo) && isFinite(disponivel) && alvo > 0) {
        const rotulo = rotulos[chave] ? rotulos[chave] : 'cartas com o requisito exigido';
        return `O desafio pede ${alvo} ${rotulo} e você tem ${disponivel}.`;
      }
      return '';
    }

    /**
     * Traduz o motivo tecnico vindo da extensao para uma frase simples, com UMA dica direcionada.
     * O usuario da versao comum nao conhece "pool", "solver", "diagnosticCode" — entao aqui nao
     * entra jargao, e a dica aponta exatamente o ajuste que costuma destravar aquele caso.
     */
    private explicarMotivoAutoDme(fonte: any): { texto: string, dica: string } {
      const f = fonte ? fonte : {};
      const diag = f.diagnostic ? f.diagnostic : {};
      const codigo = String(f.diagnosticCode || diag.diagnosticCode || '').toUpperCase();
      const motivo = String(f.motivo || diag.motivo || '').toLowerCase();
      const razao = String(f.infeasibilityReason || '').toLowerCase();
      const tem = function (alvo: string): boolean {
        return codigo === alvo || motivo === alvo.toLowerCase() || razao === alvo.toLowerCase();
      };

      if (tem('AUTODME_POOL_OBJECTIVELY_INSUFFICIENT') || motivo === 'pool_objetivamente_insuficiente' || razao === 'pool_objectively_insufficient') {
        const detalhe = this.detalheFaltaAutoDme(diag);
        const limitantes = this.configuracoesLimitantesAutoDme(f, diag);
        return {
          texto: detalhe ? detalhe : 'Você não tem cartas suficientes que atendam às exigências deste desafio.',
          dica: limitantes
            ? ('As configurações que mais barraram cartas foram:<br/>' + limitantes + '<br/><small>Afrouxe uma delas e tente de novo.</small>')
            : 'Tente desligar “Não usar jogadores negociáveis”, “Não usar jogadores especiais” ou “Não usar jogadores do elenco ativo”, e alargue o rating mínimo/máximo.'
        };
      }
      if (tem('AUTODME_CONCEPT_SQUAD_NOT_SUBMITTABLE')) {
        return {
          texto: 'O desafio so fecha usando carta que voce ainda nao tem.',
          dica: 'Compre as cartas indicadas no aviso, ou ative "Comprar jogador automaticamente" para o sistema buscar no mercado.'
        };
      }
      if (tem('AUTODME_LOCAL_SOLVER_NO_SOLUTION_API_SKIPPED') || motivo === 'solver_local_sem_solucao' || razao === 'local_solver_no_solution' || codigo === 'SOLVER_NO_SOLUTION') {
        const limitantesSemSolucao = this.configuracoesLimitantesAutoDme(f, diag);
        return {
          texto: 'Suas cartas não fecham as exigências deste desafio.',
          dica: limitantesSemSolucao
            ? ('As configurações que mais barraram cartas foram:<br/>' + limitantesSemSolucao + '<br/><small>Afrouxe uma delas e tente de novo.</small>')
            : 'Libere alguns filtros (negociáveis, especiais, elenco ativo, ligas/países/times) ou aumente a faixa de rating.'
        };
      }
      if (tem('AUTODME_LOCAL_SOLVER_UNCERTAIN_FAILURE') || motivo === 'solver_local_falha_incerta') {
        return {
          texto: 'A montagem foi interrompida antes de terminar.',
          dica: 'Não é falta de cartas: mande resolver de novo.'
        };
      }
      if (tem('AUTODME_LOCAL_SOLVER_EXCEPTION') || motivo === 'solver_local_excecao') {
        return { texto: 'Ocorreu uma falha inesperada ao montar o time.', dica: 'Tente novamente em instantes.' };
      }
      if (tem('AUTODME_SOLUCAO_INCOMPLETA')) {
        return {
          texto: 'Algumas cartas não puderam ser colocadas no time.',
          dica: 'Costuma ser carta à venda no mercado, no elenco ativo ou emprestada. Retire-as e tente de novo.'
        };
      }
      if (tem('AUTODME_INVALID_LOCAL_SOLUTION') || motivo === 'save_challenge_failed' || tem('AUTODME_SAVE_CHALLENGE_FAILED')) {
        return {
          texto: 'O jogo recusou a escalação montada.',
          dica: 'Confira se as cartas usadas continuam disponíveis no clube e tente novamente.'
        };
      }
      if (tem('AUTODME_SOFTBAN_DME_REATIVO') || motivo === 'softban_envio_dme') {
        return {
          texto: 'O jogo limitou os envios de DME por agora.',
          dica: 'Aguarde alguns minutos antes de tentar de novo.'
        };
      }
      if (tem('AUTODME_LISTA_CHEIA')) {
        return {
          texto: 'Suas listas de transferência/observação estão cheias.',
          dica: 'Libere espaço nas listas e mande resolver novamente.'
        };
      }
      if (tem('AUTODME_NO_PROGRESS_LOOP') || tem('AUTODME_REPEATED_SOLUTION_LOOP')) {
        return {
          texto: 'O sistema repetiu a mesma montagem sem o jogo liberar o envio.',
          dica: 'Feche e abra o WebApp e tente novamente.'
        };
      }
      if (tem('AUTODME_SUBMIT_FAILED') || tem('AUTODME_SUBMIT_NOT_CONFIRMED') || motivo === 'submit_failed' || motivo === 'submit_not_confirmed') {
        return {
          texto: 'O envio do desafio não foi confirmado pelo jogo.',
          dica: 'Confira no WebApp se o desafio foi enviado antes de tentar de novo.'
        };
      }
      if (tem('AUTODME_CHALLENGE_SCREEN_UNAVAILABLE') || motivo === 'challenge_screen_unavailable') {
        return {
          texto: 'A tela do desafio não abriu a tempo no WebApp.',
          dica: 'Deixe o WebApp aberto e carregado e tente novamente.'
        };
      }
      if (motivo === 'card_dme_nao_encontrado_no_hub' || motivo === 'set_nao_encontrado_apos_recarregar') {
        return {
          texto: 'Não encontrei este DME na lista do jogo.',
          dica: 'Ele pode ter expirado ou já estar concluído. Atualize a lista de DMEs e confira.'
        };
      }
      if (motivo === 'sessao_ea_expirada' || codigo === 'SOLVER_API_UNAVAILABLE') {
        return {
          texto: 'A sessão do seu WebApp caiu.',
          dica: 'Recarregue o WebApp da EA, faça login e tente novamente.'
        };
      }
      return { texto: '', dica: '' };
    }

    private criarResumoDescritivo(resp: IResultadoSolucaoDME) {
      console.log("Criando resumo descritivo do DME", resp);
      const compras = (resp.jogadoresComprados !== undefined && resp.jogadoresComprados !== null)
        ? resp.jogadoresComprados
        : [];

      // 1) Total gasto no DME (somando todos desafios)
      const totalGasto = compras.reduce(function (acc, c) { return acc + (Number(c.preco) || 0); }, 0);

      // 2) Top 2 itens de recompensa por preço desc, desempate por rating desc
      var itensRecompensa = resp.itensRecompensa != null ? resp.itensRecompensa : [];
      var recompensasPlanas: ItemRecompensaBase[] = [];
      var lucroDescarteTotal: number = 0;
      var qtdItensRecompensa: number = 0;
      const nomeItemResumo = function (item: any): string {
        if (!item) return "";
        const nomeComposto = [item.firstName, item.lastName].filter(Boolean).join(" ");
        return item.name || item.knownAs || item.commonName || nomeComposto || (item._staticData && item._staticData.name) || (item.itemData && item.itemData.name) || "";
      };
      for (var i = 0; i < itensRecompensa.length; i++) {
        var bloco = itensRecompensa[i];
        lucroDescarteTotal += bloco.lucroDescarte ? bloco.lucroDescarte : 0;
        var items = bloco && bloco.items ? bloco.items : [];
        qtdItensRecompensa += items.length;
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          if (item.itemType != "player") continue; // só jogadores
          recompensasPlanas.push(item);
        }
      }
      const recompensasOrdenadas = recompensasPlanas
        .map(function (item) {
          let preco = (item && item.price != null) ? item.price : (item && item.preco != null ? item.preco : null);
          return {
            assetId: item && item.assetId,
            rating: Number(item && item.rating) || 0,
            preco: item.untradeable ? 0 : (preco != null ? preco : (item && item.futggprice ? item.futggprice.price : 0)),
            name: nomeItemResumo(item)
          };
        })
        .sort(function (a, b) {
          return (b.preco - a.preco) || (b.rating - a.rating);
        });

      const top2 = recompensasOrdenadas.slice(0, 2);

      // 3) Recompensas: soma preços quando disponível (price ou futggprice.price)
      var somaRecompensas = 0;
      var temAlgumPreco = false;
      var qtdRecompensas = qtdItensRecompensa;
      for (var i = 0; i < recompensasPlanas.length; i++) {
        var item: ItemRecompensaBase = recompensasPlanas[i];
        let preco = (item && item.price != null) ? item.price : (item && item.preco != null ? item.preco : null);
        var price = item.untradeable ? undefined : (preco != null ? preco : (item && item.futggprice ? item.futggprice.price : undefined));
        if (typeof price === 'number' && !isNaN(price)) {
          somaRecompensas += price;
          temAlgumPreco = true;
        }
      }

      somaRecompensas += lucroDescarteTotal;
      const temAlgumValorRecompensa = temAlgumPreco || lucroDescarteTotal > 0;
      const totalRecompensasEstimado = temAlgumValorRecompensa ? somaRecompensas - totalGasto : null;
      const jogadoresUsados = Array.isArray(resp.jogadoresUsados)
        ? resp.jogadoresUsados.filter(function (j: IJogadorUsado) {
          return j && (j.name || j.rating || j.assetId || j.definitionId || j.id);
        })
        : [];
      const jogadoresUsadosResumo = jogadoresUsados.slice(0, 8).map(function (j: IJogadorUsado) {
        const nome = j.name || j.knownAs || j.commonName || j.assetId || j.definitionId || j.id || "?";
        return `<b>${nome}${j.rating ? ` (${j.rating})` : ''}</b>`;
      }).join(", ");

      // 4) Objeto final “descritivo”
      const resumo = {
        id: resp.id,
        name: resp.name,
        completo: !!resp.completo,
        progresso:
          String((resp.desafiosConcluidos != null ? resp.desafiosConcluidos : 0)) +
          "/" +
          String((resp.totalDesafios != null ? resp.totalDesafios : 0)),
        totalGasto: totalGasto, // em coins
        recompensas: {
          quantidade: qtdRecompensas,
          packsAbertos: itensRecompensa.length,
          totalEstimado: totalRecompensasEstimado // null quando não há preço disponível
        },
        top2Recompensas: top2.map(function (r) {
          return {
            assetId: r.assetId,
            rating: r.rating,
            preco: r.preco,
            name: r.name
          };
        }),
        // string pronta pra log/alert
        descricao: (() => {
          const concluidos = `${resp.desafiosConcluidos != null ? resp.desafiosConcluidos : 0}/${resp.totalDesafios != null ? resp.totalDesafios : 0}`;
          const recompensaStr = totalRecompensasEstimado != null ? "<b>" + (this.formatCoins(totalRecompensasEstimado) + " coins</b>") : "";
          const packsAbertosStr = itensRecompensa.length > 0 ? '<b>&bull;</b> Packs abertos/processados: <b>' + itensRecompensa.length + '</b><br/>' : '';
          const cartasRecebidasStr = qtdRecompensas > 0 ? '<b>&bull;</b> Cartas recebidas em packs: <b>' + qtdRecompensas + '</b><br/>' : '';
          const descarteStr = lucroDescarteTotal > 0 ? '<b>&bull;</b> Lucro de descarte: <b>' + this.formatCoins(lucroDescarteTotal) + ' coins</b><br/>' : '';
          const usadasStr = jogadoresUsados.length > 0
            ? '<b>&bull;</b> Cartas usadas: <b>' + jogadoresUsados.length + '</b>' + (jogadoresUsadosResumo ? ' <small>' + jogadoresUsadosResumo + '</small>' : '') + '<br/>'
            : '';

          const topStrs = top2.map((item, idx) => {
            if (!item) return "—<br/>";
            var nomeJogador = null;

            const nome = nomeJogador ? nomeJogador : (item.name ? item.name : `#${item.assetId}`);
            return `<b>${nome} (${item.rating})</b>: <b>${this.formatCoins(item.preco)} coins</b>`;
          });

          // Garante sempre 2 linhas para o top2
          while (topStrs.length < 2) topStrs.push("");

          return (
            '<small><b>' + resp.name + '</b> &mdash; desafios: <b>' + concluidos + '</b>' +
            (totalGasto > 0 ? ' &middot; gasto: <b>' + this.formatCoins(totalGasto) + ' coins</b>' : '') + '</small><br/>' +
            usadasStr +
            packsAbertosStr +
            cartasRecebidasStr +
            descarteStr +
            (recompensaStr ? '<b>&bull;</b> Lucro previsto: ' + recompensaStr + '<br/>' : '') +
            (topStrs[0] ? '<b>&bull;</b> Melhor recompensa: ' + topStrs[0] + '<br/>' : '')
          );
        })()
      };

      return resumo;
    }

    public cancelarSolucao() {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "cancslcao" }, (resposta: any) => { });
      toastr.warning("O Auto DME será interrompido, Aguarde...", "Interrompendo!");
      setTimeout(() => {
        this.finalizaProcesso();
      }, 5000);
    }

    private scanearClube(): void {
      try {
        chrome.runtime.sendMessage(this.idExtensao, { evento: "scnnerclb" }, (_resultado: any) => { });
      } catch (e) {
        console.error('Falha ao enviar mensagem à extensão:', e);
      }
    }

    /**
     * Pede à extensão para acessar o menu de DME no WebApp (somente versão comum).
     * A extensão só age se o WebApp estiver aberto/carregado e sem execução/captcha em andamento;
     * ao abrir o menu, o intercept de /sbs/sets dispara 'atualizar_dmes' e a lista desta tela
     * chega atualizada sem o passo manual de clicar no menu de DME.
     */
    public abrirMenuDmeNoWebApp(): void {
      try {
        if (!this.idExtensao) return;
        chrome.runtime.sendMessage(this.idExtensao, { evento: "abrmenudme" }, (_resultado: any) => { });
      } catch (e) {
        console.error('Falha ao enviar mensagem à extensão:', e);
      }
    }

    private getLogJogadoresAberturaPacotes(playersPackPrices: IPlayerResumo[] = [], lucroDescarte: number = 0, pacote: any = null): any {
      try {
        console.log("playersPackPrices", playersPackPrices)
        const players = (Array.isArray(playersPackPrices) ? playersPackPrices : []).slice().sort((a, b) => (b.preco || 0) - (a.preco || 0));
        const lucroExterno = players.reduce((total, item) => {
          const preco = typeof item.preco === 'number' && !item.untradeable ? item.preco : 0;
          return total + preco;
        }, 0);
        const lucroPrevisto = lucroExterno + (Number(lucroDescarte) || 0);
        const topCartas = players.slice(0, 10).map(obj => {
          const nome = obj.name || (obj as any).knownAs || (obj as any).assetId || "?";
          const rating = obj.rating ? `(${obj.rating})` : "";
          const preco = obj.untradeable ? "inegociavel" : `${this.formatCoins(obj.preco || 0)} coins`;
          return `<b>${nome}${rating}</b> por <b>${preco}</b>`;
        }).join(", ");
        const qtdPacote = pacote && pacote.numberItems ? pacote.numberItems : players.length;
        const descarteStr = lucroDescarte ? `<br/><b>Lucro de descarte:</b> ${this.formatCoins(lucroDescarte)} coins` : "";
        const topStr = topCartas ? `<br/><b>Top cartas:</b> ${topCartas}` : "";

        return `Jogadores recebidos de pacote. <b>Cartas recebidas: ${qtdPacote}</b><br/><b>Lucro Previsto: ${this.formatCoins(lucroPrevisto)} coins</b>${descarteStr}${topStr}`;
      } catch (e) {
        console.log("erro log pacote", e)
        return ``;
      }
    }

    private finalizaProcesso() {
      App.SniperExtensao.ocultarLoadingSniperApp()
      this.resolvendo = false;
    }

    private exbibirLoadingTemporario(html: string, texto: string, tempo: number = 60000) {
      App.SniperExtensao.exibirLoadingSniperApp(html, false, texto);
      setTimeout(() => {
        App.SniperExtensao.ocultarLoadingSniperApp && App.SniperExtensao.ocultarLoadingSniperApp();
      }, tempo);
    }

    public processarMensagensAutoDme(request: { evento: string, dados: any }) {
      console.log("📫 MSG AUTO DME", request);
      switch (request.evento) {
        case 'auto_dme_solver_debug': {
          console.log("auto_dme_solver_debug", request.dados);
          break;
        }
        case 'atualizar_dmes': {
          const dmes = request.dados as IDmes;
          console.log("atualizar_dmes", dmes);
          this.categoriaDmes = dmes.categories || [];
          // salva último conjunto de DMEs carregados
          this.writeLastDmes(this.categoriaDmes);
          // repopula selects e restaura seleção se possível
          if (this.elSelectCategory.length) {
            this.populateCategorySelect();
          } else {
            this.populateDmeSelectAsListUnique();
          }
          this.refreshProModalsOnDmesUpdate();
          break;
        }
        case 'dme_nao_encontrado': {
          console.log("dme_nao_encontrado");
          this.exibirLog("danger", "Não encontrado", request.dados && request.dados.desafio ? `Desafio já foi resolvido ou não existe mais.` : "Dme já foi resolvido ou não existe mais.");
          this.finalizaProcesso();
          break;
        }
        case 'dme_executado': {
          const dadosDmeResposta = request.dados as IResultadoSolucaoDME;
          console.log("dme_executado", dadosDmeResposta.completo);
          const resumo = this.criarResumoDescritivo(dadosDmeResposta);
          // Mostra os nomes dos DMEs solucionados por conceito, se existirem
          const solucionadosDeConceito = Array.isArray(dadosDmeResposta.solucionadosDeConceito) ? dadosDmeResposta.solucionadosDeConceito : [];
          const solucionados = Array.isArray(dadosDmeResposta.solucionados) ? dadosDmeResposta.solucionados : [];
          const nomesDesafiosDeConceito = solucionadosDeConceito.map(d => d.name ? d.name : `Desafio ${d.challengeId}`).join('<br/><b>•</b> ');
          const nomesDesafiosSolucionados = solucionados.map(d => d.name ? d.name : `Desafio ${d.challengeId}`).join('<br/><b>•</b> ');
          const enviarAutomaticamente = !!(dadosDmeResposta as any).enviarAutomaticamente;
          if (dadosDmeResposta.completo) {
            let msgConclusao = `Seu DME foi resolvido${enviarAutomaticamente ? '' : ' <b>mas não foi enviado automaticamente</b>, para enviar automaticamente, ative a opção "Enviar automaticamente" na configuração do DME.'}.<br/> ${resumo.descricao}` +
              '<b>Desafios solucionados:</b><br/><b>•</b> ' + (nomesDesafiosSolucionados || '—');
            const qtdExec = dadosDmeResposta.quantidadeExecucoesDesafio;
            if (qtdExec != null && qtdExec > 1) {
              msgConclusao += `<br/><small>O desafio foi executado <b>${qtdExec} vezes</b> (repetição configurada).</small>`;
            }
            this.exibirLog(`${enviarAutomaticamente ? "success" : "info"}`, `${enviarAutomaticamente ? 'Pronto!' : 'Ok, <b>Não Enviado!</b>'}`, msgConclusao);
          } else {
            const temSolucoesConceito = solucionadosDeConceito.length > 0;
            if (temSolucoesConceito) {
              const msgConceito = 'O DME não foi concluído, mas foi usado jogadores de conceito para solucionar alguns desafios.<br/>' +
                '<b>Desafios solucionados de conceito:</b><br/><b>•</b> ' + (nomesDesafiosDeConceito || '—') + '<br/>' +
                '<b>Desafios solucionados:</b><br/><b>•</b> ' + (nomesDesafiosSolucionados || '—');
              this.exibirLog("info badge-conceito", "Incompleto!", msgConceito);
            } else if (dadosDmeResposta.desafiosIncluidosNoSet && dadosDmeResposta.desafiosIncluidosNoSet.included.length > 0 && solucionados.length > 0) {
              const msgDesafiosIncluidosNoSet = dadosDmeResposta.desafiosIncluidosNoSet.included.map(d => d.name ? d.name : `Desafio ${d.challengeId}`).join('<br/><b>•</b> ');
              this.exibirLog("info", "Dme incompleto!, Desafios Incluídos:", msgDesafiosIncluidosNoSet + '<br/><b>Desafios solucionados:</b><br/><b>•</b> ' + (nomesDesafiosSolucionados || '—'));
            } else {
              // Motivo especifico em vez da antiga parede de sugestoes genericas: pega o ultimo
              // erro com diagnostico (ou o proprio terminal) e traduz para linguagem do usuario.
              const errosTerminal: any[] = Array.isArray((dadosDmeResposta as any).errors) ? (dadosDmeResposta as any).errors : [];
              let fonteMotivo: any = dadosDmeResposta;
              for (let iErr = errosTerminal.length - 1; iErr >= 0; iErr--) {
                const e = errosTerminal[iErr];
                if (e && (e.diagnostic || e.infeasibilityReason)) { fonteMotivo = e; break; }
              }
              const explFim = this.explicarMotivoAutoDme(fonteMotivo);
              const motivoFim = explFim.texto ? `<b>Motivo:</b> ${explFim.texto}<br/>` : '';
              const dicaFim = explFim.dica ? `<b>O que fazer:</b> ${explFim.dica}<br/>` : 'Revise os filtros e a faixa de rating e tente novamente.<br/>';
              this.exibirLog("info badge-alerta-amarelo", "Não concluído", `O DME não foi concluído.<br/>${motivoFim}${dicaFim}${resumo.descricao}`);
            }
          }

          this.finalizaProcesso();
          break;
        }
        case 'coletando_jog_externo': {
          this.exibirLog("info", "Coletando!", "Coletando jogadores de soluções externas e preparando jogadores de conceitos.");
          break;
        }
        case 'preparado_jog_conceitos': {
          this.exibirLog("info", "Conceito!", "Preparado com jogadores de conceito.");
          break;
        }
        case 'pack': {
          this.exbibirLoadingTemporario('<i class="fas " style="font-size: 34px;" title="Verificando pacotes...">🎁</i>', "Verificando pacotes...");
          const dadosDmeResposta = request.dados as { status: boolean, acao: number, msg?: string, origem?: string, motivo?: string, playersPackPrices: IPlayerResumo[], lucroDescarte?: number, pacote?: any, opcoes?: any[], resgatados?: any[], quantidade?: number, items?: any[] };
          switch (dadosDmeResposta.acao) {
            case 0:
              this.exibirLog("info", "Abrindo Pacote Ineg.!", `Abrindo os pacotes de recompensa <b>inegociáveis</b>, aguarde...`);
              break;
            case 1:
              this.exibirLog("info", "Abrindo Pacote Neg.!", `Abrindo os pacotes de recompensa <b>negociáveis</b>, aguarde...`);
              break;
            case 2:
              this.exibirLog("info", "Analisando Pacote!", `Analisando pacote aberto...`);
              break;
            case 3:
              this.exibirLog("success", "Pacote Analisado!", `Itens do pacote foram processados com sucesso.`);
              break;
            case 4:
              this.finalizaProcesso();
              this.exibirLog(
                dadosDmeResposta.motivo === 'player_pick_selecao_desativada' ? "info badge-alerta-amarelo" : "danger",
                dadosDmeResposta.motivo === 'player_pick_selecao_desativada' ? "Player Pick Recebido!" : "Resgate Necessário!",
                dadosDmeResposta.msg || `É importante resgatar os itens de escolha manualmente.`
              );
              break;
            case 5:
              this.finalizaProcesso();
              this.exibirLog("success badge-pacote-aberto", "Pacote Aberto!", this.getLogJogadoresAberturaPacotes(dadosDmeResposta.playersPackPrices, dadosDmeResposta.lucroDescarte || 0, dadosDmeResposta.pacote));
              break;
            case 6:
              this.exibirLog("info", "Recompensa DME", dadosDmeResposta.msg || "Recompensa detectada. Abrindo pacote pendente antes de continuar.");
              break;
            case 7: {
              const qtdStorage = Number(dadosDmeResposta.quantidade || (Array.isArray(dadosDmeResposta.items) ? dadosDmeResposta.items.length : 0)) || 0;
              this.exibirLog("success", "Storage", dadosDmeResposta.msg || (qtdStorage > 0
                ? `Enviado(s) <b>${qtdStorage}</b> item(ns) duplicado(s) inegociavel(is) ao Storage.`
                : "Item duplicado inegociavel enviado ao Storage."));
              break;
            }
            case 8: {
              const qtdDescartados = Number(dadosDmeResposta.quantidade || (Array.isArray(dadosDmeResposta.items) ? dadosDmeResposta.items.length : 0)) || 0;
              this.exibirLog("info badge-alerta-amarelo", "Itens Descartados", dadosDmeResposta.msg || (qtdDescartados > 0
                ? `Descartado(s) <b>${qtdDescartados}</b> item(ns) que nao puderam ir para o Storage.`
                : "Itens restantes foram descartados depois da tentativa de Storage."));
              break;
            }
            case 9:
              this.exibirLog("info badge-alerta-amarelo", "Pacotes", dadosDmeResposta.msg || "A extensao esta tentando liberar itens pendentes antes de continuar.");
              break;
            case 10: {
              const resgatados = Array.isArray(dadosDmeResposta.resgatados) ? dadosDmeResposta.resgatados : [];
              const nomes = resgatados.map((item: any) => `<b>${item.name || item.resourceId || '?'}</b>${item.rating ? ` (${item.rating})` : ''}`).join(", ");
              this.exibirLog("success", "Player Pick", nomes ? `Player pick confirmado por rating: ${nomes}.` : "Player pick confirmado por rating.");
              break;
            }
            case 11:
              this.exibirLog(dadosDmeResposta.status ? "success" : "danger", "Nao Atribuidos", dadosDmeResposta.msg || (dadosDmeResposta.status ? "Itens nao atribuidos liberados." : "Nao foi possivel liberar itens nao atribuidos."));
              break;
            case 12:
              this.exibirLog(
                dadosDmeResposta.status ? "success" : "danger",
                "Player Pick",
                dadosDmeResposta.msg || (dadosDmeResposta.status
                  ? "Player Pick pendente processado antes do fechamento do Auto DME."
                  : "Player Pick pendente nao foi processado antes do fechamento do Auto DME.")
              );
              break;
          }
          break;
        }
        case 'auto_resolvedor': {
          App.SniperExtensao.exibirLoadingSniperApp('<i class="fas " style="font-size: 34px;" title="Resolvendo aguarde...">🕔</i>', false, "Resolvendo aguarde...");
          const dadosDmeResposta = request.dados as {
            status: boolean, acao: number, msg: string, validacaoSquad: IObjValidacaoSquad[], link: string, envio: boolean, statusCode: number, playersCount: number, nome: string, desafio: string, quantidadeJogadores: number, configPrecoMaxJogador: number,
            somaDoPrecoDeCompraTodosJogadores?: number, jogador: IItemListagem, quantidadeJogadoresComprados: number, quantidadePacksresgatados: number, quantidadePlayerPicksResgatados?: number,
            tentativa: number, montadoComJogadorDeConceito: boolean, jogadoresUsadosDesafio?: { assetId: number, definitionId: number, name: string, rareFlag: number, rating: number }[],
            fase?: string,
            motivo?: string,
            execucaoConcluida?: number,
            repeticaoTotal?: number,
            repeticaoAtual?: number,
            repeticoesRestantes?: number,
            intervaloMinutos?: number,
            quantidade_itens_lista_transferencia?: number,
            quantidade_itens_lista_observacao?: number,
            diagnosticCode?: string,
            diagnostic?: any,
            infeasibilityReason?: string
          };
          switch (dadosDmeResposta.acao) {
            case 0:
              this.exibirLog("info", "Iniciando", `Resolvendo <b>${dadosDmeResposta.nome}</b>, aguarde...`);
              break;
            case 1:
              this.exibirLog("info", "Montando time", `Procurando uma combinação entre <b>${dadosDmeResposta.quantidadeJogadores}</b> cartas suas.`);
              break;
            case 2:
              if (dadosDmeResposta.status) {
                const tent = typeof dadosDmeResposta.tentativa === 'number' && dadosDmeResposta.tentativa > 0 ? `<br/><small>Tentativa de solução: <b>${dadosDmeResposta.tentativa}</b></small>` : '';
                const det = dadosDmeResposta.msg ? `<br/><small>${dadosDmeResposta.msg}</small>` : '';
                if (dadosDmeResposta.montadoComJogadorDeConceito) {
                  this.exibirLog("conceito", "Possível Solução!", `Uma possível solução foi encontrada para o desafio <b>${dadosDmeResposta.nome}</b> usando jogadores de conceito.${det}${tent}`);
                } else {
                  this.exibirLog("success", "Possível Solução!", `Uma possível solução foi encontrada para o desafio <b>${dadosDmeResposta.nome}</b>.${det}${tent}`);
                }
              } else {
                const expl2 = this.explicarMotivoAutoDme(dadosDmeResposta);
                const txt2 = expl2.texto ? expl2.texto : 'Não consegui montar um time que atenda a este desafio.';
                const dica2 = expl2.dica ? `<br/><small>${expl2.dica}</small>` : '';
                this.exibirLog("info badge-alerta-amarelo", "Não deu para montar", `${txt2}${dica2}`);
              }
              break;
            case 3:
              this.exibirLog("info", "Requisito!", `Necessário comprar <b>${dadosDmeResposta.quantidadeJogadores} jogadores</b> para concluir o desafio.`);
              break;
            case 4:
              this.exbibirLoadingTemporario('<i class="fas " style="font-size: 34px;" title="Buscando e identificando os preços dos jogadores na EA...">🕔</i>', "Buscando e identificando os preços...");
              this.exibirLog("info", "Buscando!", `Buscando e identificando os preços dos jogadores na EA, aguarde...`);
              break;
            case 5:
              this.exibirLog("info", "Total Estimado!", `O preço estimado para comprar todos os jogadores é de <b>${dadosDmeResposta.somaDoPrecoDeCompraTodosJogadores} coins</b>.`);
              break;
            case 6:
              this.exibirLog("info badge-alerta-amarelo", "Compra Inviável!", `O Sistema só irá comprar quando tiver certeza<b>(Configuração:Comprar só c/ certeza)</b> que a solução será concluída, ou seja, todos os jogadores tem que estar no <b>orcamento(Configurado)</b> e disponíveis no mercado.`);
              break;
            case 7:
              this.exibirLog("info badge-alerta-amarelo", "Compra Inviável!", `O Sistema  irá comprar os jogadores, mesmo não tendo certeza que a solução será concluída <b>(Configuração:Comprar só c/ certeza DESATIVADA)</b>.`);
              break;
            case 8:
              this.exibirLog("info", "Comprando!", `O Sistema iniciou as compras dos jogadores, aguarde...`);
              break;
            case 9:
              this.exibirLog("info badge-alerta-amarelo", "Comprou!", `Comprou jogador <b>${dadosDmeResposta.jogador.name}(${dadosDmeResposta.jogador.rating})</b> por <b>${dadosDmeResposta.jogador.buyNowPrice} coins</b>.`);
              break;
            case 10:
              this.exibirLog("info", "Compras Finalizadas!", `Foram comprados <b>${dadosDmeResposta.quantidadeJogadoresComprados} jogadores</b> para o desafio <b>${dadosDmeResposta.nome}</b>.`);
              break;
            case 11:
              if (dadosDmeResposta && dadosDmeResposta.status) {
                this.exibirLog("success", "Desafio Enviado!", `O desafio <b>${dadosDmeResposta.nome}</b> foi enviado com sucesso!`);
              } else {
                var codeErro = 0;
                if (dadosDmeResposta && typeof dadosDmeResposta.statusCode !== "undefined") {
                  codeErro = dadosDmeResposta.statusCode;
                }
                var foiTentativaDeEnvio = false;
                if (dadosDmeResposta && typeof dadosDmeResposta.envio !== "undefined") {
                  foiTentativaDeEnvio = !!dadosDmeResposta.envio;
                }

                // Personalize mensagem para erros específicos
                if (codeErro === 475) {
                  var msgBase =
                    "A solução encontrada parece conter jogadores bloqueados ou que não estão mais no seu clube. O sistema tentará uma nova alternativa para resolver o desafio. Por favor, tente novamente.<br/><small>Código do erro: <b>${codeErro}</b>.</small>";
                  if (foiTentativaDeEnvio) {
                    this.exibirLog("danger badge-amarelo-second", "Desafio Não Enviado!", msgBase);
                  } else {
                    this.exibirLog("danger badge-amarelo-second", "Desafio Não Salvo!", msgBase);
                  }
                  break;
                }

                // Mensagem padrão para outros erros
                var msgPadrao;
                if (foiTentativaDeEnvio) {
                  msgPadrao = `Não foi possível enviar o desafio. Código do erro: <b>${codeErro}</b>.`;
                } else {
                  msgPadrao = `Não foi possível salvar o desafio. Código do erro: <b>${codeErro}</b>. Por favor, tente novamente ou ajuste as configurações se o erro persistir.`;
                }

                this.exibirLog("danger badge-amarelo-second", foiTentativaDeEnvio ? "Desafio Não Enviado!" : "Desafio Não Salvo!", msgPadrao);
              }
              break;
            case 12: {
              let msgPacks = `Foram resgatados <b>${dadosDmeResposta.quantidadePacksresgatados} packs</b> do desafio <b>${dadosDmeResposta.nome}</b>.`;
              if (dadosDmeResposta.quantidadePlayerPicksResgatados && dadosDmeResposta.quantidadePlayerPicksResgatados > 0) {
                msgPacks += `<br/><small>Tambem recebeu <b>${dadosDmeResposta.quantidadePlayerPicksResgatados}</b> Player Pick(s). A escolha automatica esta desativada; selecione manualmente no WebApp.</small>`;
              }
              const jogadoresUsados = dadosDmeResposta.jogadoresUsadosDesafio;
              if (jogadoresUsados && jogadoresUsados.length > 0) {
                const listaJogadores = jogadoresUsados.map(j => `<b>${j.name || '?'} (${j.rating})</b>`).join(", ");
                msgPacks += `<br/><small>Jogadores usados na troca: ${listaJogadores}</small>`;
              }
              this.exibirLog("success", "Packs Resgatados!", msgPacks);
              break;
            }
            case 13:
              this.exibirLog("info badge-alerta-amarelo", "Jogador caro!", `O Jogador <b>${dadosDmeResposta.jogador.name}(${dadosDmeResposta.jogador.rating})</b>
                está com preço de <b>${dadosDmeResposta.jogador.buyNowPrice} coins</b> acima do valor máximo configurado de <b>${dadosDmeResposta.configPrecoMaxJogador} coins</b>
                para compra, portanto não será comprado e foi adicionado a lista de ignorados para um nova tentativa de solução.`);
              break;
            case 14:
              this.exibirLog("danger", "Sem Mercado!", `Não é possível comprar jogadores para o DME, pois o mercado está inacessível para essa conta.`);
              break;
            case 15:
              this.exibirLog("info badge-alerta-amarelo", "Sem Saldo!", `Não é possível comprar jogadores para o DME, pois a conta não possui coins suficientes.`);
              break;
            case 16:
              if (dadosDmeResposta.hasOwnProperty('playersCount') && dadosDmeResposta.playersCount <= 0) {
                this.exibirLog("danger", "Sem cartas suficientes", `Nenhuma carta sua atende às exigências deste DME.<br/><small>Libere filtros (negociáveis, especiais, elenco ativo) ou alargue o rating.</small>`);
                break;
              }

              if (dadosDmeResposta.hasOwnProperty('msg') && dadosDmeResposta.hasOwnProperty('statusCode') && ([401, 403, 500] as any).includes(dadosDmeResposta.statusCode) && (dadosDmeResposta.msg == "compra" || dadosDmeResposta.msg == "busca")) {
                this.exibirLog("danger", "Falha de Autenticacao!", `Verifique se sua conta não está sendo logada em outro dispositivo/navegador/aba, isso pode impedir o auto Dme de funcionar corretamente.`);
                break;
              }

              if (dadosDmeResposta.hasOwnProperty('msg') && dadosDmeResposta.hasOwnProperty('statusCode') && !(([461, 475] as any).includes(dadosDmeResposta.statusCode) && (dadosDmeResposta.msg == "compra" || dadosDmeResposta.msg == "busca"))) {
                const expl16 = this.explicarMotivoAutoDme(dadosDmeResposta);
                if (expl16.texto) {
                  this.exibirLog("danger", "Auto DME parado", `${expl16.texto}${expl16.dica ? `<br/><small>${expl16.dica}</small>` : ''}`);
                } else {
                  this.exibirLog("danger", "Auto DME parado", `Ocorreu um erro inesperado.<br/><small>Se continuar, avise o suporte: contato@futsniperweb.com.br</small>`);
                }
              }
              break;
            case 17:
              this.finalizaProcesso();
              this.exibirLog("danger", "Interrompido!", `O Auto Dme foi interrompido.`);
              break;
            case 18:
              this.marcarConceitoExtinto(dadosDmeResposta);
              this.exibirLog("info badge-alerta-amarelo", "Jogador Extinto!", `Não foi possível encontrar o jogador <b>${dadosDmeResposta.jogador.name}(${dadosDmeResposta.jogador.rating})</b>.`);
              break;
            case 19: {
              const tent19 = typeof dadosDmeResposta.tentativa === 'number' && dadosDmeResposta.tentativa > 0 ? `<br/><small>Tentativa de solução: <b>${dadosDmeResposta.tentativa}</b></small>` : '';
              this.exibirLog("primary", "Solução Rápida!", `A Solução rápida será usada para o DME <b>${dadosDmeResposta.nome}</b>, essa solução tem como modelo a busca de soluções externa online sem se preocupar com jogadores atualmente no seu clube.${tent19}`);
              break;
            }
            case 20:
              let linkUsado = dadosDmeResposta.link ? `<br/>Link usado: <a href="${dadosDmeResposta.link}" target="_blank">${dadosDmeResposta.link}</a>` : "";
              this.exibirLog("primary", "Analisando Solução Externa!", ` Analisando solução externa <b>№${dadosDmeResposta.tentativa}</b> online encontrada para o DME <b>${dadosDmeResposta.nome}</b>.${linkUsado} `);
              break;
            case 21: {
              const tent21 = typeof dadosDmeResposta.tentativa === 'number' && dadosDmeResposta.tentativa > 0 ? `<br/><small>Tentativa de solução: <b>${dadosDmeResposta.tentativa}</b></small>` : '';
              this.exibirLog("success", "Solucionado!", `O Desafio <b>${dadosDmeResposta.nome}</b> foi solucionado.${tent21}`);
              break;
            }
            case 22:
              this.exibirLog("info badge-alerta-amarelo", "Desafio Incompatível!", `O Desafio <b>${dadosDmeResposta.desafio}</b> é um desafio que a inteligência do sistema interno ainda não consegue solucionar, mas é possível que se resolva usando a opção:<b>"solução rápida"</b>.`);
              break;
            case 23:
              this.exibirLog("info badge-alerta-amarelo", "Rating Ajustado!", `O sistema precisou de jogadores com exigência de rating diferente da configuração atual, portanto, <b>foi necessário um ajuste no Min/Max Rating</b>.`);
              break;
            case 24:
              this.exibirLog("info badge-alerta-amarelo", "Compra Incompleta!", `O sistema não conseguiu comprar todos os jogadores para o desafio <b>${dadosDmeResposta.desafio}</b>. A solução encontrada foi salva, mas alguns jogadores ainda precisam ser adquiridos manualmente. Verifique quais estão faltando e realize a compra manualmente para completar o DME.`
              );
              break;
            case 25: {
              const expl25 = this.explicarMotivoAutoDme(dadosDmeResposta);
              const dica25 = expl25.dica ? `<br/><small>${expl25.dica}</small>` : '';
              this.exibirLog("info badge-alerta-amarelo", "Desafio não resolvido", `<b>${dadosDmeResposta.desafio}</b> ficou sem solução.${expl25.texto ? `<br/>${expl25.texto}` : ''}${dica25}`);
              break;
            }
            case 26:
              this.exibirLog("info badge-alerta-amarelo", "Sobra de Jogadores!", `Jogadores comprados mas não usados no dme, serão enviados para a lista de transferência.`
              );
              break;
            case 27:
              this.exibirLog("info", "Desafio retomado!", `O desafio <b>${dadosDmeResposta.desafio}</b> pronto mas não enviado foi retomado, não foi necessário buscar nova solução.`);
              break;
            case 28: {
              const validacoes = Array.isArray(dadosDmeResposta.validacaoSquad) ? dadosDmeResposta.validacaoSquad.filter(v => !v.concept) : [];
              const nomeDesafio = dadosDmeResposta.nome ? dadosDmeResposta.nome : 'desconhecido';

              let logTxt = `<b>Desafio:</b> ${nomeDesafio}<br/>`;

              if (validacoes.length === 0) {
                // Conceitos sao tratados pelo aviso "Montado, falta comprar"; nao duplicar o log.
                break;
              }
              const motivosTecnicos = ['id_invalido', 'ea_isValid_false', 'definitionId_invalido'];
              const tecnicas = validacoes.filter((validacao: any) => {
                const motivos = String(validacao.motivo || '').split(',').map(m => m.trim()).filter(Boolean);
                return motivos.length > 0 && motivos.every(m => motivosTecnicos.indexOf(m) >= 0);
              });
              if (tecnicas.length > 0) {
                logTxt += `<br/>${tecnicas.length} jogador(es) foram ignorados porque a EA retornou dados incompletos para essas cartas.`;
              }

              const mensagens: { [mensagem: string]: number } = {};
              validacoes.filter((validacao: any) => tecnicas.indexOf(validacao) < 0).forEach((validacao: any) => {
                if (validacao.mensagem) mensagens[validacao.mensagem] = (mensagens[validacao.mensagem] || 0) + 1;
              });
              const mensagensUnicas = Object.keys(mensagens);
              mensagensUnicas.slice(0, 3).forEach(mensagem => {
                const quantidade = mensagens[mensagem];
                logTxt += `<br/>${mensagem}${quantidade > 1 ? ` (${quantidade} ocorrências)` : ''}`;
              });
              if (mensagensUnicas.length > 3) {
                logTxt += `<br/>E mais ${mensagensUnicas.length - 3} motivo(s) de validação.`;
              }

              this.exibirLog(
                "info badge-alerta-amarelo",
                "Validação de Squad!",
                logTxt
              );
              break;
            }
            case 29: {
              const nome29 = dadosDmeResposta.nome || 'DME';
              const total29 = dadosDmeResposta.repeticaoTotal;
              if (dadosDmeResposta.fase === 'intervalo') {
                const concl = dadosDmeResposta.execucaoConcluida;
                const rest = dadosDmeResposta.repeticoesRestantes;
                const min = typeof dadosDmeResposta.intervaloMinutos !== 'undefined' && dadosDmeResposta.intervaloMinutos !== null ? dadosDmeResposta.intervaloMinutos : 0;
                let msg = `Execucao <b>${concl}</b> de <b>${total29}</b> do DME <b>${nome29}</b> concluida.`;
                if (typeof rest === 'number' && rest > 0) {
                  msg += ` Faltam <b>${rest}</b> repeticao(oes).`;
                }
                msg += `<br/><small>Aguardando <b>${min}</b> min antes da proxima rodada.</small>`;
                this.exibirLog("primary", "Repeticao DME", msg);
              } else if (dadosDmeResposta.fase === 'reiniciando') {
                this.exibirLog("primary", "Repeticao DME", `Iniciando execucao <b>${dadosDmeResposta.repeticaoAtual}</b> de <b>${total29}</b> do DME <b>${nome29}</b>.`);
              } else if (dadosDmeResposta.fase === 'atualizando_pool') {
                const concl = dadosDmeResposta.execucaoConcluida;
                const rest = dadosDmeResposta.repeticoesRestantes;
                let msg = `Execucao <b>${concl}</b> de <b>${total29}</b> do DME <b>${nome29}</b> concluida.`;
                if (typeof rest === 'number' && rest > 0) {
                  msg += ` Faltam <b>${rest}</b> repeticao(oes).`;
                }
                msg += `<br/><small>Pack processado e novos itens adicionados ao clube; atualizando cache antes da proxima rodada.</small>`;
                this.exibirLog("primary", "Atualizando Pool", msg);
              } else if (dadosDmeResposta.fase === 'recalculando_fila') {
                const concl = dadosDmeResposta.execucaoConcluida;
                const rest = dadosDmeResposta.repeticoesRestantes;
                let msg = `Execucao <b>${concl}</b> de <b>${total29}</b> do DME <b>${nome29}</b> concluida.`;
                if (typeof rest === 'number' && rest > 0) {
                  msg += ` Faltam <b>${rest}</b> repeticao(oes).`;
                }
                msg += `<br/><small>O clube recebeu novos itens; o Auto DME vai recalcular a fila por prioridade.</small>`;
                this.exibirLog("primary", "Repeticao DME", msg);
              } else if (dadosDmeResposta.fase === 'recompensa_ignorada_configuracao') {
                this.exibirLog("info badge-alerta-amarelo", "Recompensa Ignorada", `A recompensa de pack do DME <b>${nome29}</b> nao foi aberta porque a configuracao atual nao permite esse tipo de pack.`);
              } else if (dadosDmeResposta.fase === 'recompensa_adiada_nao_renderizou') {
                this.exibirLog("info", "Recompensa", `O pacote do DME <b>${nome29}</b> ainda esta sendo liberado pela EA. Vamos abri-lo na proxima verificacao — nao precisa fazer nada.`);
              } else if (dadosDmeResposta.fase === 'recompensa_ignorada_ausente') {
                this.exibirLog("info", "Recompensa", `O pacote do DME <b>${nome29}</b> nao apareceu em "Meus Pacotes". Seguindo em frente; abra-o pelo WebApp quando ele aparecer.`);
              } else if (dadosDmeResposta.fase === 'recompensa_pendente_falha') {
                this.finalizaProcesso();
                if ((dadosDmeResposta as any).motivo === 'player_pick_selecao_desativada') {
                  this.exibirLog("info badge-alerta-amarelo", "Player Pick Pendente", `O DME <b>${nome29}</b> recebeu um Player Pick. A escolha automatica esta desativada; selecione manualmente no WebApp para continuar.`);
                } else {
                  this.exibirLog("danger", "Recompensa Pendente", `Ha um pacote do DME <b>${nome29}</b> esperando ser aberto e nao foi possivel abri-lo.<br/><b>O que fazer:</b> abra o pacote em "Meus Pacotes" no WebApp e mande resolver de novo.`);
                }
              } else {
                this.exibirLog("info", "Repeticao DME", `Progresso de repeticoes do DME <b>${nome29}</b>.`);
              }
              break;
            }
            case 30: {
              const etapa = (dadosDmeResposta as any).etapa || "etapa_nao_informada";
              const desafio = (dadosDmeResposta as any).desafio || dadosDmeResposta.nome || "Desafio";
              const mensagem = (dadosDmeResposta as any).message || dadosDmeResposta.msg || "Erro sem mensagem";
              console.error("AUTODME_ERRO_TECNICO_EXTENSAO", dadosDmeResposta);
              this.exibirLog("danger", "Erro tecnico", `Erro tecnico no Auto DME em <b>${etapa}</b> no desafio <b>${desafio}</b>.<br/><small>${mensagem}</small>`);
              break;
            }
            case 31:
              this.exibirLog("info", "Pacotes Processados", "Pacotes processados antes do DME inicial. Escaneando clube antes de resolver.");
              break;
            case 32:
              this.exibirLog("primary", "Fallback Externo", `Fallback externo ativado para <b>${dadosDmeResposta.nome || 'DME'}</b>.<br/><small>${dadosDmeResposta.msg || 'Solver interno sem solucao; tentando solucao externa por configuracao.'}</small>`);
              break;
            case 34:
              this.finalizaProcesso();
              this.exibirLog("danger", "Loop de Solucao", `<b>Auto DME pausado por loop de solucao.</b><br/>DME/desafio: <b>${dadosDmeResposta.nome || dadosDmeResposta.desafio || 'DME'}</b>.<br/><small>${dadosDmeResposta.msg || 'Mesma solucao repetida sem liberar envio no WebApp.'}</small>`);
              break;
            case 35: {
              this.finalizaProcesso();
              var qtdTransfLista = dadosDmeResposta.quantidade_itens_lista_transferencia;
              var qtdObsLista = dadosDmeResposta.quantidade_itens_lista_observacao;
              var detalheListas = (qtdTransfLista !== undefined || qtdObsLista !== undefined)
                ? `<br/><small>Transferencia: ${qtdTransfLista !== undefined ? qtdTransfLista : '-'} | Observacao: ${qtdObsLista !== undefined ? qtdObsLista : '-'}</small>`
                : '';
              this.exibirLog("danger", "Listas Cheias", `<b>Auto DME interrompido: listas de transferencia/observacao cheias.</b>${detalheListas}<br/><small>${dadosDmeResposta.msg || 'Libere espaco nas listas e tente novamente.'}</small>`);
              break;
            }
            case 36: {
              // Elenco montado usando carta que o usuario nao possui. A EA nao permite enviar
              // assim: o desafio fica montado na tela e aqui dizemos QUAIS cartas faltam.
              var cartasFaltando: any[] = Array.isArray((dadosDmeResposta as any).jogadores) ? (dadosDmeResposta as any).jogadores : [];
              var listaCartas = cartasFaltando
                .map(function (c: any) {
                  var nome = c && c.name ? c.name : 'Carta ' + (c && c.definitionId ? c.definitionId : '?');
                  var ovr = c && c.rating ? ' <small>(' + c.rating + ')</small>' : '';
                  var pos = c && c.preferredPositionName ? ' <small>' + c.preferredPositionName + '</small>' : '';
                  var preco = c && c.precoEstimado ? ' <small>~' + Number(c.precoEstimado).toLocaleString('pt-BR') + ' moedas</small>' : '';
                  return '<b>•</b> ' + nome + ovr + pos + preco;
                })
                .join('<br/>');
              var vaiComprar = (dadosDmeResposta as any).comprarAutomatico === true;
              var msg36 = 'Consegui montar <b>' + (dadosDmeResposta.desafio || dadosDmeResposta.nome || 'o desafio') + '</b>, mas usando carta que voce ainda nao tem — a EA nao deixa enviar assim.<br/>'
                + '<b>Faltam:</b><br/>' + (listaCartas || '<b>•</b> —') + '<br/>'
                + (vaiComprar
                  ? '<small>Vou procurar essas cartas no mercado e comprar.</small>'
                  : '<small>O desafio ficou montado na tela. Compre as cartas acima (ou ative "Comprar jogador automaticamente") e mande resolver de novo.</small>');
              this.exibirLog("info badge-conceito", "Montado, falta comprar", msg36);
              break;
            }
          }
          break;
        }
        case 'teste': {
          break;
        }
      }
    }
  }
}
